
// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate, useLocation } from 'react-router-dom';
// // // import { useFormik } from 'formik';
// // // import * as Yup from 'yup';
// // // import {
// // //   Container,
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   TextField,
// // //   Select,
// // //   MenuItem,
// // //   FormControl,
// // //   InputLabel,
// // //   FormControlLabel,
// // //   Switch,
// // //   Radio,
// // //   RadioGroup,
// // //   IconButton,
// // //   Alert,
// // //   CircularProgress,
// // //   Paper,
// // //   Grid,
// // //   Divider,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Autocomplete,
// // //   Breadcrumbs,
// // //   Link as MuiLink,
// // //   Chip,
// // //   InputAdornment,
// // //   FormHelperText,
// // //   Avatar,
// // // } from '@mui/material';
// // // import {
// // //   Add as AddIcon,
// // //   Delete as DeleteIcon,
// // //   ArrowForward,
// // //   ArrowBack as ArrowBackIcon,
// // //   CheckCircle,
// // //   Language as LanguageIcon,
// // //   ExpandMore,
// // //   ExpandLess,
// // //   CloudUpload,
// // //   InfoOutlined,
// // //   EditOutlined,
// // //   AccessTime as AccessTimeIcon,
// // //   Lock as LockIcon,
// // //   Public as PublicIcon,
// // //   VerifiedUser as VerifiedUserIcon,
// // //   PersonOutline as PersonOutlineIcon,
// // // } from '@mui/icons-material';
// // // import { adminService as realAdminService } from '../services/admin';
// // // import { useAuth } from '../context/AuthContext';
// // // import { ROUTES } from '../utils/constants';

// // // /* ----------------------------------------------------------------------
// // //    MOCK FLAG – set to true to skip real API calls
// // // ---------------------------------------------------------------------- */
// // // const USE_MOCK = true; // ← change to false when backend is ready

// // // /* ----------------------------------------------------------------------
// // //    Design tokens
// // // ---------------------------------------------------------------------- */
// // // const C = {
// // //   border: '#e2e8f0',
// // //   blue: '#3182ce',
// // //   blueDark: '#2b6cb0',
// // //   green: '#38a169',
// // //   greenDark: '#276749',
// // //   indigo: '#4c51bf',
// // //   amber: '#dd6b20',
// // //   amberBg: '#feebc8',
// // //   amberText: '#9c4221',
// // //   textPrimary: '#1a202c',
// // //   textSecondary: '#718096',
// // //   bgLight: '#f7fafc',
// // //   badgeActiveBg: '#c6f6d5',
// // //   badgeActiveText: '#276749',
// // //   badgeInactiveBg: '#e2e8f0',
// // //   badgeInactiveText: '#4a5568',
// // //   infoBg: '#ebf8ff',
// // //   infoBorder: '#bee3f8',
// // //   infoText: '#2c5282',
// // // };

// // // /* ----------------------------------------------------------------------
// // //    Validation schemas
// // // ---------------------------------------------------------------------- */
// // // const detailsSchema = Yup.object({
// // //   businessId: Yup.string().required('Business is required'),
// // //   applicationType: Yup.string()
// // //     .oneOf(['WEB', 'MOBILE'])
// // //     .required('Application type is required'),
// // //   businessName: Yup.string().required('Display name is required').max(100),
// // //   description: Yup.string().max(500),
// // //   isActive: Yup.boolean(),
// // //   appLogoUrl: Yup.string().url('Invalid URL').nullable(),
// // // });

// // // const settingsSchema = Yup.object({
// // //   blockDuration: Yup.number()
// // //     .min(1, 'Min 1 minute')
// // //     .max(1440, 'Max 1440 minutes')
// // //     .required('Required'),
// // //   failedAttempts: Yup.number()
// // //     .min(1, 'Min 1')
// // //     .max(99, 'Max 99')
// // //     .required('Required'),
// // //   ipGeolocationEnabled: Yup.boolean(),
// // //   webhookUrl: Yup.string().url('Invalid URL').nullable(),
// // //   metadataJson: Yup.string().test(
// // //     'is-json',
// // //     'Metadata must be valid JSON',
// // //     (val) => {
// // //       if (!val || !val.trim()) return true;
// // //       try {
// // //         JSON.parse(val);
// // //         return true;
// // //       } catch {
// // //         return false;
// // //       }
// // //     }
// // //   ),
// // // });

// // // /* Step definitions. The "domains" step is filtered out entirely for
// // //    MOBILE applications. */
// // // const ALL_STEPS = [
// // //   { key: 'details', label: 'Application Details', subtitle: 'Basic information' },
// // //   { key: 'domains', label: 'Domains & URLs', subtitle: 'Configure domains and URLs' },
// // //   { key: 'settings', label: 'Security & Settings', subtitle: 'Security and access control' },
// // //   { key: 'review', label: 'Review & Create', subtitle: 'Review and create application' },
// // // ];

// // // const BLOCK_DURATION_OPTIONS = [5, 15, 30, 60, 120, 240, 1440];
// // // const FAILED_ATTEMPTS_OPTIONS = [3, 5, 10, 15, 20, 25];

// // // const emptyDomain = () => ({
// // //   id: null,
// // //   domain: '',
// // //   displayName: '',
// // //   redirectUrl: 'https://',
// // //   status: true,
// // //   saved: false,
// // //   logoUrl: '', // only URL, no radio selection
// // //   _tempId: Date.now() + Math.random(),
// // // });

// // // const getProtocol = (url = '') => (url.startsWith('http://') ? 'http' : 'https');
// // // const getPath = (url = '') => url.replace(/^https?:\/\//, '');

// // // /* ----------------------------------------------------------------------
// // //    Mock adminService
// // // ---------------------------------------------------------------------- */
// // // const mockAdminService = {
// // //   getAllBusinesses: () =>
// // //     Promise.resolve({
// // //       businesses: [
// // //         { _id: 'biz1', businessName: 'Acme Corp', status: true, isActive: true },
// // //         { _id: 'biz2', businessName: 'Beta Inc', status: true, isActive: false },
// // //         { _id: 'biz3', businessName: 'Gamma LLC', status: false, isActive: true },
// // //       ],
// // //     }),
// // //   createBusinessApp: (payload) =>
// // //     Promise.resolve({ data: { _id: 'mock-app-' + Date.now() } }),
// // //   updateAppSettings: () => Promise.resolve({}),
// // //   addAppDomain: (appId, payload) =>
// // //     Promise.resolve({ data: { _id: 'mock-domain-' + Date.now() } }),
// // //   updateAppDomain: () => Promise.resolve({}),
// // //   deleteAppDomain: () => Promise.resolve({}),
// // //   toggleAppDomainStatus: () => Promise.resolve({}),
// // // };

// // // const adminService = USE_MOCK ? mockAdminService : realAdminService;

// // // /* ----------------------------------------------------------------------
// // //    Inline Field Helper – label on left, control on right
// // // ---------------------------------------------------------------------- */
// // // const InlineField = ({ label, children, ...boxProps }) => (
// // //   <Box
// // //     sx={{
// // //       display: 'flex',
// // //       alignItems: 'flex-start',
// // //       gap: 2,
// // //       mb: 2.5,
// // //       ...boxProps.sx,
// // //     }}
// // //     {...boxProps}
// // //   >
// // //     <Typography
// // //       variant="body2"
// // //       fontWeight={600}
// // //       sx={{ minWidth: 140, flexShrink: 0, pt: 0.5 }}
// // //     >
// // //       {label}
// // //     </Typography>
// // //     <Box sx={{ flex: 1 }}>{children}</Box>
// // //   </Box>
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Main Component
// // // ---------------------------------------------------------------------- */
// // // const CreateApplicationPage = () => {
// // //   const navigate = useNavigate();
// // //   const location = useLocation();
// // //   const { isAdmin, businessId: userBusinessId, user, email: authEmail } = useAuth();

// // //   // Resolve the signed-in admin's email defensively, since the exact shape
// // //   // of the auth context can vary (user.email, top-level email, username, etc).
// // //   const createdByEmail =
// // //     user?.email || authEmail || user?.username || user?.name || 'Unknown user';

// // //   const [activeStep, setActiveStep] = useState(0);
// // //   const [loading, setLoading] = useState(false);
// // //   const [businesses, setBusinesses] = useState([]);
// // //   const [fetchingBusinesses, setFetchingBusinesses] = useState(false);
// // //   const [submitError, setSubmitError] = useState('');
// // //   const [appId, setAppId] = useState(null);
// // //   const [savingDomain, setSavingDomain] = useState(false);
// // //   const [savingSettings, setSavingSettings] = useState(false);
// // //   const [expandedDomains, setExpandedDomains] = useState({ 0: true });

// // //   const preselectedBusinessId = new URLSearchParams(location.search).get('businessId');

// // //   const formik = useFormik({
// // //     initialValues: {
// // //       businessId: preselectedBusinessId || (isAdmin ? '' : userBusinessId || ''),
// // //       applicationType: 'WEB', // default to WEB
// // //       description: '',
// // //       businessName: '',
// // //       isActive: true,
// // //       domains: [emptyDomain()],
// // //       blockDuration: 30,
// // //       failedAttempts: 5,
// // //       ipGeolocationEnabled: false,
// // //       webhookUrl: '',
// // //       metadataJson: '{\n  \n}',
// // //       appLogoUrl: '',
// // //     },
// // //     validateOnChange: true,
// // //   });

// // //   const { values, handleChange, setFieldValue, errors, touched } = formik;

// // //   // Fetch businesses if admin
// // //   useEffect(() => {
// // //     if (isAdmin) {
// // //       setFetchingBusinesses(true);
// // //       adminService
// // //         .getAllBusinesses(0, 100)
// // //         .then((data) => {
// // //           let list = [];
// // //           if (Array.isArray(data)) list = data;
// // //           else if (data.businesses && Array.isArray(data.businesses)) list = data.businesses;
// // //           else if (data.data && Array.isArray(data.data)) list = data.data;
// // //           setBusinesses(list);
// // //         })
// // //         .catch(() => {})
// // //         .finally(() => setFetchingBusinesses(false));
// // //     }
// // //   }, [isAdmin]);

// // //   useEffect(() => {
// // //     if (!isAdmin && userBusinessId) {
// // //       setFieldValue('businessId', userBusinessId);
// // //     }
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, [isAdmin, userBusinessId]);

// // //   const showDomains = values.applicationType === 'WEB';

// // //   const visibleSteps = ALL_STEPS.filter((s) => s.key !== 'domains' || showDomains);
// // //   const currentStepKey = visibleSteps[activeStep]?.key;

// // //   const goNextIndex = () => setActiveStep((i) => Math.min(i + 1, visibleSteps.length - 1));
// // //   const goPrevIndex = () => setActiveStep((i) => Math.max(i - 1, 0));

// // //   /* ---------------- API calls ---------------- */
// // //   const createApplication = async () => {
// // //     try {
// // //       await detailsSchema.validate(values, { abortEarly: false });
// // //     } catch (err) {
// // //       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
// // //       setSubmitError('Please fill in all required fields.');
// // //       return;
// // //     }
// // //     setLoading(true);
// // //     setSubmitError('');
// // //     try {
// // //       let newAppId;
// // //       if (USE_MOCK) {
// // //         await new Promise((resolve) => setTimeout(resolve, 300));
// // //         newAppId = 'mock-app-' + Date.now();
// // //       } else {
// // //         const payload = {
// // //           businessId: values.businessId,
// // //           appName: values.businessName,
// // //           appDescription: values.description,
// // //           appType: values.applicationType,
// // //           appBusinessName: values.businessName,
// // //           enabled: values.isActive,
// // //           logoUrl: values.appLogoUrl || undefined,
// // //         };
// // //         const response = await adminService.createBusinessApp(payload);
// // //         newAppId = response.data?._id || response._id;
// // //       }
// // //       if (!newAppId) throw new Error('App ID not returned');
// // //       setAppId(newAppId);
// // //       goNextIndex();
// // //     } catch (err) {
// // //       setSubmitError(err.message || 'Failed to create application');
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const saveSettings = async () => {
// // //     try {
// // //       await settingsSchema.validate(values, { abortEarly: false });
// // //     } catch (err) {
// // //       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
// // //       setSubmitError(err.errors?.[0] || 'Please fill in all required settings.');
// // //       return;
// // //     }
// // //     if (!appId) {
// // //       setSubmitError('Application not created yet.');
// // //       return;
// // //     }
// // //     setSavingSettings(true);
// // //     setSubmitError('');
// // //     try {
// // //       if (!USE_MOCK) {
// // //         let metadataObj = {};
// // //         if (values.metadataJson && values.metadataJson.trim()) {
// // //           metadataObj = JSON.parse(values.metadataJson);
// // //         }
// // //         const settingsPayload = {
// // //           blockDuration: values.blockDuration,
// // //           failedAttempts: values.failedAttempts,
// // //           ipGeolocationEnabled: values.ipGeolocationEnabled,
// // //           webhookUrl: values.webhookUrl || undefined,
// // //           metadata: metadataObj,
// // //         };
// // //         await adminService.updateAppSettings(appId, settingsPayload);
// // //       } else {
// // //         await new Promise((resolve) => setTimeout(resolve, 200));
// // //       }
// // //       goNextIndex();
// // //     } catch (err) {
// // //       setSubmitError(err.message || 'Failed to save settings');
// // //     } finally {
// // //       setSavingSettings(false);
// // //     }
// // //   };

// // //   /* ---------------- Domain handlers ---------------- */
// // //   const addDomainRow = () => {
// // //     const next = [...values.domains, emptyDomain()];
// // //     setFieldValue('domains', next);
// // //     setExpandedDomains((prev) => ({ ...prev, [next.length - 1]: true }));
// // //   };

// // //   const updateDomainField = (index, field, value) => {
// // //     const updated = values.domains.map((d, i) =>
// // //       i === index ? { ...d, [field]: value, saved: field === 'status' ? d.saved : false } : d
// // //     );
// // //     setFieldValue('domains', updated);
// // //   };

// // //   const saveDomain = async (index) => {
// // //     const domain = values.domains[index];
// // //     if (!domain.domain.trim() || !getPath(domain.redirectUrl).trim()) {
// // //       setSubmitError('Domain and Redirect URL are required.');
// // //       return;
// // //     }
// // //     if (!appId) {
// // //       setSubmitError('Application not created yet.');
// // //       return;
// // //     }
// // //     setSavingDomain(true);
// // //     setSubmitError('');
// // //     try {
// // //       let newDomainId = domain.id;
// // //       if (!USE_MOCK) {
// // //         const payload = {
// // //           domain: domain.domain,
// // //           displayName: domain.displayName,
// // //           redirectUrl: domain.redirectUrl,
// // //           enabled: domain.status,
// // //           logoUrl: domain.logoUrl || undefined,
// // //         };
// // //         let response;
// // //         if (domain.id) {
// // //           response = await adminService.updateAppDomain(appId, domain.id, payload);
// // //         } else {
// // //           response = await adminService.addAppDomain(appId, payload);
// // //           newDomainId = response.data?._id || response._id;
// // //           if (!newDomainId) throw new Error('Domain ID not returned');
// // //         }
// // //       } else {
// // //         await new Promise((resolve) => setTimeout(resolve, 200));
// // //         if (!domain.id) {
// // //           newDomainId = 'mock-domain-' + Date.now();
// // //         }
// // //       }
// // //       const updated = values.domains.map((d, i) =>
// // //         i === index ? { ...d, id: newDomainId, saved: true } : d
// // //       );
// // //       setFieldValue('domains', updated);
// // //       setExpandedDomains((prev) => ({ ...prev, [index]: false }));
// // //     } catch (err) {
// // //       setSubmitError(err.message || 'Failed to save domain');
// // //     } finally {
// // //       setSavingDomain(false);
// // //     }
// // //   };

// // //   const removeDomain = async (index) => {
// // //     const domain = values.domains[index];
// // //     if (domain.id && appId && !USE_MOCK) {
// // //       setSavingDomain(true);
// // //       try {
// // //         await adminService.deleteAppDomain(appId, domain.id);
// // //       } catch (err) {
// // //         setSubmitError(err.message || 'Failed to delete domain');
// // //         setSavingDomain(false);
// // //         return;
// // //       }
// // //     }
// // //     const updated = values.domains.filter((_, i) => i !== index);
// // //     setFieldValue('domains', updated.length ? updated : [emptyDomain()]);
// // //     setSavingDomain(false);
// // //   };

// // //   const toggleDomainStatus = async (index) => {
// // //     const domain = values.domains[index];
// // //     updateDomainField(index, 'status', !domain.status);

// // //     if (domain.id && appId && !USE_MOCK) {
// // //       setSavingDomain(true);
// // //       try {
// // //         await adminService.toggleAppDomainStatus(appId, domain.id, !domain.status);
// // //       } catch (err) {
// // //         setSubmitError(err.message || 'Failed to toggle domain status');
// // //         updateDomainField(index, 'status', domain.status);
// // //       } finally {
// // //         setSavingDomain(false);
// // //       }
// // //     }
// // //   };

// // //   const handleNext = async () => {
// // //     if (currentStepKey === 'details') {
// // //       await createApplication();
// // //     } else if (currentStepKey === 'domains') {
// // //       const unsaved = values.domains.filter((d) => !d.saved && d.domain.trim());
// // //       if (unsaved.length > 0) {
// // //         setSubmitError('Please save all domains before proceeding.');
// // //         return;
// // //       }
// // //       goNextIndex();
// // //     } else if (currentStepKey === 'settings') {
// // //       await saveSettings();
// // //     } else {
// // //       goNextIndex();
// // //     }
// // //   };

// // //   const handleBack = () => goPrevIndex();

// // //   const handleDone = () => {
// // //     navigate(isAdmin ? '/admin/businesses' : '/business/applications');
// // //   };

// // //   const isBusy = loading || savingSettings || savingDomain;

// // //   /* ---------------- Render ---------------- */
// // //   return (
// // //     <Container maxWidth="xl" sx={{ py: 3 }}>
// // //       <Box sx={{ mb: 3 }}>
// // //         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
// // //           <MuiLink underline="hover" color="text.secondary" href="#" onClick={(e) => e.preventDefault()}>
// // //             Applications
// // //           </MuiLink>
// // //           <Typography color="text.primary" fontSize={13} fontWeight={600}>
// // //             Create Application
// // //           </Typography>
// // //         </Breadcrumbs>

// // //         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
// // //           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
// // //             Create Application
// // //           </Typography>
// // //           <Typography variant="body2" color="text.secondary">
// // //             Create and configure a new application for your business
// // //           </Typography>
// // //         </Box>
// // //       </Box>

// // //       {submitError && (
// // //         <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSubmitError('')}>
// // //           {submitError}
// // //         </Alert>
// // //       )}

// // //       {/* ---------- Wider & taller Stepper ---------- */}
// // //       <Paper
// // //         elevation={0}
// // //         sx={{
// // //           borderRadius: 3,
// // //           border: `1px solid ${C.border}`,
// // //           p: 3,
// // //           mb: 3,
// // //         }}
// // //       >
// // //         <Grid container spacing={2}>
// // //           {visibleSteps.map((step, index) => (
// // //             <Grid
// // //               item
// // //               xs
// // //               key={step.key}
// // //               sx={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 gap: 1.5,
// // //                 borderRight: index < visibleSteps.length - 1 ? `1px solid ${C.border}` : 'none',
// // //                 pr: 2,
// // //                 mr: 2,
// // //                 py: 0.5,
// // //               }}
// // //             >
// // //               <Box
// // //                 sx={{
// // //                   width: 34,
// // //                   height: 34,
// // //                   borderRadius: '50%',
// // //                   flexShrink: 0,
// // //                   display: 'flex',
// // //                   alignItems: 'center',
// // //                   justifyContent: 'center',
// // //                   fontWeight: 700,
// // //                   fontSize: 16,
// // //                   bgcolor: index === activeStep ? C.blue : index < activeStep ? C.green : '#fff',
// // //                   color: index <= activeStep ? '#fff' : C.textSecondary,
// // //                   border: index > activeStep ? `2px solid ${C.border}` : 'none',
// // //                 }}
// // //               >
// // //                 {index < activeStep ? <CheckCircle sx={{ fontSize: 18 }} /> : index + 1}
// // //               </Box>
// // //               <Box sx={{ minWidth: 0 }}>
// // //                 <Typography
// // //                   variant="body1"
// // //                   fontWeight={700}
// // //                   noWrap
// // //                   sx={{ color: index === activeStep ? C.blue : C.textPrimary }}
// // //                 >
// // //                   {step.label}
// // //                 </Typography>
// // //                 <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// // //                   {step.subtitle}
// // //                 </Typography>
// // //               </Box>
// // //             </Grid>
// // //           ))}
// // //         </Grid>
// // //       </Paper>

// // //       {/* ---------- Step content ---------- */}
// // //       <Box
// // //         sx={{
// // //           display: 'flex',
// // //           flexDirection: { xs: 'column', md: 'row' },
// // //           alignItems: 'flex-start',
// // //           gap: 3,
// // //         }}
// // //       >
// // //         {/* LEFT — form (full width on the review step, since there is no sidebar there) */}
// // //         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
// // //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// // //             {currentStepKey === 'details' && (
// // //               <Step1Details
// // //                 values={values}
// // //                 handleChange={handleChange}
// // //                 setFieldValue={setFieldValue}
// // //                 errors={errors}
// // //                 touched={touched}
// // //                 businesses={businesses}
// // //                 isAdmin={isAdmin}
// // //                 fetching={fetchingBusinesses}
// // //               />
// // //             )}
// // //             {currentStepKey === 'domains' && (
// // //               <Step2Domains
// // //                 values={values}
// // //                 savingDomain={savingDomain}
// // //                 onSaveDomain={saveDomain}
// // //                 onRemoveDomain={removeDomain}
// // //                 onToggleDomain={toggleDomainStatus}
// // //                 updateDomainField={updateDomainField}
// // //                 addDomainRow={addDomainRow}
// // //                 expandedDomains={expandedDomains}
// // //                 setExpandedDomains={setExpandedDomains}
// // //                 appLogoUrl={values.appLogoUrl}
// // //               />
// // //             )}
// // //             {currentStepKey === 'settings' && (
// // //               <Step3Security
// // //                 values={values}
// // //                 handleChange={handleChange}
// // //                 setFieldValue={setFieldValue}
// // //                 errors={errors}
// // //                 touched={touched}
// // //               />
// // //             )}
// // //             {currentStepKey === 'review' && (
// // //               <Step4Review
// // //                 values={values}
// // //                 setActiveStep={setActiveStep}
// // //                 visibleSteps={visibleSteps}
// // //                 createdByEmail={createdByEmail}
// // //               />
// // //             )}

// // //             <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
// // //               <Button
// // //                 variant="outlined"
// // //                 startIcon={<ArrowBackIcon />}
// // //                 onClick={handleBack}
// // //                 disabled={activeStep === 0}
// // //                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
// // //               >
// // //                 Back
// // //               </Button>
// // //               {currentStepKey === 'review' ? (
// // //                 <Button
// // //                   variant="contained"
// // //                   onClick={handleDone}
// // //                   startIcon={<CheckCircle />}
// // //                   sx={{
// // //                     background: `#2563EB`,
// // //                     color: '#fff',
// // //                     px: 5,
// // //                     py: 1.5,
// // //                   }}
// // //                 >
// // //                   Create Application
// // //                 </Button>
// // //               ) : (
// // //                 <Button
// // //                   variant="contained"
// // //                   onClick={handleNext}
// // //                   disabled={isBusy}
// // //                   endIcon={isBusy ? <CircularProgress size={20} color="inherit" /> : <ArrowForward />}
// // //                   sx={{
// // //                     background: `#2563EB`,
// // //                     color: '#fff',
// // //                     px: 5,
// // //                     py: 1.5,
// // //                   }}
// // //                 >
// // //                   {isBusy ? 'Processing…' : 'Save & Continue'}
// // //                 </Button>
// // //               )}
// // //             </Box>
// // //           </Paper>
// // //         </Box>

// // //         {/* RIGHT — preview sidebar (hidden on review, where the form takes the full width instead) */}
// // //         {currentStepKey !== 'review' && (
// // //           <Box
// // //             sx={{
// // //               flex: '0 0 auto',
// // //               width: { xs: '100%', md: 600 },
// // //               position: { md: 'sticky' },
// // //               top: { md: 16 },
// // //             }}
// // //           >
// // //             <PreviewSidebar
// // //               values={values}
// // //               showDomains={showDomains}
// // //               currentStepKey={currentStepKey}
// // //             />
// // //           </Box>
// // //         )}
// // //       </Box>
// // //     </Container>
// // //   );
// // // };

// // // /* ----------------------------------------------------------------------
// // //    Status badge
// // // ---------------------------------------------------------------------- */
// // // const StatusBadge = ({ active }) => (
// // //   <Chip
// // //     label={active ? 'ACTIVE' : 'INACTIVE'}
// // //     size="small"
// // //     sx={{
// // //       fontWeight: 700,
// // //       fontSize: 11,
// // //       height: 22,
// // //       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
// // //       color: active ? C.badgeActiveText : C.badgeInactiveText,
// // //     }}
// // //   />
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Saved / unsaved badge (used in the domains list)
// // // ---------------------------------------------------------------------- */
// // // const SaveStateBadge = ({ saved }) => (
// // //   <Chip
// // //     label={saved ? 'Saved' : 'Unsaved'}
// // //     size="small"
// // //     sx={{
// // //       fontWeight: 700,
// // //       fontSize: 11,
// // //       height: 22,
// // //       bgcolor: saved ? C.badgeActiveBg : C.amberBg,
// // //       color: saved ? C.badgeActiveText : C.amberText,
// // //     }}
// // //   />
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Inline toggle row
// // // ---------------------------------------------------------------------- */
// // // const InlineToggleRow = ({ label, description, checked, onChange }) => (
// // //   <Box
// // //     sx={{
// // //       display: 'flex',
// // //       alignItems: 'center',
// // //       justifyContent: 'space-between',
// // //       gap: 2,
// // //       flexWrap: 'wrap',
// // //     }}
// // //   >
// // //     <Typography variant="body2" noWrap sx={{ overflow: 'visible' }}>
// // //       <Box component="span" fontWeight={600}>
// // //         {label}
// // //       </Box>
// // //       {description && (
// // //         <Box component="span" sx={{ color: C.textSecondary, ml: 1 }}>
// // //           — {description}
// // //         </Box>
// // //       )}
// // //     </Typography>
// // //     <Switch checked={checked} onChange={onChange} color="primary" />
// // //   </Box>
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Step 1 — Application Details
// // // ---------------------------------------------------------------------- */
// // // const Step1Details = ({
// // //   values,
// // //   handleChange,
// // //   setFieldValue,
// // //   errors,
// // //   touched,
// // //   businesses,
// // //   isAdmin,
// // //   fetching,
// // // }) => {
// // //   const selectedBusiness = businesses.find((b) => b._id === values.businessId) || null;

// // //   return (
// // //     <Box>
// // //       <Typography variant="h6" fontWeight={700} gutterBottom>
// // //         Application Details
// // //       </Typography>
// // //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// // //         Provide basic information about your application
// // //       </Typography>

// // //       {isAdmin && (
// // //         <InlineField label="Select Business *">
// // //           <Autocomplete
// // //             options={businesses}
// // //             loading={fetching}
// // //             value={selectedBusiness}
// // //             getOptionLabel={(biz) => biz.businessName || ''}
// // //             isOptionEqualToValue={(a, b) => a._id === b._id}
// // //             onChange={(_, val) => setFieldValue('businessId', val ? val._id : '')}
// // //             renderOption={(props, biz) => (
// // //               <Box component="li" {...props} key={biz._id} sx={{ justifyContent: 'space-between !important' }}>
// // //                 <Box>
// // //                   <Typography variant="body2" fontWeight={600}>
// // //                     {biz.businessName}
// // //                   </Typography>
// // //                   <Typography variant="caption" color="text.secondary">
// // //                     {biz._id}
// // //                   </Typography>
// // //                 </Box>
// // //                 <StatusBadge active={biz.status !== false && biz.isActive !== false} />
// // //               </Box>
// // //             )}
// // //             renderInput={(params) => (
// // //               <TextField
// // //                 {...params}
// // //                 placeholder="Search and select a business"
// // //                 size="medium"
// // //                 error={touched.businessId && Boolean(errors.businessId)}
// // //                 helperText={touched.businessId && errors.businessId}
// // //               />
// // //             )}
// // //           />
// // //         </InlineField>
// // //       )}

// // //       <InlineField label="Application Type *">
// // //         <FormControl fullWidth size="medium" error={touched.applicationType && Boolean(errors.applicationType)}>
// // //           <Select
// // //             name="applicationType"
// // //             displayEmpty
// // //             value={values.applicationType}
// // //             onChange={(e) => {
// // //               const type = e.target.value;
// // //               setFieldValue('applicationType', type);
// // //               if (type === 'MOBILE') {
// // //                 setFieldValue('domains', []);
// // //               } else if (values.domains.length === 0) {
// // //                 setFieldValue('domains', [emptyDomain()]);
// // //               }
// // //             }}
// // //           >
// // //             <MenuItem value="" disabled>Select application type</MenuItem>
// // //             <MenuItem value="WEB">Web Application</MenuItem>
// // //             <MenuItem value="MOBILE">Mobile Application</MenuItem>
// // //           </Select>
// // //           {touched.applicationType && errors.applicationType && (
// // //             <FormHelperText error>{errors.applicationType}</FormHelperText>
// // //           )}
// // //         </FormControl>
// // //       </InlineField>

// // //       <InlineField label="Business Name *">
// // //         <TextField
// // //           fullWidth
// // //           size="medium"
// // //           name="businessName"
// // //           placeholder="Enter business name to display"
// // //           value={values.businessName}
// // //           onChange={handleChange}
// // //           error={touched.businessName && Boolean(errors.businessName)}
// // //           helperText={touched.businessName && errors.businessName}
// // //         />
// // //       </InlineField>

// // //       <InlineField label="Logo URL (Optional)">
// // //         <TextField
// // //           fullWidth
// // //           size="medium"
// // //           name="appLogoUrl"
// // //           placeholder="https://example.com/logo.png"
// // //           value={values.appLogoUrl}
// // //           onChange={handleChange}
// // //           error={touched.appLogoUrl && Boolean(errors.appLogoUrl)}
// // //           helperText={touched.appLogoUrl && errors.appLogoUrl}
// // //         />
// // //       </InlineField>

// // //       <InlineField label="Description">
// // //         <TextField
// // //           fullWidth
// // //           size="medium"
// // //           multiline
// // //           minRows={2}
// // //           name="description"
// // //           placeholder="Enter application description"
// // //           value={values.description}
// // //           onChange={handleChange}
// // //           error={touched.description && Boolean(errors.description)}
// // //           helperText={touched.description && errors.description}
// // //         />
// // //       </InlineField>

// // //       <InlineField label="Enable Application">
// // //         <Switch
// // //           checked={values.isActive}
// // //           onChange={(e) => setFieldValue('isActive', e.target.checked)}
// // //           color="primary"
// // //         />
// // //         <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
// // //           Application will be active after creation
// // //         </Typography>
// // //       </InlineField>
// // //     </Box>
// // //   );
// // // };

// // // /* ----------------------------------------------------------------------
// // //    Preview sidebar (wider, tighter internal spacing)
// // // ---------------------------------------------------------------------- */
// // // const NEXT_STEP_COPY = {
// // //   details: 'Configure domains, URLs, and redirect settings for your application.',
// // //   domains: 'Set up block duration, failed-attempt limits, and other security settings.',
// // //   settings: 'Review everything and create your application.',
// // //   review: 'You’re all set — hit “Create Application” to finish up.',
// // // };

// // // const PreviewSidebar = ({ values, showDomains, currentStepKey }) => {
// // //   const initials = (values.businessName || 'AP').slice(0, 2).toUpperCase();
// // //   const logoUrl = values.appLogoUrl || null;
// // //   const nextStepText =
// // //     currentStepKey === 'details' && !showDomains
// // //       ? 'Configure security and access-control settings for your application.'
// // //       : NEXT_STEP_COPY[currentStepKey] || NEXT_STEP_COPY.details;

// // //   return (
// // //     <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// // //       <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
// // //         Application Preview
// // //       </Typography>
// // //       <Box
// // //         sx={{
// // //           border: `1px solid ${C.border}`,
// // //           borderRadius: 2,
// // //           p: 3,
// // //           textAlign: 'center',
// // //           mb: 2.5,
// // //         }}
// // //       >
// // //         <Box
// // //           sx={{
// // //             width: 104,
// // //             height: 104,
// // //             borderRadius: '50%',
// // //             bgcolor: C.indigo,
// // //             color: '#fff',
// // //             display: 'flex',
// // //             alignItems: 'center',
// // //             justifyContent: 'center',
// // //             fontSize: 34,
// // //             fontWeight: 700,
// // //             mx: 'auto',
// // //             mb: 1.5,
// // //             overflow: 'hidden',
// // //           }}
// // //         >
// // //           {logoUrl ? (
// // //             <Box component="img" src={logoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// // //           ) : (
// // //             initials
// // //           )}
// // //         </Box>
// // //         <Typography variant="h5" fontWeight={700}>
// // //           {values.businessName || 'Application Name'}
// // //         </Typography>
// // //         {values.applicationType && (
// // //           <Chip
// // //             label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
// // //             size="medium"
// // //             sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
// // //           />
// // //         )}
// // //         <Typography variant="body2" color="text.secondary">
// // //           {values.businessId || 'Business Name'}
// // //         </Typography>
// // //       </Box>

// // //       <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
// // //         Overview
// // //       </Typography>
// // //       <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
// // //         {[
// // //           ['Business', values.businessId || 'Not selected'],
// // //           ['Type', values.applicationType === 'WEB' ? 'Web Application' : values.applicationType === 'MOBILE' ? 'Mobile Application' : '-'],
// // //           ['Status', values.isActive ? 'Active after creation' : 'Inactive'],
// // //           ['Domains', showDomains ? (values.domains?.length ? `${values.domains.length} configured` : 'Not configured') : 'N/A'],
// // //           ['Created', '-'],
// // //         ].map(([label, value]) => (
// // //           <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
// // //             <Typography variant="body2" color="text.secondary">
// // //               {label}
// // //             </Typography>
// // //             <Typography variant="body2" fontWeight={600}>
// // //               {value}
// // //             </Typography>
// // //           </Box>
// // //         ))}
// // //       </Box>

// // //       <Box
// // //         sx={{
// // //           mt: 2.5,
// // //           bgcolor: C.infoBg,
// // //           border: `1px solid ${C.infoBorder}`,
// // //           borderRadius: 2,
// // //           p: 2,
// // //           display: 'flex',
// // //           gap: 1.5,
// // //         }}
// // //       >
// // //         <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
// // //         <Box>
// // //           <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
// // //             {currentStepKey === 'review' ? 'Ready to Create' : 'Next Step'}
// // //           </Typography>
// // //           <Typography variant="caption" sx={{ color: C.infoText }}>
// // //             {nextStepText}
// // //           </Typography>
// // //         </Box>
// // //       </Box>
// // //     </Paper>
// // //   );
// // // };

// // // /* ----------------------------------------------------------------------
// // //    Step 2 — Domains & URLs
// // //    Redesigned: two-column field layout, a compact inline logo preview,
// // //    a clear saved/unsaved state, and a single dashed "add domain" affordance
// // //    at the end of the list instead of a duplicated button inside every card.
// // // ---------------------------------------------------------------------- */
// // // const Step2Domains = ({
// // //   values,
// // //   savingDomain,
// // //   onSaveDomain,
// // //   onRemoveDomain,
// // //   onToggleDomain,
// // //   updateDomainField,
// // //   addDomainRow,
// // //   expandedDomains,
// // //   setExpandedDomains,
// // //   appLogoUrl,
// // // }) => {
// // //   const domains = values.domains;

// // //   const toggleExpand = (index) =>
// // //     setExpandedDomains((prev) => ({ ...prev, [index]: !prev[index] }));

// // //   return (
// // //     <Box>
// // //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 2 }}>
// // //         <Box>
// // //           <Typography variant="h6" fontWeight={700} gutterBottom>
// // //             Domains & URLs
// // //           </Typography>
// // //           <Typography variant="body2" color="text.secondary">
// // //             Add every domain that's allowed to access this application, along with where it should
// // //             redirect after authentication.
// // //           </Typography>
// // //         </Box>
// // //         <Chip
// // //           label={`${domains.length} ${domains.length === 1 ? 'domain' : 'domains'}`}
// // //           sx={{ bgcolor: C.bgLight, color: C.textPrimary, fontWeight: 700, border: `1px solid ${C.border}` }}
// // //         />
// // //       </Box>

// // //       {domains.map((domain, index) => {
// // //         const expanded = expandedDomains[index] ?? true;
// // //         const domainLogoSource = domain.logoUrl || appLogoUrl || null;

// // //         return (
// // //           <Box
// // //             key={domain._tempId || index}
// // //             sx={{
// // //               border: `1px solid ${domain.saved ? C.border : C.amber}44`,
// // //               borderRadius: 2,
// // //               mb: 2,
// // //               overflow: 'hidden',
// // //               transition: 'border-color 0.15s ease',
// // //             }}
// // //           >
// // //             {/* Card header */}
// // //             <Box
// // //               sx={{
// // //                 display: 'flex',
// // //                 alignItems: 'center',
// // //                 justifyContent: 'space-between',
// // //                 px: 2.5,
// // //                 py: 1.5,
// // //                 bgcolor: '#fafbfc',
// // //                 cursor: 'pointer',
// // //               }}
// // //               onClick={() => toggleExpand(index)}
// // //             >
// // //               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
// // //                 <Avatar
// // //                   variant="rounded"
// // //                   sx={{
// // //                     width: 36,
// // //                     height: 36,
// // //                     bgcolor: domain.domain ? C.indigo : C.bgLight,
// // //                     color: domain.domain ? '#fff' : C.textSecondary,
// // //                     border: domain.domain ? 'none' : `1px dashed ${C.border}`,
// // //                   }}
// // //                 >
// // //                   <LanguageIcon fontSize="small" />
// // //                 </Avatar>
// // //                 <Box sx={{ minWidth: 0 }}>
// // //                   <Typography variant="body1" fontWeight={700} noWrap>
// // //                     {domain.domain || 'New Domain'}
// // //                   </Typography>
// // //                   {!expanded && (
// // //                     <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// // //                       {domain.redirectUrl && getPath(domain.redirectUrl)
// // //                         ? domain.redirectUrl
// // //                         : 'No redirect URL set'}
// // //                     </Typography>
// // //                   )}
// // //                 </Box>
// // //               </Box>
// // //               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={(e) => e.stopPropagation()}>
// // //                 <StatusBadge active={domain.status} />
// // //                 <SaveStateBadge saved={domain.saved} />
// // //                 <Button
// // //                   size="small"
// // //                   onClick={() => onRemoveDomain(index)}
// // //                   disabled={savingDomain}
// // //                   sx={{ color: '#e53e3e', minWidth: 'auto' }}
// // //                 >
// // //                   Remove
// // //                 </Button>
// // //                 <IconButton size="small" onClick={() => toggleExpand(index)}>
// // //                   {expanded ? <ExpandLess /> : <ExpandMore />}
// // //                 </IconButton>
// // //               </Box>
// // //             </Box>

// // //             {expanded && (
// // //               <Box sx={{ p: 2.5 }}>
// // //                 <Grid container spacing={2.5}>
// // //                   <Grid item xs={12} sm={6}>
// // //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// // //                       Domain *
// // //                     </Typography>
// // //                     <TextField
// // //                       fullWidth
// // //                       placeholder="example.com"
// // //                       value={domain.domain}
// // //                       onChange={(e) => updateDomainField(index, 'domain', e.target.value)}
// // //                       disabled={domain.saved}
// // //                       size="medium"
// // //                     />
// // //                   </Grid>

// // //                   <Grid item xs={12} sm={6}>
// // //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// // //                       Display Name *
// // //                     </Typography>
// // //                     <TextField
// // //                       fullWidth
// // //                       placeholder="Marketing Site"
// // //                       value={domain.displayName}
// // //                       onChange={(e) => updateDomainField(index, 'displayName', e.target.value)}
// // //                       size="medium"
// // //                     />
// // //                   </Grid>

// // //                   <Grid item xs={12}>
// // //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// // //                       Redirect URL *
// // //                     </Typography>
// // //                     <TextField
// // //                       fullWidth
// // //                       value={getPath(domain.redirectUrl)}
// // //                       onChange={(e) =>
// // //                         updateDomainField(
// // //                           index,
// // //                           'redirectUrl',
// // //                           `${getProtocol(domain.redirectUrl)}://${e.target.value}`
// // //                         )
// // //                       }
// // //                       disabled={domain.saved}
// // //                       size="medium"
// // //                       InputProps={{
// // //                         startAdornment: (
// // //                           <InputAdornment position="start">
// // //                             <Select
// // //                               variant="standard"
// // //                               disableUnderline
// // //                               value={getProtocol(domain.redirectUrl)}
// // //                               onChange={(e) =>
// // //                                 updateDomainField(
// // //                                   index,
// // //                                   'redirectUrl',
// // //                                   `${e.target.value}://${getPath(domain.redirectUrl)}`
// // //                                 )
// // //                               }
// // //                               disabled={domain.saved}
// // //                               sx={{ mr: 1 }}
// // //                             >
// // //                               <MenuItem value="https">https</MenuItem>
// // //                               <MenuItem value="http">http</MenuItem>
// // //                             </Select>
// // //                           </InputAdornment>
// // //                         ),
// // //                       }}
// // //                     />
// // //                   </Grid>

// // //                   <Grid item xs={12} sm={8}>
// // //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// // //                       Logo URL (optional)
// // //                     </Typography>
// // //                     <TextField
// // //                       fullWidth
// // //                       placeholder="https://example.com/domain-logo.png"
// // //                       value={domain.logoUrl}
// // //                       onChange={(e) => updateDomainField(index, 'logoUrl', e.target.value)}
// // //                       size="medium"
// // //                       helperText="Overrides the application logo for this domain, if provided."
// // //                     />
// // //                   </Grid>

// // //                   <Grid item xs={12} sm={4}>
// // //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// // //                       Preview
// // //                     </Typography>
// // //                     <Box
// // //                       sx={{
// // //                         border: `1px solid ${C.border}`,
// // //                         borderRadius: 2,
// // //                         height: 56,
// // //                         display: 'flex',
// // //                         alignItems: 'center',
// // //                         justifyContent: 'center',
// // //                         bgcolor: C.bgLight,
// // //                         overflow: 'hidden',
// // //                         p: 1,
// // //                       }}
// // //                     >
// // //                       {domainLogoSource ? (
// // //                         <Box
// // //                           component="img"
// // //                           src={domainLogoSource}
// // //                           alt="logo preview"
// // //                           sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
// // //                         />
// // //                       ) : (
// // //                         <Typography variant="caption" color="text.secondary">
// // //                           No logo
// // //                         </Typography>
// // //                       )}
// // //                     </Box>
// // //                   </Grid>
// // //                 </Grid>

// // //                 <Divider sx={{ my: 2.5 }} />

// // //                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
// // //                   <FormControlLabel
// // //                     control={<Switch checked={domain.status} onChange={() => onToggleDomain(index)} />}
// // //                     label={domain.status ? 'Active' : 'Inactive'}
// // //                   />
// // //                   {!domain.saved ? (
// // //                     <Button
// // //                       size="medium"
// // //                       variant="contained"
// // //                       onClick={() => onSaveDomain(index)}
// // //                       disabled={savingDomain}
// // //                       sx={{ background: C.blue, px: 4 }}
// // //                     >
// // //                       {savingDomain ? <CircularProgress size={20} color="inherit" /> : 'Save Domain'}
// // //                     </Button>
// // //                   ) : (
// // //                     <Button
// // //                       size="medium"
// // //                       variant="outlined"
// // //                       onClick={() => updateDomainField(index, 'domain', domain.domain)}
// // //                       sx={{ borderColor: C.border, color: C.textSecondary, px: 4 }}
// // //                       startIcon={<EditOutlined fontSize="small" />}
// // //                     >
// // //                       Edit
// // //                     </Button>
// // //                   )}
// // //                 </Box>
// // //               </Box>
// // //             )}
// // //           </Box>
// // //         );
// // //       })}

// // //       {/* Single, clear entry point for adding another domain */}
// // //       <Box
// // //         onClick={addDomainRow}
// // //         sx={{
// // //           border: `1.5px dashed ${C.border}`,
// // //           borderRadius: 2,
// // //           py: 2,
// // //           display: 'flex',
// // //           alignItems: 'center',
// // //           justifyContent: 'center',
// // //           gap: 1,
// // //           cursor: 'pointer',
// // //           color: C.blue,
// // //           transition: 'background-color 0.15s ease, border-color 0.15s ease',
// // //           '&:hover': { bgcolor: C.infoBg, borderColor: C.blue },
// // //         }}
// // //       >
// // //         <AddIcon fontSize="small" />
// // //         <Typography variant="body2" fontWeight={700}>
// // //           Add another domain
// // //         </Typography>
// // //       </Box>
// // //     </Box>
// // //   );
// // // };

// // // /* ----------------------------------------------------------------------
// // //    Step 3 — Security & Settings
// // // ---------------------------------------------------------------------- */
// // // const Step3Security = ({ values, handleChange, setFieldValue, errors, touched }) => (
// // //   <Box>
// // //     <Typography variant="h6" fontWeight={700} gutterBottom>
// // //       Security & Settings
// // //     </Typography>
// // //     <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// // //       Configure security options and additional settings for this application.
// // //     </Typography>

// // //     <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>
// // //       Security Settings
// // //     </Typography>

// // //     <InlineField label="Block Duration *">
// // //       <FormControl fullWidth size="medium" error={touched.blockDuration && Boolean(errors.blockDuration)}>
// // //         <Select
// // //           name="blockDuration"
// // //           value={values.blockDuration}
// // //           onChange={handleChange}
// // //         >
// // //           {BLOCK_DURATION_OPTIONS.map((v) => (
// // //             <MenuItem key={v} value={v}>
// // //               {v} minutes
// // //             </MenuItem>
// // //           ))}
// // //         </Select>
// // //         {touched.blockDuration && errors.blockDuration ? (
// // //           <FormHelperText error>{errors.blockDuration}</FormHelperText>
// // //         ) : (
// // //           <FormHelperText>Duration for blocking after suspicious activity.</FormHelperText>
// // //         )}
// // //       </FormControl>
// // //     </InlineField>

// // //     <InlineField label="Failed Attempts *">
// // //       <FormControl fullWidth size="medium" error={touched.failedAttempts && Boolean(errors.failedAttempts)}>
// // //         <Select
// // //           name="failedAttempts"
// // //           value={values.failedAttempts}
// // //           onChange={handleChange}
// // //         >
// // //           {FAILED_ATTEMPTS_OPTIONS.map((v) => (
// // //             <MenuItem key={v} value={v}>
// // //               {v} attempts
// // //             </MenuItem>
// // //           ))}
// // //         </Select>
// // //         {touched.failedAttempts && errors.failedAttempts ? (
// // //           <FormHelperText error>{errors.failedAttempts}</FormHelperText>
// // //         ) : (
// // //           <FormHelperText>Failed attempts before blocking.</FormHelperText>
// // //         )}
// // //       </FormControl>
// // //     </InlineField>

// // //     <InlineField label="IP Allowlisting">
// // //       <Switch
// // //         checked={values.ipGeolocationEnabled}
// // //         onChange={(e) => setFieldValue('ipGeolocationEnabled', e.target.checked)}
// // //         color="primary"
// // //       />
// // //       <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
// // //         Restrict access to specific IP addresses
// // //       </Typography>
// // //     </InlineField>

// // //     <Divider sx={{ my: 2.5 }} />

// // //     <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>
// // //       Advanced Settings
// // //     </Typography>

// // //     <InlineField label="Webhook URL">
// // //       <TextField
// // //         fullWidth
// // //         size="medium"
// // //         name="webhookUrl"
// // //         placeholder="https://example.com/webhook/auth-events"
// // //         value={values.webhookUrl}
// // //         onChange={handleChange}
// // //         error={touched.webhookUrl && Boolean(errors.webhookUrl)}
// // //         helperText={
// // //           (touched.webhookUrl && errors.webhookUrl) || 'Receive real-time notifications and events.'
// // //         }
// // //       />
// // //     </InlineField>

// // //     <InlineField label="Metadata (JSON)">
// // //       <TextField
// // //         fullWidth
// // //         size="medium"
// // //         multiline
// // //         minRows={3}
// // //         name="metadataJson"
// // //         value={values.metadataJson}
// // //         onChange={handleChange}
// // //         error={Boolean(errors.metadataJson)}
// // //         helperText={errors.metadataJson}
// // //         InputProps={{
// // //           sx: {
// // //             fontFamily: 'Menlo, Consolas, monospace',
// // //             fontSize: 13,
// // //             bgcolor: '#f7fafc',
// // //           },
// // //         }}
// // //       />
// // //     </InlineField>

// // //     <Divider sx={{ my: 2.5 }} />

// // //     <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
// // //       Application Status
// // //     </Typography>

// // //     <InlineField label="Enable Application">
// // //       <Switch
// // //         checked={values.isActive}
// // //         onChange={(e) => setFieldValue('isActive', e.target.checked)}
// // //         color="primary"
// // //       />
// // //       <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
// // //         Application will be active after creation
// // //       </Typography>
// // //     </InlineField>
// // //   </Box>
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Step 4 — Review & Create
// // //    Redesigned to use the full width of the page now that the preview
// // //    sidebar is gone: a hero summary, a row of at-a-glance stat tiles, and
// // //    the detail sections laid out two-up instead of stacked in a single
// // //    narrow column.
// // // ---------------------------------------------------------------------- */
// // // const SummarySection = ({ title, onEdit, children, sx }) => (
// // //   <Paper variant="outlined" sx={{ p: 2.5, borderColor: C.border, borderRadius: 2, height: '100%', ...sx }}>
// // //     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
// // //       <Typography variant="subtitle1" fontWeight={700}>
// // //         {title}
// // //       </Typography>
// // //       {onEdit && (
// // //         <Button size="small" startIcon={<EditOutlined fontSize="small" />} onClick={onEdit} sx={{ color: C.blue }}>
// // //           Edit
// // //         </Button>
// // //       )}
// // //     </Box>
// // //     {children}
// // //   </Paper>
// // // );

// // // const StatTile = ({ icon, label, value }) => (
// // //   <Paper
// // //     variant="outlined"
// // //     sx={{
// // //       p: 2,
// // //       borderColor: C.border,
// // //       borderRadius: 2,
// // //       display: 'flex',
// // //       alignItems: 'center',
// // //       gap: 1.5,
// // //       height: '100%',
// // //     }}
// // //   >
// // //     <Box
// // //       sx={{
// // //         width: 40,
// // //         height: 40,
// // //         borderRadius: 2,
// // //         bgcolor: C.infoBg,
// // //         color: C.infoText,
// // //         display: 'flex',
// // //         alignItems: 'center',
// // //         justifyContent: 'center',
// // //         flexShrink: 0,
// // //       }}
// // //     >
// // //       {icon}
// // //     </Box>
// // //     <Box sx={{ minWidth: 0 }}>
// // //       <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// // //         {label}
// // //       </Typography>
// // //       <Typography variant="body1" fontWeight={700} noWrap>
// // //         {value}
// // //       </Typography>
// // //     </Box>
// // //   </Paper>
// // // );

// // // const Step4Review = ({ values, setActiveStep, visibleSteps, createdByEmail }) => {
// // //   const showDomains = values.applicationType === 'WEB';
// // //   const stepIndex = (key) => visibleSteps.findIndex((s) => s.key === key);
// // //   const metadataCount = (() => {
// // //     try {
// // //       return Object.keys(JSON.parse(values.metadataJson || '{}')).length;
// // //     } catch {
// // //       return 0;
// // //     }
// // //   })();

// // //   const detailRow = (label, value) => (
// // //     <Grid item xs={12} sm={6} key={label}>
// // //       <Typography variant="body2" color="text.secondary">
// // //         {label}
// // //       </Typography>
// // //       <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
// // //         {value}
// // //       </Typography>
// // //     </Grid>
// // //   );

// // //   return (
// // //     <Box>
// // //       <Typography variant="h6" fontWeight={700} gutterBottom>
// // //         Review & Create
// // //       </Typography>
// // //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// // //         Confirm all details before creating the application.
// // //       </Typography>

// // //       {/* Hero summary */}
// // //       <Paper
// // //         variant="outlined"
// // //         sx={{
// // //           p: 3,
// // //           mb: 3,
// // //           borderColor: C.border,
// // //           borderRadius: 3,
// // //           bgcolor: C.bgLight,
// // //         }}
// // //       >
// // //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
// // //           <Box
// // //             sx={{
// // //               width: 64,
// // //               height: 64,
// // //               borderRadius: '50%',
// // //               bgcolor: C.indigo,
// // //               color: '#fff',
// // //               display: 'flex',
// // //               alignItems: 'center',
// // //               justifyContent: 'center',
// // //               fontSize: 24,
// // //               fontWeight: 700,
// // //               flexShrink: 0,
// // //               overflow: 'hidden',
// // //             }}
// // //           >
// // //             {values.appLogoUrl ? (
// // //               <Box component="img" src={values.appLogoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// // //             ) : (
// // //               (values.businessName || 'AP').slice(0, 2).toUpperCase()
// // //             )}
// // //           </Box>
// // //           <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
// // //             <Typography variant="h5" fontWeight={800} noWrap>
// // //               {values.businessName || 'Application'}
// // //             </Typography>
// // //             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
// // //               <Chip
// // //                 label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
// // //                 size="small"
// // //                 sx={{ bgcolor: '#fff', color: C.textPrimary, fontWeight: 600, border: `1px solid ${C.border}` }}
// // //               />
// // //               <StatusBadge active={values.isActive} />
// // //             </Box>
// // //           </Box>
// // //           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: C.textSecondary }}>
// // //             <PersonOutlineIcon fontSize="small" />
// // //             <Box>
// // //               <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
// // //                 Created by
// // //               </Typography>
// // //               <Typography variant="body2" fontWeight={700}>
// // //                 {createdByEmail}
// // //               </Typography>
// // //             </Box>
// // //           </Box>
// // //         </Box>
// // //       </Paper>

// // //       {/* At-a-glance stat tiles — fills the width freed up by removing the sidebar */}
// // //       <Grid container spacing={2} sx={{ mb: 3 }}>
// // //         <Grid item xs={6} md={3}>
// // //           <StatTile
// // //             icon={<PublicIcon fontSize="small" />}
// // //             label="Domains"
// // //             value={showDomains ? values.domains.length : 'N/A'}
// // //           />
// // //         </Grid>
// // //         <Grid item xs={6} md={3}>
// // //           <StatTile
// // //             icon={<AccessTimeIcon fontSize="small" />}
// // //             label="Block Duration"
// // //             value={`${values.blockDuration} min`}
// // //           />
// // //         </Grid>
// // //         <Grid item xs={6} md={3}>
// // //           <StatTile
// // //             icon={<LockIcon fontSize="small" />}
// // //             label="Failed Attempts"
// // //             value={`${values.failedAttempts}`}
// // //           />
// // //         </Grid>
// // //         <Grid item xs={6} md={3}>
// // //           <StatTile
// // //             icon={<VerifiedUserIcon fontSize="small" />}
// // //             label="IP Allowlisting"
// // //             value={values.ipGeolocationEnabled ? 'Enabled' : 'Disabled'}
// // //           />
// // //         </Grid>
// // //       </Grid>

// // //       {/* Two-up detail sections instead of a single stacked column */}
// // //       <Grid container spacing={3} sx={{ mb: showDomains ? 3 : 0 }}>
// // //         <Grid item xs={12} md={6}>
// // //           <SummarySection title="Application Details" onEdit={() => setActiveStep(stepIndex('details'))}>
// // //             <Grid container spacing={2}>
// // //               {detailRow('Application Name', values.businessName)}
// // //               {detailRow('Application Type', values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application')}
// // //               {detailRow('Business', values.businessId || 'N/A')}
// // //               {detailRow('Description', values.description || 'Not provided')}
// // //             </Grid>
// // //           </SummarySection>
// // //         </Grid>

// // //         <Grid item xs={12} md={6}>
// // //           <SummarySection title="Security & Settings" onEdit={() => setActiveStep(stepIndex('settings'))}>
// // //             <Grid container spacing={2}>
// // //               {detailRow('Block Duration', `${values.blockDuration} minutes`)}
// // //               {detailRow('Failed Attempts Before Block', `${values.failedAttempts} attempts`)}
// // //               {detailRow('IP Allowlisting', values.ipGeolocationEnabled ? 'Enabled' : 'Disabled')}
// // //               {detailRow('Webhook URL', values.webhookUrl || 'Not configured')}
// // //               {detailRow('Metadata', metadataCount > 0 ? `${metadataCount} keys configured` : 'None')}
// // //             </Grid>
// // //           </SummarySection>
// // //         </Grid>
// // //       </Grid>

// // //       {showDomains && (
// // //         <SummarySection title="Domains & URLs" onEdit={() => setActiveStep(stepIndex('domains'))}>
// // //           <TableContainer>
// // //             <Table size="small">
// // //               <TableHead>
// // //                 <TableRow>
// // //                   <TableCell>Domain</TableCell>
// // //                   <TableCell>Display Name</TableCell>
// // //                   <TableCell>Redirect URL</TableCell>
// // //                   <TableCell>Logo</TableCell>
// // //                   <TableCell>Status</TableCell>
// // //                 </TableRow>
// // //               </TableHead>
// // //               <TableBody>
// // //                 {values.domains.map((d, idx) => (
// // //                   <TableRow key={idx}>
// // //                     <TableCell>{d.domain}</TableCell>
// // //                     <TableCell>{d.displayName || '-'}</TableCell>
// // //                     <TableCell>{d.redirectUrl}</TableCell>
// // //                     <TableCell>{d.logoUrl ? '✓' : '-'}</TableCell>
// // //                     <TableCell>
// // //                       <StatusBadge active={d.status} />
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 ))}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>
// // //         </SummarySection>
// // //       )}
// // //     </Box>
// // //   );
// // // };

// // // export default CreateApplicationPage;

// // import React, { useState, useEffect } from 'react';
// // import { useNavigate, useLocation } from 'react-router-dom';
// // import { useFormik } from 'formik';
// // import * as Yup from 'yup';
// // import {
// //   Container,
// //   Box,
// //   Typography,
// //   Button,
// //   TextField,
// //   Select,
// //   MenuItem,
// //   FormControl,
// //   InputLabel,
// //   FormControlLabel,
// //   Switch,
// //   Radio,
// //   RadioGroup,
// //   IconButton,
// //   Alert,
// //   CircularProgress,
// //   Paper,
// //   Grid,
// //   Divider,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Autocomplete,
// //   Breadcrumbs,
// //   Link as MuiLink,
// //   Chip,
// //   InputAdornment,
// //   FormHelperText,
// //   Avatar,
// // } from '@mui/material';
// // import {
// //   Add as AddIcon,
// //   Delete as DeleteIcon,
// //   ArrowForward,
// //   ArrowBack as ArrowBackIcon,
// //   CheckCircle,
// //   Language as LanguageIcon,
// //   ExpandMore,
// //   ExpandLess,
// //   CloudUpload,
// //   InfoOutlined,
// //   EditOutlined,
// //   AccessTime as AccessTimeIcon,
// //   Lock as LockIcon,
// //   Public as PublicIcon,
// //   VerifiedUser as VerifiedUserIcon,
// //   PersonOutline as PersonOutlineIcon,
// //   PhoneIphone as MobileIcon,
// //   Settings as SettingsIcon,
// // } from '@mui/icons-material';
// // import { adminService as realAdminService } from '../services/admin';
// // import { useAuth } from '../context/AuthContext';
// // import { ROUTES } from '../utils/constants';

// // /* ----------------------------------------------------------------------
// //    MOCK FLAG – set to true to skip real API calls
// // ---------------------------------------------------------------------- */
// // const USE_MOCK = true; // ← change to false when backend is ready

// // /* ----------------------------------------------------------------------
// //    Design tokens
// // ---------------------------------------------------------------------- */
// // const C = {
// //   border: '#e2e8f0',
// //   blue: '#3182ce',
// //   blueDark: '#2b6cb0',
// //   green: '#38a169',
// //   greenDark: '#276749',
// //   indigo: '#4c51bf',
// //   amber: '#dd6b20',
// //   amberBg: '#feebc8',
// //   amberText: '#9c4221',
// //   textPrimary: '#1a202c',
// //   textSecondary: '#718096',
// //   bgLight: '#f7fafc',
// //   badgeActiveBg: '#c6f6d5',
// //   badgeActiveText: '#276749',
// //   badgeInactiveBg: '#e2e8f0',
// //   badgeInactiveText: '#4a5568',
// //   infoBg: '#ebf8ff',
// //   infoBorder: '#bee3f8',
// //   infoText: '#2c5282',
// // };

// // /* ----------------------------------------------------------------------
// //    Validation schemas
// // ---------------------------------------------------------------------- */
// // const detailsSchema = Yup.object({
// //   businessId: Yup.string().required('Business is required'),
// //   applicationType: Yup.string()
// //     .oneOf(['WEB', 'MOBILE'])
// //     .required('Application type is required'),
// //   businessName: Yup.string().required('Display name is required').max(100),
// //   description: Yup.string().max(500),
// //   isActive: Yup.boolean(),
// //   appLogoUrl: Yup.string().url('Invalid URL').nullable(),
// // });

// // const settingsSchema = Yup.object({
// //   blockDuration: Yup.number()
// //     .min(1, 'Min 1 minute')
// //     .max(1440, 'Max 1440 minutes')
// //     .required('Required'),
// //   failedAttempts: Yup.number()
// //     .min(1, 'Min 1')
// //     .max(99, 'Max 99')
// //     .required('Required'),
// //   ipGeolocationEnabled: Yup.boolean(),
// //   webhookUrl: Yup.string().url('Invalid URL').nullable(),
// //   metadataJson: Yup.string().test(
// //     'is-json',
// //     'Metadata must be valid JSON',
// //     (val) => {
// //       if (!val || !val.trim()) return true;
// //       try {
// //         JSON.parse(val);
// //         return true;
// //       } catch {
// //         return false;
// //       }
// //     }
// //   ),
// // });

// // /* Step definitions. The "domains" step is filtered out entirely for
// //    MOBILE applications. */
// // const ALL_STEPS = [
// //   { key: 'details', label: 'Application Details', subtitle: 'Basic information' },
// //   { key: 'domains', label: 'Domains & URLs', subtitle: 'Configure domains and URLs' },
// //   { key: 'settings', label: 'Security & Settings', subtitle: 'Security and access control' },
// //   { key: 'review', label: 'Review & Create', subtitle: 'Review and create application' },
// // ];

// // const BLOCK_DURATION_OPTIONS = [5, 15, 30, 60, 120, 240, 1440];
// // const FAILED_ATTEMPTS_OPTIONS = [3, 5, 10, 15, 20, 25];

// // const emptyDomain = () => ({
// //   id: null,
// //   domain: '',
// //   displayName: '',
// //   redirectUrl: 'https://',
// //   status: true,
// //   saved: false,
// //   logoUrl: '', // only URL, no radio selection
// //   _tempId: Date.now() + Math.random(),
// // });

// // const getProtocol = (url = '') => (url.startsWith('http://') ? 'http' : 'https');
// // const getPath = (url = '') => url.replace(/^https?:\/\//, '');

// // /* ----------------------------------------------------------------------
// //    Mock adminService
// // ---------------------------------------------------------------------- */
// // const mockAdminService = {
// //   getAllBusinesses: () =>
// //     Promise.resolve({
// //       businesses: [
// //         { _id: 'biz1', businessName: 'Acme Corp', status: true, isActive: true },
// //         { _id: 'biz2', businessName: 'Beta Inc', status: true, isActive: false },
// //         { _id: 'biz3', businessName: 'Gamma LLC', status: false, isActive: true },
// //       ],
// //     }),
// //   createBusinessApp: (payload) =>
// //     Promise.resolve({ data: { _id: 'mock-app-' + Date.now() } }),
// //   updateAppSettings: () => Promise.resolve({}),
// //   addAppDomain: (appId, payload) =>
// //     Promise.resolve({ data: { _id: 'mock-domain-' + Date.now() } }),
// //   updateAppDomain: () => Promise.resolve({}),
// //   deleteAppDomain: () => Promise.resolve({}),
// //   toggleAppDomainStatus: () => Promise.resolve({}),
// // };

// // const adminService = USE_MOCK ? mockAdminService : realAdminService;

// // /* ----------------------------------------------------------------------
// //    Section Card – the shared "domain card" visual language: a bordered,
// //    rounded container with a light-grey header (icon avatar + title +
// //    optional badge/action) and top-labelled fields in the body. Reused
// //    across every step so the whole wizard reads as one consistent system.
// // ---------------------------------------------------------------------- */
// // const SectionCard = ({ icon, title, badge, action, children, sx }) => (
// //   <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
// //     <Box
// //       sx={{
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'space-between',
// //         px: 2.5,
// //         py: 1.5,
// //         bgcolor: '#fafbfc',
// //         flexWrap: 'wrap',
// //         gap: 1,
// //       }}
// //     >
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
// //         {icon && (
// //           <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
// //             {icon}
// //           </Avatar>
// //         )}
// //         <Typography variant="body1" fontWeight={700} noWrap>
// //           {title}
// //         </Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //         {badge}
// //         {action}
// //       </Box>
// //     </Box>
// //     <Box sx={{ p: 2.5 }}>{children}</Box>
// //   </Box>
// // );

// // /* Field label used above every input inside a SectionCard, matching the
// //    domain fields' top-label style. */
// // const FieldLabel = ({ children }) => (
// //   <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //     {children}
// //   </Typography>
// // );

// // /* ----------------------------------------------------------------------
// //    Main Component
// // ---------------------------------------------------------------------- */
// // const CreateApplicationPage = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { isAdmin, businessId: userBusinessId, user, email: authEmail } = useAuth();

// //   // Resolve the signed-in admin's email defensively, since the exact shape
// //   // of the auth context can vary (user.email, top-level email, username, etc).
// //   const createdByEmail =
// //     user?.email || authEmail || user?.username || user?.name || 'Unknown user';

// //   const [activeStep, setActiveStep] = useState(0);
// //   const [loading, setLoading] = useState(false);
// //   const [businesses, setBusinesses] = useState([]);
// //   const [fetchingBusinesses, setFetchingBusinesses] = useState(false);
// //   const [submitError, setSubmitError] = useState('');
// //   const [appId, setAppId] = useState(null);
// //   const [savingDomain, setSavingDomain] = useState(false);
// //   const [savingSettings, setSavingSettings] = useState(false);
// //   const [expandedDomains, setExpandedDomains] = useState({ 0: true });

// //   const preselectedBusinessId = new URLSearchParams(location.search).get('businessId');

// //   const formik = useFormik({
// //     initialValues: {
// //       businessId: preselectedBusinessId || (isAdmin ? '' : userBusinessId || ''),
// //       applicationType: 'WEB', // default to WEB
// //       description: '',
// //       businessName: '',
// //       isActive: true,
// //       domains: [emptyDomain()],
// //       blockDuration: 30,
// //       failedAttempts: 5,
// //       ipGeolocationEnabled: false,
// //       webhookUrl: '',
// //       metadataJson: '{\n  \n}',
// //       appLogoUrl: '',
// //     },
// //     validateOnChange: true,
// //   });

// //   const { values, handleChange, setFieldValue, errors, touched } = formik;

// //   // Fetch businesses if admin
// //   useEffect(() => {
// //     if (isAdmin) {
// //       setFetchingBusinesses(true);
// //       adminService
// //         .getAllBusinesses(0, 100)
// //         .then((data) => {
// //           let list = [];
// //           if (Array.isArray(data)) list = data;
// //           else if (data.businesses && Array.isArray(data.businesses)) list = data.businesses;
// //           else if (data.data && Array.isArray(data.data)) list = data.data;
// //           setBusinesses(list);
// //         })
// //         .catch(() => {})
// //         .finally(() => setFetchingBusinesses(false));
// //     }
// //   }, [isAdmin]);

// //   useEffect(() => {
// //     if (!isAdmin && userBusinessId) {
// //       setFieldValue('businessId', userBusinessId);
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [isAdmin, userBusinessId]);

// //   const showDomains = values.applicationType === 'WEB';

// //   const visibleSteps = ALL_STEPS.filter((s) => s.key !== 'domains' || showDomains);
// //   const currentStepKey = visibleSteps[activeStep]?.key;

// //   const goNextIndex = () => setActiveStep((i) => Math.min(i + 1, visibleSteps.length - 1));
// //   const goPrevIndex = () => setActiveStep((i) => Math.max(i - 1, 0));

// //   /* ---------------- API calls ---------------- */
// //   const createApplication = async () => {
// //     try {
// //       await detailsSchema.validate(values, { abortEarly: false });
// //     } catch (err) {
// //       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
// //       setSubmitError('Please fill in all required fields.');
// //       return;
// //     }
// //     setLoading(true);
// //     setSubmitError('');
// //     try {
// //       let newAppId;
// //       if (USE_MOCK) {
// //         await new Promise((resolve) => setTimeout(resolve, 300));
// //         newAppId = 'mock-app-' + Date.now();
// //       } else {
// //         const payload = {
// //           businessId: values.businessId,
// //           appName: values.businessName,
// //           appDescription: values.description,
// //           appType: values.applicationType,
// //           appBusinessName: values.businessName,
// //           enabled: values.isActive,
// //           logoUrl: values.appLogoUrl || undefined,
// //         };
// //         const response = await adminService.createBusinessApp(payload);
// //         newAppId = response.data?._id || response._id;
// //       }
// //       if (!newAppId) throw new Error('App ID not returned');
// //       setAppId(newAppId);
// //       goNextIndex();
// //     } catch (err) {
// //       setSubmitError(err.message || 'Failed to create application');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const saveSettings = async () => {
// //     try {
// //       await settingsSchema.validate(values, { abortEarly: false });
// //     } catch (err) {
// //       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
// //       setSubmitError(err.errors?.[0] || 'Please fill in all required settings.');
// //       return;
// //     }
// //     if (!appId) {
// //       setSubmitError('Application not created yet.');
// //       return;
// //     }
// //     setSavingSettings(true);
// //     setSubmitError('');
// //     try {
// //       if (!USE_MOCK) {
// //         let metadataObj = {};
// //         if (values.metadataJson && values.metadataJson.trim()) {
// //           metadataObj = JSON.parse(values.metadataJson);
// //         }
// //         const settingsPayload = {
// //           blockDuration: values.blockDuration,
// //           failedAttempts: values.failedAttempts,
// //           ipGeolocationEnabled: values.ipGeolocationEnabled,
// //           webhookUrl: values.webhookUrl || undefined,
// //           metadata: metadataObj,
// //         };
// //         await adminService.updateAppSettings(appId, settingsPayload);
// //       } else {
// //         await new Promise((resolve) => setTimeout(resolve, 200));
// //       }
// //       goNextIndex();
// //     } catch (err) {
// //       setSubmitError(err.message || 'Failed to save settings');
// //     } finally {
// //       setSavingSettings(false);
// //     }
// //   };

// //   /* ---------------- Domain handlers ---------------- */
// //   const addDomainRow = () => {
// //     const next = [...values.domains, emptyDomain()];
// //     setFieldValue('domains', next);
// //     setExpandedDomains((prev) => ({ ...prev, [next.length - 1]: true }));
// //   };

// //   const updateDomainField = (index, field, value) => {
// //     const updated = values.domains.map((d, i) =>
// //       i === index ? { ...d, [field]: value, saved: field === 'status' ? d.saved : false } : d
// //     );
// //     setFieldValue('domains', updated);
// //   };

// //   const saveDomain = async (index) => {
// //     const domain = values.domains[index];
// //     if (!domain.domain.trim() || !getPath(domain.redirectUrl).trim()) {
// //       setSubmitError('Domain and Redirect URL are required.');
// //       return;
// //     }
// //     if (!appId) {
// //       setSubmitError('Application not created yet.');
// //       return;
// //     }
// //     setSavingDomain(true);
// //     setSubmitError('');
// //     try {
// //       let newDomainId = domain.id;
// //       if (!USE_MOCK) {
// //         const payload = {
// //           domain: domain.domain,
// //           displayName: domain.displayName,
// //           redirectUrl: domain.redirectUrl,
// //           enabled: domain.status,
// //           logoUrl: domain.logoUrl || undefined,
// //         };
// //         let response;
// //         if (domain.id) {
// //           response = await adminService.updateAppDomain(appId, domain.id, payload);
// //         } else {
// //           response = await adminService.addAppDomain(appId, payload);
// //           newDomainId = response.data?._id || response._id;
// //           if (!newDomainId) throw new Error('Domain ID not returned');
// //         }
// //       } else {
// //         await new Promise((resolve) => setTimeout(resolve, 200));
// //         if (!domain.id) {
// //           newDomainId = 'mock-domain-' + Date.now();
// //         }
// //       }
// //       const updated = values.domains.map((d, i) =>
// //         i === index ? { ...d, id: newDomainId, saved: true } : d
// //       );
// //       setFieldValue('domains', updated);
// //       setExpandedDomains((prev) => ({ ...prev, [index]: false }));
// //     } catch (err) {
// //       setSubmitError(err.message || 'Failed to save domain');
// //     } finally {
// //       setSavingDomain(false);
// //     }
// //   };

// //   const removeDomain = async (index) => {
// //     const domain = values.domains[index];
// //     if (domain.id && appId && !USE_MOCK) {
// //       setSavingDomain(true);
// //       try {
// //         await adminService.deleteAppDomain(appId, domain.id);
// //       } catch (err) {
// //         setSubmitError(err.message || 'Failed to delete domain');
// //         setSavingDomain(false);
// //         return;
// //       }
// //     }
// //     const updated = values.domains.filter((_, i) => i !== index);
// //     setFieldValue('domains', updated.length ? updated : [emptyDomain()]);
// //     setSavingDomain(false);
// //   };

// //   const toggleDomainStatus = async (index) => {
// //     const domain = values.domains[index];
// //     updateDomainField(index, 'status', !domain.status);

// //     if (domain.id && appId && !USE_MOCK) {
// //       setSavingDomain(true);
// //       try {
// //         await adminService.toggleAppDomainStatus(appId, domain.id, !domain.status);
// //       } catch (err) {
// //         setSubmitError(err.message || 'Failed to toggle domain status');
// //         updateDomainField(index, 'status', domain.status);
// //       } finally {
// //         setSavingDomain(false);
// //       }
// //     }
// //   };

// //   const handleNext = async () => {
// //     if (currentStepKey === 'details') {
// //       await createApplication();
// //     } else if (currentStepKey === 'domains') {
// //       const unsaved = values.domains.filter((d) => !d.saved && d.domain.trim());
// //       if (unsaved.length > 0) {
// //         setSubmitError('Please save all domains before proceeding.');
// //         return;
// //       }
// //       goNextIndex();
// //     } else if (currentStepKey === 'settings') {
// //       await saveSettings();
// //     } else {
// //       goNextIndex();
// //     }
// //   };

// //   const handleBack = () => goPrevIndex();

// //   const handleDone = () => {
// //     navigate(isAdmin ? '/admin/businesses' : '/business/applications');
// //   };

// //   const isBusy = loading || savingSettings || savingDomain;

// //   /* ---------------- Render ---------------- */
// //   return (
// //     <Container maxWidth="xl" sx={{ py: 3 }}>
// //       <Box sx={{ mb: 3 }}>
// //         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
// //           <MuiLink underline="hover" color="text.secondary" href="#" onClick={(e) => e.preventDefault()}>
// //             Applications
// //           </MuiLink>
// //           <Typography color="text.primary" fontSize={13} fontWeight={600}>
// //             Create Application
// //           </Typography>
// //         </Breadcrumbs>

// //         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
// //           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
// //             Create Application
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             Create and configure a new application for your business
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {submitError && (
// //         <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSubmitError('')}>
// //           {submitError}
// //         </Alert>
// //       )}

// //       {/* ---------- Wider & taller Stepper ---------- */}
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           borderRadius: 3,
// //           border: `1px solid ${C.border}`,
// //           p: 3,
// //           mb: 3,
// //         }}
// //       >
// //         <Grid container spacing={2}>
// //           {visibleSteps.map((step, index) => (
// //             <Grid
// //               item
// //               xs
// //               key={step.key}
// //               sx={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: 1.5,
// //                 borderRight: index < visibleSteps.length - 1 ? `1px solid ${C.border}` : 'none',
// //                 pr: 2,
// //                 mr: 2,
// //                 py: 0.5,
// //               }}
// //             >
// //               <Box
// //                 sx={{
// //                   width: 34,
// //                   height: 34,
// //                   borderRadius: '50%',
// //                   flexShrink: 0,
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontWeight: 700,
// //                   fontSize: 16,
// //                   bgcolor: index === activeStep ? C.blue : index < activeStep ? C.green : '#fff',
// //                   color: index <= activeStep ? '#fff' : C.textSecondary,
// //                   border: index > activeStep ? `2px solid ${C.border}` : 'none',
// //                 }}
// //               >
// //                 {index < activeStep ? <CheckCircle sx={{ fontSize: 18 }} /> : index + 1}
// //               </Box>
// //               <Box sx={{ minWidth: 0 }}>
// //                 <Typography
// //                   variant="body1"
// //                   fontWeight={700}
// //                   noWrap
// //                   sx={{ color: index === activeStep ? C.blue : C.textPrimary }}
// //                 >
// //                   {step.label}
// //                 </Typography>
// //                 <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// //                   {step.subtitle}
// //                 </Typography>
// //               </Box>
// //             </Grid>
// //           ))}
// //         </Grid>
// //       </Paper>

// //       {/* ---------- Step content ---------- */}
// //       <Box
// //         sx={{
// //           display: 'flex',
// //           flexDirection: { xs: 'column', md: 'row' },
// //           alignItems: 'flex-start',
// //           gap: 3,
// //         }}
// //       >
// //         {/* LEFT — form (full width on the review step, since there is no sidebar there) */}
// //         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
// //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// //             {currentStepKey === 'details' && (
// //               <Step1Details
// //                 values={values}
// //                 handleChange={handleChange}
// //                 setFieldValue={setFieldValue}
// //                 errors={errors}
// //                 touched={touched}
// //                 businesses={businesses}
// //                 isAdmin={isAdmin}
// //                 fetching={fetchingBusinesses}
// //               />
// //             )}
// //             {currentStepKey === 'domains' && (
// //               <Step2Domains
// //                 values={values}
// //                 savingDomain={savingDomain}
// //                 onSaveDomain={saveDomain}
// //                 onRemoveDomain={removeDomain}
// //                 onToggleDomain={toggleDomainStatus}
// //                 updateDomainField={updateDomainField}
// //                 addDomainRow={addDomainRow}
// //                 expandedDomains={expandedDomains}
// //                 setExpandedDomains={setExpandedDomains}
// //                 appLogoUrl={values.appLogoUrl}
// //               />
// //             )}
// //             {currentStepKey === 'settings' && (
// //               <Step3Security
// //                 values={values}
// //                 handleChange={handleChange}
// //                 setFieldValue={setFieldValue}
// //                 errors={errors}
// //                 touched={touched}
// //               />
// //             )}
// //             {currentStepKey === 'review' && (
// //               <Step4Review
// //                 values={values}
// //                 setActiveStep={setActiveStep}
// //                 visibleSteps={visibleSteps}
// //                 createdByEmail={createdByEmail}
// //               />
// //             )}

// //             <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
// //               <Button
// //                 variant="outlined"
// //                 startIcon={<ArrowBackIcon />}
// //                 onClick={handleBack}
// //                 disabled={activeStep === 0}
// //                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
// //               >
// //                 Back
// //               </Button>
// //               {currentStepKey === 'review' ? (
// //                 <Button
// //                   variant="contained"
// //                   onClick={handleDone}
// //                   startIcon={<CheckCircle />}
// //                   sx={{
// //                     background: `#2563EB`,
// //                     color: '#fff',
// //                     px: 5,
// //                     py: 1.5,
// //                   }}
// //                 >
// //                   Create Application
// //                 </Button>
// //               ) : (
// //                 <Button
// //                   variant="contained"
// //                   onClick={handleNext}
// //                   disabled={isBusy}
// //                   endIcon={isBusy ? <CircularProgress size={20} color="inherit" /> : <ArrowForward />}
// //                   sx={{
// //                     background: `#2563EB`,
// //                     color: '#fff',
// //                     px: 5,
// //                     py: 1.5,
// //                   }}
// //                 >
// //                   {isBusy ? 'Processing…' : 'Save & Continue'}
// //                 </Button>
// //               )}
// //             </Box>
// //           </Paper>
// //         </Box>

// //         {/* RIGHT — preview sidebar (hidden on review, where the form takes the full width instead) */}
// //         {currentStepKey !== 'review' && (
// //           <Box
// //             sx={{
// //               flex: '0 0 auto',
// //               width: { xs: '100%', md: 600 },
// //               position: { md: 'sticky' },
// //               top: { md: 16 },
// //             }}
// //           >
// //             <PreviewSidebar
// //               values={values}
// //               showDomains={showDomains}
// //               currentStepKey={currentStepKey}
// //             />
// //           </Box>
// //         )}
// //       </Box>
// //     </Container>
// //   );
// // };

// // /* ----------------------------------------------------------------------
// //    Status badge
// // ---------------------------------------------------------------------- */
// // const StatusBadge = ({ active }) => (
// //   <Chip
// //     label={active ? 'ACTIVE' : 'INACTIVE'}
// //     size="small"
// //     sx={{
// //       fontWeight: 700,
// //       fontSize: 11,
// //       height: 22,
// //       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
// //       color: active ? C.badgeActiveText : C.badgeInactiveText,
// //     }}
// //   />
// // );

// // /* ----------------------------------------------------------------------
// //    Saved / unsaved badge (used in the domains list)
// // ---------------------------------------------------------------------- */
// // const SaveStateBadge = ({ saved }) => (
// //   <Chip
// //     label={saved ? 'Saved' : 'Unsaved'}
// //     size="small"
// //     sx={{
// //       fontWeight: 700,
// //       fontSize: 11,
// //       height: 22,
// //       bgcolor: saved ? C.badgeActiveBg : C.amberBg,
// //       color: saved ? C.badgeActiveText : C.amberText,
// //     }}
// //   />
// // );

// // /* ----------------------------------------------------------------------
// //    Inline toggle row
// // ---------------------------------------------------------------------- */
// // const InlineToggleRow = ({ label, description, checked, onChange }) => (
// //   <Box
// //     sx={{
// //       display: 'flex',
// //       alignItems: 'center',
// //       justifyContent: 'space-between',
// //       gap: 2,
// //       flexWrap: 'wrap',
// //     }}
// //   >
// //     <Typography variant="body2" noWrap sx={{ overflow: 'visible' }}>
// //       <Box component="span" fontWeight={600}>
// //         {label}
// //       </Box>
// //       {description && (
// //         <Box component="span" sx={{ color: C.textSecondary, ml: 1 }}>
// //           — {description}
// //         </Box>
// //       )}
// //     </Typography>
// //     <Switch checked={checked} onChange={onChange} color="primary" />
// //   </Box>
// // );

// // /* ----------------------------------------------------------------------
// //    Step 1 — Application Details
// // ---------------------------------------------------------------------- */
// // const Step1Details = ({
// //   values,
// //   handleChange,
// //   setFieldValue,
// //   errors,
// //   touched,
// //   businesses,
// //   isAdmin,
// //   fetching,
// // }) => {
// //   const selectedBusiness = businesses.find((b) => b._id === values.businessId) || null;
// //   const typeIcon =
// //     values.applicationType === 'MOBILE' ? <MobileIcon fontSize="small" /> : <LanguageIcon fontSize="small" />;

// //   return (
// //     <Box>
// //       <Typography variant="h6" fontWeight={700} gutterBottom>
// //         Application Details
// //       </Typography>
// //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// //         Provide basic information about your application
// //       </Typography>

// //       <SectionCard
// //         icon={typeIcon}
// //         title={values.businessName || 'New Application'}
// //         badge={<StatusBadge active={values.isActive} />}
// //         sx={{ mb: 0 }}
// //       >
// //         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //           {isAdmin && (
// //             <Box>
// //               <FieldLabel>Select Business *</FieldLabel>
// //               <Autocomplete
// //                 options={businesses}
// //                 loading={fetching}
// //                 value={selectedBusiness}
// //                 getOptionLabel={(biz) => biz.businessName || ''}
// //                 isOptionEqualToValue={(a, b) => a._id === b._id}
// //                 onChange={(_, val) => setFieldValue('businessId', val ? val._id : '')}
// //                 renderOption={(props, biz) => (
// //                   <Box component="li" {...props} key={biz._id} sx={{ justifyContent: 'space-between !important' }}>
// //                     <Box>
// //                       <Typography variant="body2" fontWeight={600}>
// //                         {biz.businessName}
// //                       </Typography>
// //                       <Typography variant="caption" color="text.secondary">
// //                         {biz._id}
// //                       </Typography>
// //                     </Box>
// //                     <StatusBadge active={biz.status !== false && biz.isActive !== false} />
// //                   </Box>
// //                 )}
// //                 renderInput={(params) => (
// //                   <TextField
// //                     {...params}
// //                     placeholder="Search and select a business"
// //                     size="medium"
// //                     error={touched.businessId && Boolean(errors.businessId)}
// //                     helperText={touched.businessId && errors.businessId}
// //                   />
// //                 )}
// //               />
// //             </Box>
// //           )}

// //           <Box>
// //             <FieldLabel>Business Name *</FieldLabel>
// //             <TextField
// //               fullWidth
// //               size="medium"
// //               name="businessName"
// //               placeholder="Enter business name to display"
// //               value={values.businessName}
// //               onChange={handleChange}
// //               error={touched.businessName && Boolean(errors.businessName)}
// //               helperText={touched.businessName && errors.businessName}
// //             />
// //           </Box>

// //           <Box>
// //             <FieldLabel>Application Type *</FieldLabel>
// //             <FormControl fullWidth size="medium" error={touched.applicationType && Boolean(errors.applicationType)}>
// //               <Select
// //                 name="applicationType"
// //                 displayEmpty
// //                 value={values.applicationType}
// //                 onChange={(e) => {
// //                   const type = e.target.value;
// //                   setFieldValue('applicationType', type);
// //                   if (type === 'MOBILE') {
// //                     setFieldValue('domains', []);
// //                   } else if (values.domains.length === 0) {
// //                     setFieldValue('domains', [emptyDomain()]);
// //                   }
// //                 }}
// //               >
// //                 <MenuItem value="" disabled>Select application type</MenuItem>
// //                 <MenuItem value="WEB">Web Application</MenuItem>
// //                 <MenuItem value="MOBILE">Mobile Application</MenuItem>
// //               </Select>
// //               {touched.applicationType && errors.applicationType && (
// //                 <FormHelperText error>{errors.applicationType}</FormHelperText>
// //               )}
// //             </FormControl>
// //           </Box>

// //           <Box>
// //             <FieldLabel>Logo URL (optional)</FieldLabel>
// //             <TextField
// //               fullWidth
// //               size="medium"
// //               name="appLogoUrl"
// //               placeholder="https://example.com/logo.png"
// //               value={values.appLogoUrl}
// //               onChange={handleChange}
// //               error={touched.appLogoUrl && Boolean(errors.appLogoUrl)}
// //               helperText={touched.appLogoUrl && errors.appLogoUrl}
// //             />
// //           </Box>

// //           <Box>
// //             <FieldLabel>Preview</FieldLabel>
// //             <Box
// //               sx={{
// //                 border: `1px solid ${C.border}`,
// //                 borderRadius: 2,
// //                 width: 96,
// //                 height: 96,
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 bgcolor: C.bgLight,
// //                 overflow: 'hidden',
// //                 p: 1,
// //               }}
// //             >
// //               {values.appLogoUrl ? (
// //                 <Box
// //                   component="img"
// //                   src={values.appLogoUrl}
// //                   alt="logo preview"
// //                   sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
// //                 />
// //               ) : (
// //                 <Typography variant="caption" color="text.secondary">
// //                   No logo
// //                 </Typography>
// //               )}
// //             </Box>
// //           </Box>

// //           <Box>
// //             <FieldLabel>Description</FieldLabel>
// //             <TextField
// //               fullWidth
// //               size="medium"
// //               multiline
// //               minRows={2}
// //               name="description"
// //               placeholder="Enter application description"
// //               value={values.description}
// //               onChange={handleChange}
// //               error={touched.description && Boolean(errors.description)}
// //               helperText={touched.description && errors.description}
// //             />
// //           </Box>
// //         </Box>

// //         <Divider sx={{ my: 2.5 }} />

// //         <FormControlLabel
// //           control={
// //             <Switch
// //               checked={values.isActive}
// //               onChange={(e) => setFieldValue('isActive', e.target.checked)}
// //               color="primary"
// //             />
// //           }
// //           label={
// //             <Box>
// //               <Typography variant="body2" fontWeight={600}>
// //                 Enable Application
// //               </Typography>
// //               <Typography variant="caption" color="text.secondary">
// //                 Application will be active after creation
// //               </Typography>
// //             </Box>
// //           }
// //         />
// //       </SectionCard>
// //     </Box>
// //   );
// // };

// // /* ----------------------------------------------------------------------
// //    Preview sidebar (wider, tighter internal spacing)
// // ---------------------------------------------------------------------- */
// // const NEXT_STEP_COPY = {
// //   details: 'Configure domains, URLs, and redirect settings for your application.',
// //   domains: 'Set up block duration, failed-attempt limits, and other security settings.',
// //   settings: 'Review everything and create your application.',
// //   review: 'You’re all set — hit “Create Application” to finish up.',
// // };

// // const PreviewSidebar = ({ values, showDomains, currentStepKey }) => {
// //   const initials = (values.businessName || 'AP').slice(0, 2).toUpperCase();
// //   const logoUrl = values.appLogoUrl || null;
// //   const nextStepText =
// //     currentStepKey === 'details' && !showDomains
// //       ? 'Configure security and access-control settings for your application.'
// //       : NEXT_STEP_COPY[currentStepKey] || NEXT_STEP_COPY.details;

// //   return (
// //     <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// //       <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
// //         Application Preview
// //       </Typography>
// //       <Box
// //         sx={{
// //           border: `1px solid ${C.border}`,
// //           borderRadius: 2,
// //           p: 3,
// //           textAlign: 'center',
// //           mb: 2.5,
// //         }}
// //       >
// //         <Box
// //           sx={{
// //             width: 104,
// //             height: 104,
// //             borderRadius: '50%',
// //             bgcolor: C.indigo,
// //             color: '#fff',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             fontSize: 34,
// //             fontWeight: 700,
// //             mx: 'auto',
// //             mb: 1.5,
// //             overflow: 'hidden',
// //           }}
// //         >
// //           {logoUrl ? (
// //             <Box component="img" src={logoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// //           ) : (
// //             initials
// //           )}
// //         </Box>
// //         <Typography variant="h5" fontWeight={700}>
// //           {values.businessName || 'Application Name'}
// //         </Typography>
// //         {values.applicationType && (
// //           <Chip
// //             label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
// //             size="medium"
// //             sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
// //           />
// //         )}
// //         <Typography variant="body2" color="text.secondary">
// //           {values.businessId || 'Business Name'}
// //         </Typography>
// //       </Box>

// //       <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
// //         Overview
// //       </Typography>
// //       <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
// //         {[
// //           ['Business', values.businessId || 'Not selected'],
// //           ['Type', values.applicationType === 'WEB' ? 'Web Application' : values.applicationType === 'MOBILE' ? 'Mobile Application' : '-'],
// //           ['Status', values.isActive ? 'Active after creation' : 'Inactive'],
// //           ['Domains', showDomains ? (values.domains?.length ? `${values.domains.length} configured` : 'Not configured') : 'N/A'],
// //           ['Created', '-'],
// //         ].map(([label, value]) => (
// //           <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
// //             <Typography variant="body2" color="text.secondary">
// //               {label}
// //             </Typography>
// //             <Typography variant="body2" fontWeight={600}>
// //               {value}
// //             </Typography>
// //           </Box>
// //         ))}
// //       </Box>

// //       <Box
// //         sx={{
// //           mt: 2.5,
// //           bgcolor: C.infoBg,
// //           border: `1px solid ${C.infoBorder}`,
// //           borderRadius: 2,
// //           p: 2,
// //           display: 'flex',
// //           gap: 1.5,
// //         }}
// //       >
// //         <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
// //         <Box>
// //           <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
// //             {currentStepKey === 'review' ? 'Ready to Create' : 'Next Step'}
// //           </Typography>
// //           <Typography variant="caption" sx={{ color: C.infoText }}>
// //             {nextStepText}
// //           </Typography>
// //         </Box>
// //       </Box>
// //     </Paper>
// //   );
// // };

// // /* ----------------------------------------------------------------------
// //    Step 2 — Domains & URLs
// //    Redesigned: two-column field layout, a compact inline logo preview,
// //    a clear saved/unsaved state, and a single dashed "add domain" affordance
// //    at the end of the list instead of a duplicated button inside every card.
// // ---------------------------------------------------------------------- */
// // const Step2Domains = ({
// //   values,
// //   savingDomain,
// //   onSaveDomain,
// //   onRemoveDomain,
// //   onToggleDomain,
// //   updateDomainField,
// //   addDomainRow,
// //   expandedDomains,
// //   setExpandedDomains,
// //   appLogoUrl,
// // }) => {
// //   const domains = values.domains;

// //   const toggleExpand = (index) =>
// //     setExpandedDomains((prev) => ({ ...prev, [index]: !prev[index] }));

// //   return (
// //     <Box>
// //       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 2 }}>
// //         <Box>
// //           <Typography variant="h6" fontWeight={700} gutterBottom>
// //             Domains & URLs
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             Add every domain that's allowed to access this application, along with where it should
// //             redirect after authentication.
// //           </Typography>
// //         </Box>
// //         <Chip
// //           label={`${domains.length} ${domains.length === 1 ? 'domain' : 'domains'}`}
// //           sx={{ bgcolor: C.bgLight, color: C.textPrimary, fontWeight: 700, border: `1px solid ${C.border}` }}
// //         />
// //       </Box>

// //       {domains.map((domain, index) => {
// //         const expanded = expandedDomains[index] ?? true;
// //         const domainLogoSource = domain.logoUrl || appLogoUrl || null;

// //         return (
// //           <Box
// //             key={domain._tempId || index}
// //             sx={{
// //               border: `1px solid ${domain.saved ? C.border : C.amber}44`,
// //               borderRadius: 2,
// //               mb: 2,
// //               overflow: 'hidden',
// //               transition: 'border-color 0.15s ease',
// //             }}
// //           >
// //             {/* Card header */}
// //             <Box
// //               sx={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'space-between',
// //                 px: 2.5,
// //                 py: 1.5,
// //                 bgcolor: '#fafbfc',
// //                 cursor: 'pointer',
// //               }}
// //               onClick={() => toggleExpand(index)}
// //             >
// //               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
// //                 <Avatar
// //                   variant="rounded"
// //                   sx={{
// //                     width: 36,
// //                     height: 36,
// //                     bgcolor: domain.domain ? C.indigo : C.bgLight,
// //                     color: domain.domain ? '#fff' : C.textSecondary,
// //                     border: domain.domain ? 'none' : `1px dashed ${C.border}`,
// //                   }}
// //                 >
// //                   <LanguageIcon fontSize="small" />
// //                 </Avatar>
// //                 <Box sx={{ minWidth: 0 }}>
// //                   <Typography variant="body1" fontWeight={700} noWrap>
// //                     {domain.domain || 'New Domain'}
// //                   </Typography>
// //                   {!expanded && (
// //                     <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// //                       {domain.redirectUrl && getPath(domain.redirectUrl)
// //                         ? domain.redirectUrl
// //                         : 'No redirect URL set'}
// //                     </Typography>
// //                   )}
// //                 </Box>
// //               </Box>
// //               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={(e) => e.stopPropagation()}>
// //                 <StatusBadge active={domain.status} />
// //                 <SaveStateBadge saved={domain.saved} />
// //                 <Button
// //                   size="small"
// //                   onClick={() => onRemoveDomain(index)}
// //                   disabled={savingDomain}
// //                   sx={{ color: '#e53e3e', minWidth: 'auto' }}
// //                 >
// //                   Remove
// //                 </Button>
// //                 <IconButton size="small" onClick={() => toggleExpand(index)}>
// //                   {expanded ? <ExpandLess /> : <ExpandMore />}
// //                 </IconButton>
// //               </Box>
// //             </Box>

// //             {expanded && (
// //               <Box sx={{ p: 2.5 }}>
// //                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //                   <Box>
// //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //                       Domain *
// //                     </Typography>
// //                     <TextField
// //                       fullWidth
// //                       placeholder="example.com"
// //                       value={domain.domain}
// //                       onChange={(e) => updateDomainField(index, 'domain', e.target.value)}
// //                       size="medium"
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //                       Display Name *
// //                     </Typography>
// //                     <TextField
// //                       fullWidth
// //                       placeholder="Marketing Site"
// //                       value={domain.displayName}
// //                       onChange={(e) => updateDomainField(index, 'displayName', e.target.value)}
// //                       size="medium"
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //                       Redirect URL *
// //                     </Typography>
// //                     <TextField
// //                       fullWidth
// //                       value={getPath(domain.redirectUrl)}
// //                       onChange={(e) =>
// //                         updateDomainField(
// //                           index,
// //                           'redirectUrl',
// //                           `${getProtocol(domain.redirectUrl)}://${e.target.value}`
// //                         )
// //                       }
// //                       size="medium"
// //                       InputProps={{
// //                         startAdornment: (
// //                           <InputAdornment position="start">
// //                             <Select
// //                               variant="standard"
// //                               disableUnderline
// //                               value={getProtocol(domain.redirectUrl)}
// //                               onChange={(e) =>
// //                                 updateDomainField(
// //                                   index,
// //                                   'redirectUrl',
// //                                   `${e.target.value}://${getPath(domain.redirectUrl)}`
// //                                 )
// //                               }
// //                               sx={{ mr: 1 }}
// //                             >
// //                               <MenuItem value="https">https</MenuItem>
// //                               <MenuItem value="http">http</MenuItem>
// //                             </Select>
// //                           </InputAdornment>
// //                         ),
// //                       }}
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //                       Logo URL (optional)
// //                     </Typography>
// //                     <TextField
// //                       fullWidth
// //                       placeholder="https://example.com/domain-logo.png"
// //                       value={domain.logoUrl}
// //                       onChange={(e) => updateDomainField(index, 'logoUrl', e.target.value)}
// //                       size="medium"
// //                       helperText="Overrides the application logo for this domain, if provided."
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //                       Preview
// //                     </Typography>
// //                     <Box
// //                       sx={{
// //                         border: `1px solid ${C.border}`,
// //                         borderRadius: 2,
// //                         width: 96,
// //                         height: 96,
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         bgcolor: C.bgLight,
// //                         overflow: 'hidden',
// //                         p: 1,
// //                       }}
// //                     >
// //                       {domainLogoSource ? (
// //                         <Box
// //                           component="img"
// //                           src={domainLogoSource}
// //                           alt="logo preview"
// //                           sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
// //                         />
// //                       ) : (
// //                         <Typography variant="caption" color="text.secondary">
// //                           No logo
// //                         </Typography>
// //                       )}
// //                     </Box>
// //                   </Box>
// //                 </Box>

// //                 <Divider sx={{ my: 2.5 }} />

// //                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
// //                   <FormControlLabel
// //                     control={<Switch checked={domain.status} onChange={() => onToggleDomain(index)} />}
// //                     label={domain.status ? 'Active' : 'Inactive'}
// //                   />
// //                   {!domain.saved ? (
// //                     <Button
// //                       size="medium"
// //                       variant="contained"
// //                       onClick={() => onSaveDomain(index)}
// //                       disabled={savingDomain}
// //                       sx={{ background: C.blue, px: 4 }}
// //                     >
// //                       {savingDomain ? <CircularProgress size={20} color="inherit" /> : 'Save Domain'}
// //                     </Button>
// //                   ) : (
// //                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: C.badgeActiveText }}>
// //                       <CheckCircle fontSize="small" />
// //                       <Typography variant="body2" fontWeight={600}>
// //                         Saved — edit any field to make changes
// //                       </Typography>
// //                     </Box>
// //                   )}
// //                 </Box>
// //               </Box>
// //             )}
// //           </Box>
// //         );
// //       })}

// //       {/* Single, clear entry point for adding another domain */}
// //       <Box
// //         onClick={addDomainRow}
// //         sx={{
// //           border: `1.5px dashed ${C.border}`,
// //           borderRadius: 2,
// //           py: 2,
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           gap: 1,
// //           cursor: 'pointer',
// //           color: C.blue,
// //           transition: 'background-color 0.15s ease, border-color 0.15s ease',
// //           '&:hover': { bgcolor: C.infoBg, borderColor: C.blue },
// //         }}
// //       >
// //         <AddIcon fontSize="small" />
// //         <Typography variant="body2" fontWeight={700}>
// //           Add another domain
// //         </Typography>
// //       </Box>
// //     </Box>
// //   );
// // };

// // /* ----------------------------------------------------------------------
// //    Step 3 — Security & Settings
// // ---------------------------------------------------------------------- */
// // const Step3Security = ({ values, handleChange, setFieldValue, errors, touched }) => (
// //   <Box>
// //     <Typography variant="h6" fontWeight={700} gutterBottom>
// //       Security & Settings
// //     </Typography>
// //     <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// //       Configure security options and additional settings for this application.
// //     </Typography>

// //     <SectionCard icon={<LockIcon fontSize="small" />} title="Security Settings">
// //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //         <Box>
// //           <FieldLabel>Block Duration *</FieldLabel>
// //           <FormControl fullWidth size="medium" error={touched.blockDuration && Boolean(errors.blockDuration)}>
// //             <Select name="blockDuration" value={values.blockDuration} onChange={handleChange}>
// //               {BLOCK_DURATION_OPTIONS.map((v) => (
// //                 <MenuItem key={v} value={v}>
// //                   {v} minutes
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //             {touched.blockDuration && errors.blockDuration ? (
// //               <FormHelperText error>{errors.blockDuration}</FormHelperText>
// //             ) : (
// //               <FormHelperText>Duration for blocking after suspicious activity.</FormHelperText>
// //             )}
// //           </FormControl>
// //         </Box>

// //         <Box>
// //           <FieldLabel>Failed Attempts *</FieldLabel>
// //           <FormControl fullWidth size="medium" error={touched.failedAttempts && Boolean(errors.failedAttempts)}>
// //             <Select name="failedAttempts" value={values.failedAttempts} onChange={handleChange}>
// //               {FAILED_ATTEMPTS_OPTIONS.map((v) => (
// //                 <MenuItem key={v} value={v}>
// //                   {v} attempts
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //             {touched.failedAttempts && errors.failedAttempts ? (
// //               <FormHelperText error>{errors.failedAttempts}</FormHelperText>
// //             ) : (
// //               <FormHelperText>Failed attempts before blocking.</FormHelperText>
// //             )}
// //           </FormControl>
// //         </Box>
// //       </Box>

// //       <Divider sx={{ my: 2.5 }} />

// //       <FormControlLabel
// //         control={
// //           <Switch
// //             checked={values.ipGeolocationEnabled}
// //             onChange={(e) => setFieldValue('ipGeolocationEnabled', e.target.checked)}
// //             color="primary"
// //           />
// //         }
// //         label={
// //           <Box>
// //             <Typography variant="body2" fontWeight={600}>
// //               IP Allowlisting
// //             </Typography>
// //             <Typography variant="caption" color="text.secondary">
// //               Restrict access to specific IP addresses
// //             </Typography>
// //           </Box>
// //         }
// //       />
// //     </SectionCard>

// //     <SectionCard icon={<SettingsIcon fontSize="small" />} title="Advanced Settings">
// //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //         <Box>
// //           <FieldLabel>Webhook URL</FieldLabel>
// //           <TextField
// //             fullWidth
// //             size="medium"
// //             name="webhookUrl"
// //             placeholder="https://example.com/webhook/auth-events"
// //             value={values.webhookUrl}
// //             onChange={handleChange}
// //             error={touched.webhookUrl && Boolean(errors.webhookUrl)}
// //             helperText={
// //               (touched.webhookUrl && errors.webhookUrl) || 'Receive real-time notifications and events.'
// //             }
// //           />
// //         </Box>

// //         <Box>
// //           <FieldLabel>Metadata (JSON)</FieldLabel>
// //           <TextField
// //             fullWidth
// //             size="medium"
// //             multiline
// //             minRows={3}
// //             name="metadataJson"
// //             value={values.metadataJson}
// //             onChange={handleChange}
// //             error={Boolean(errors.metadataJson)}
// //             helperText={errors.metadataJson}
// //             InputProps={{
// //               sx: {
// //                 fontFamily: 'Menlo, Consolas, monospace',
// //                 fontSize: 13,
// //                 bgcolor: '#f7fafc',
// //               },
// //             }}
// //           />
// //         </Box>
// //       </Box>
// //     </SectionCard>

// //     <SectionCard
// //       icon={<PersonOutlineIcon fontSize="small" />}
// //       title="Application Status"
// //       badge={<StatusBadge active={values.isActive} />}
// //       sx={{ mb: 0 }}
// //     >
// //       <FormControlLabel
// //         control={
// //           <Switch
// //             checked={values.isActive}
// //             onChange={(e) => setFieldValue('isActive', e.target.checked)}
// //             color="primary"
// //           />
// //         }
// //         label={
// //           <Box>
// //             <Typography variant="body2" fontWeight={600}>
// //               Enable Application
// //             </Typography>
// //             <Typography variant="caption" color="text.secondary">
// //               Application will be active after creation
// //             </Typography>
// //           </Box>
// //         }
// //       />
// //     </SectionCard>
// //   </Box>
// // );

// // /* ----------------------------------------------------------------------
// //    Step 4 — Review & Create
// //    Redesigned to use the full width of the page now that the preview
// //    sidebar is gone: a hero summary, a row of at-a-glance stat tiles, and
// //    the detail sections laid out two-up instead of stacked in a single
// //    narrow column.
// // ---------------------------------------------------------------------- */
// // const SummarySection = ({ title, onEdit, children, sx }) => (
// //   <Paper variant="outlined" sx={{ p: 2.5, borderColor: C.border, borderRadius: 2, height: '100%', ...sx }}>
// //     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
// //       <Typography variant="subtitle1" fontWeight={700}>
// //         {title}
// //       </Typography>
// //       {onEdit && (
// //         <Button size="small" startIcon={<EditOutlined fontSize="small" />} onClick={onEdit} sx={{ color: C.blue }}>
// //           Edit
// //         </Button>
// //       )}
// //     </Box>
// //     {children}
// //   </Paper>
// // );

// // const StatTile = ({ icon, label, value }) => (
// //   <Paper
// //     variant="outlined"
// //     sx={{
// //       p: 2,
// //       borderColor: C.border,
// //       borderRadius: 2,
// //       display: 'flex',
// //       alignItems: 'center',
// //       gap: 1.5,
// //       height: '100%',
// //     }}
// //   >
// //     <Box
// //       sx={{
// //         width: 40,
// //         height: 40,
// //         borderRadius: 2,
// //         bgcolor: C.infoBg,
// //         color: C.infoText,
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'center',
// //         flexShrink: 0,
// //       }}
// //     >
// //       {icon}
// //     </Box>
// //     <Box sx={{ minWidth: 0 }}>
// //       <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
// //         {label}
// //       </Typography>
// //       <Typography variant="body1" fontWeight={700} noWrap>
// //         {value}
// //       </Typography>
// //     </Box>
// //   </Paper>
// // );

// // const Step4Review = ({ values, setActiveStep, visibleSteps, createdByEmail }) => {
// //   const showDomains = values.applicationType === 'WEB';
// //   const stepIndex = (key) => visibleSteps.findIndex((s) => s.key === key);
// //   const metadataCount = (() => {
// //     try {
// //       return Object.keys(JSON.parse(values.metadataJson || '{}')).length;
// //     } catch {
// //       return 0;
// //     }
// //   })();

// //   const detailRow = (label, value) => (
// //     <Grid item xs={12} sm={6} key={label}>
// //       <Typography variant="body2" color="text.secondary">
// //         {label}
// //       </Typography>
// //       <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
// //         {value}
// //       </Typography>
// //     </Grid>
// //   );

// //   return (
// //     <Box>
// //       <Typography variant="h6" fontWeight={700} gutterBottom>
// //         Review & Create
// //       </Typography>
// //       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
// //         Confirm all details before creating the application.
// //       </Typography>

// //       {/* Hero summary */}
// //       <Paper
// //         variant="outlined"
// //         sx={{
// //           p: 3,
// //           mb: 3,
// //           borderColor: C.border,
// //           borderRadius: 3,
// //           bgcolor: C.bgLight,
// //         }}
// //       >
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
// //           <Box
// //             sx={{
// //               width: 64,
// //               height: 64,
// //               borderRadius: '50%',
// //               bgcolor: C.indigo,
// //               color: '#fff',
// //               display: 'flex',
// //               alignItems: 'center',
// //               justifyContent: 'center',
// //               fontSize: 24,
// //               fontWeight: 700,
// //               flexShrink: 0,
// //               overflow: 'hidden',
// //             }}
// //           >
// //             {values.appLogoUrl ? (
// //               <Box component="img" src={values.appLogoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
// //             ) : (
// //               (values.businessName || 'AP').slice(0, 2).toUpperCase()
// //             )}
// //           </Box>
// //           <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
// //             <Typography variant="h5" fontWeight={800} noWrap>
// //               {values.businessName || 'Application'}
// //             </Typography>
// //             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
// //               <Chip
// //                 label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
// //                 size="small"
// //                 sx={{ bgcolor: '#fff', color: C.textPrimary, fontWeight: 600, border: `1px solid ${C.border}` }}
// //               />
// //               <StatusBadge active={values.isActive} />
// //             </Box>
// //           </Box>
// //           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: C.textSecondary }}>
// //             <PersonOutlineIcon fontSize="small" />
// //             <Box>
// //               <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
// //                 Created by
// //               </Typography>
// //               <Typography variant="body2" fontWeight={700}>
// //                 {createdByEmail}
// //               </Typography>
// //             </Box>
// //           </Box>
// //         </Box>
// //       </Paper>

// //       {/* At-a-glance stat tiles — fills the width freed up by removing the sidebar */}
// //       <Grid container spacing={2} sx={{ mb: 3 }}>
// //         <Grid item xs={6} md={3}>
// //           <StatTile
// //             icon={<PublicIcon fontSize="small" />}
// //             label="Domains"
// //             value={showDomains ? values.domains.length : 'N/A'}
// //           />
// //         </Grid>
// //         <Grid item xs={6} md={3}>
// //           <StatTile
// //             icon={<AccessTimeIcon fontSize="small" />}
// //             label="Block Duration"
// //             value={`${values.blockDuration} min`}
// //           />
// //         </Grid>
// //         <Grid item xs={6} md={3}>
// //           <StatTile
// //             icon={<LockIcon fontSize="small" />}
// //             label="Failed Attempts"
// //             value={`${values.failedAttempts}`}
// //           />
// //         </Grid>
// //         <Grid item xs={6} md={3}>
// //           <StatTile
// //             icon={<VerifiedUserIcon fontSize="small" />}
// //             label="IP Allowlisting"
// //             value={values.ipGeolocationEnabled ? 'Enabled' : 'Disabled'}
// //           />
// //         </Grid>
// //       </Grid>

// //       {/* Two-up detail sections instead of a single stacked column */}
// //       <Grid container spacing={3} sx={{ mb: showDomains ? 3 : 0 }}>
// //         <Grid item xs={12} md={6}>
// //           <SummarySection title="Application Details" onEdit={() => setActiveStep(stepIndex('details'))}>
// //             <Grid container spacing={2}>
// //               {detailRow('Application Name', values.businessName)}
// //               {detailRow('Application Type', values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application')}
// //               {detailRow('Business', values.businessId || 'N/A')}
// //               {detailRow('Description', values.description || 'Not provided')}
// //             </Grid>
// //           </SummarySection>
// //         </Grid>

// //         <Grid item xs={12} md={6}>
// //           <SummarySection title="Security & Settings" onEdit={() => setActiveStep(stepIndex('settings'))}>
// //             <Grid container spacing={2}>
// //               {detailRow('Block Duration', `${values.blockDuration} minutes`)}
// //               {detailRow('Failed Attempts Before Block', `${values.failedAttempts} attempts`)}
// //               {detailRow('IP Allowlisting', values.ipGeolocationEnabled ? 'Enabled' : 'Disabled')}
// //               {detailRow('Webhook URL', values.webhookUrl || 'Not configured')}
// //               {detailRow('Metadata', metadataCount > 0 ? `${metadataCount} keys configured` : 'None')}
// //             </Grid>
// //           </SummarySection>
// //         </Grid>
// //       </Grid>

// //       {showDomains && (
// //         <SummarySection title="Domains & URLs" onEdit={() => setActiveStep(stepIndex('domains'))}>
// //           <TableContainer>
// //             <Table size="small">
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell>Domain</TableCell>
// //                   <TableCell>Display Name</TableCell>
// //                   <TableCell>Redirect URL</TableCell>
// //                   <TableCell>Logo</TableCell>
// //                   <TableCell>Status</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {values.domains.map((d, idx) => (
// //                   <TableRow key={idx}>
// //                     <TableCell>{d.domain}</TableCell>
// //                     <TableCell>{d.displayName || '-'}</TableCell>
// //                     <TableCell>{d.redirectUrl}</TableCell>
// //                     <TableCell>{d.logoUrl ? '✓' : '-'}</TableCell>
// //                     <TableCell>
// //                       <StatusBadge active={d.status} />
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>
// //           </TableContainer>
// //         </SummarySection>
// //       )}
// //     </Box>
// //   );
// // };

// // export default CreateApplicationPage;


// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   FormControlLabel,
//   Switch,
//   Radio,
//   RadioGroup,
//   IconButton,
//   Alert,
//   CircularProgress,
//   Paper,
//   Grid,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Autocomplete,
//   Breadcrumbs,
//   Link as MuiLink,
//   Chip,
//   InputAdornment,
//   FormHelperText,
//   Avatar,
// } from '@mui/material';
// import {
//   Add as AddIcon,
//   Delete as DeleteIcon,
//   ArrowForward,
//   ArrowBack as ArrowBackIcon,
//   CheckCircle,
//   Language as LanguageIcon,
//   ExpandMore,
//   ExpandLess,
//   CloudUpload,
//   InfoOutlined,
//   EditOutlined,
//   AccessTime as AccessTimeIcon,
//   Lock as LockIcon,
//   Public as PublicIcon,
//   VerifiedUser as VerifiedUserIcon,
//   PersonOutline as PersonOutlineIcon,
//   PhoneIphone as MobileIcon,
//   Settings as SettingsIcon,
// } from '@mui/icons-material';
// import { adminService } from '../services/admin';
// import { useAuth } from '../context/AuthContext';
// import { ROUTES } from '../utils/constants';

// /* ----------------------------------------------------------------------
//    Real APIs are wired in. If you ever need to go back to mocks for local
//    UI work, reintroduce a USE_MOCK flag + mock service — removed here
//    since we're now calling the real backend everywhere.
// ---------------------------------------------------------------------- */

// /* ----------------------------------------------------------------------
//    Design tokens
// ---------------------------------------------------------------------- */
// const C = {
//   border: '#e2e8f0',
//   blue: '#3182ce',
//   blueDark: '#2b6cb0',
//   green: '#38a169',
//   greenDark: '#276749',
//   indigo: '#4c51bf',
//   amber: '#dd6b20',
//   amberBg: '#feebc8',
//   amberText: '#9c4221',
//   textPrimary: '#1a202c',
//   textSecondary: '#718096',
//   bgLight: '#f7fafc',
//   badgeActiveBg: '#c6f6d5',
//   badgeActiveText: '#276749',
//   badgeInactiveBg: '#e2e8f0',
//   badgeInactiveText: '#4a5568',
//   infoBg: '#ebf8ff',
//   infoBorder: '#bee3f8',
//   infoText: '#2c5282',
// };

// /* ----------------------------------------------------------------------
//    Validation schemas
// ---------------------------------------------------------------------- */
// const detailsSchema = Yup.object({
//   businessId: Yup.string().required('Business is required'),
//   applicationType: Yup.string()
//     .oneOf(['WEB', 'MOBILE'])
//     .required('Application type is required'),
//   businessName: Yup.string().required('Display name is required').max(100),
//   description: Yup.string().max(500),
//   isActive: Yup.boolean(),
//   appLogoUrl: Yup.string().url('Invalid URL').nullable(),
// });

// const settingsSchema = Yup.object({
//   blockDuration: Yup.number()
//     .min(1, 'Min 1 minute')
//     .max(1440, 'Max 1440 minutes')
//     .required('Required'),
//   failedAttempts: Yup.number()
//     .min(1, 'Min 1')
//     .max(99, 'Max 99')
//     .required('Required'),
//   ipGeolocationEnabled: Yup.boolean(),
//   webhookUrl: Yup.string().url('Invalid URL').nullable(),
//   metadataJson: Yup.string().test(
//     'is-json',
//     'Metadata must be valid JSON',
//     (val) => {
//       if (!val || !val.trim()) return true;
//       try {
//         JSON.parse(val);
//         return true;
//       } catch {
//         return false;
//       }
//     }
//   ),
// });

// /* Step definitions. The "domains" step is filtered out entirely for
//    MOBILE applications. */
// const ALL_STEPS = [
//   { key: 'details', label: 'Application Details', subtitle: 'Basic information' },
//   { key: 'domains', label: 'Domains & URLs', subtitle: 'Configure domains and URLs' },
//   { key: 'settings', label: 'Security & Settings', subtitle: 'Security and access control' },
//   { key: 'review', label: 'Review & Create', subtitle: 'Review and create application' },
// ];

// const BLOCK_DURATION_OPTIONS = [5, 15, 30, 60, 120, 240, 1440];
// const FAILED_ATTEMPTS_OPTIONS = [3, 5, 10, 15, 20, 25];

// const emptyDomain = () => ({
//   id: null,
//   // The real API has no domain-id — a domain is addressed by its
//   // domainName in the URL (PUT/DELETE .../domains/:domainName/:appId).
//   // We track the name it was LAST SAVED under separately from the
//   // (possibly edited, not-yet-saved) `domain` field below.
//   savedDomainName: null,
//   domain: '',
//   displayName: '',
//   redirectUrl: 'https://',
//   status: true,
//   saved: false,
//   logoUrl: '', // only URL, no radio selection
//   _tempId: Date.now() + Math.random(),
// });

// const getProtocol = (url = '') => (url.startsWith('http://') ? 'http' : 'https');
// const getPath = (url = '') => url.replace(/^https?:\/\//, '');

// /* ----------------------------------------------------------------------
//    Section Card – the shared "domain card" visual language: a bordered,
//    rounded container with a light-grey header (icon avatar + title +
//    optional badge/action) and top-labelled fields in the body. Reused
//    across every step so the whole wizard reads as one consistent system.
// ---------------------------------------------------------------------- */
// const SectionCard = ({ icon, title, badge, action, children, sx }) => (
//   <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         px: 2.5,
//         py: 1.5,
//         bgcolor: '#fafbfc',
//         flexWrap: 'wrap',
//         gap: 1,
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
//         {icon && (
//           <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
//             {icon}
//           </Avatar>
//         )}
//         <Typography variant="body1" fontWeight={700} noWrap>
//           {title}
//         </Typography>
//       </Box>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {badge}
//         {action}
//       </Box>
//     </Box>
//     <Box sx={{ p: 2.5 }}>{children}</Box>
//   </Box>
// );

// /* Field label used above every input inside a SectionCard, matching the
//    domain fields' top-label style. */
// const FieldLabel = ({ children }) => (
//   <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//     {children}
//   </Typography>
// );

// /* ----------------------------------------------------------------------
//    Main Component
// ---------------------------------------------------------------------- */
// const CreateApplicationPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { isAdmin, businessId: userBusinessId, user, email: authEmail } = useAuth();

//   // Resolve the signed-in admin's email defensively, since the exact shape
//   // of the auth context can vary (user.email, top-level email, username, etc).
//   const createdByEmail =
//     user?.email || authEmail || user?.username || user?.name || 'Unknown user';

//   const [activeStep, setActiveStep] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [businesses, setBusinesses] = useState([]);
//   const [fetchingBusinesses, setFetchingBusinesses] = useState(false);
//   const [submitError, setSubmitError] = useState('');
//   const [appId, setAppId] = useState(null);
//   const [savingDomain, setSavingDomain] = useState(false);
//   const [savingSettings, setSavingSettings] = useState(false);
//   // Tracks whether settings have already been POSTed for this app, so a
//   // second save on Step 3 (e.g. user goes Back and edits again) calls the
//   // update (PUT) endpoint instead of trying to create them again.
//   const [settingsSaved, setSettingsSaved] = useState(false);
//   const [expandedDomains, setExpandedDomains] = useState({ 0: true });

//   const preselectedBusinessId = new URLSearchParams(location.search).get('businessId');

//   const formik = useFormik({
//     initialValues: {
//       businessId: preselectedBusinessId || (isAdmin ? '' : userBusinessId || ''),
//       applicationType: 'WEB', // default to WEB
//       description: '',
//       businessName: '',
//       isActive: true,
//       domains: [emptyDomain()],
//       blockDuration: 30,
//       failedAttempts: 5,
//       ipGeolocationEnabled: false,
//       webhookUrl: '',
//       metadataJson: '{\n  \n}',
//       appLogoUrl: '',
//     },
//     validateOnChange: true,
//   });

//   const { values, handleChange, setFieldValue, errors, touched } = formik;

//   // Fetch businesses if admin
//   useEffect(() => {
//     if (isAdmin) {
//       setFetchingBusinesses(true);
//       adminService
//         .getAllBusinesses(0, 100)
//         .then((data) => {
//           let list = [];
//           if (Array.isArray(data)) list = data;
//           else if (data.businesses && Array.isArray(data.businesses)) list = data.businesses;
//           else if (data.data && Array.isArray(data.data)) list = data.data;
//           setBusinesses(list);
//         })
//         .catch(() => {})
//         .finally(() => setFetchingBusinesses(false));
//     }
//   }, [isAdmin]);

//   useEffect(() => {
//     if (!isAdmin && userBusinessId) {
//       setFieldValue('businessId', userBusinessId);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAdmin, userBusinessId]);

//   const showDomains = values.applicationType === 'WEB';

//   const visibleSteps = ALL_STEPS.filter((s) => s.key !== 'domains' || showDomains);
//   const currentStepKey = visibleSteps[activeStep]?.key;

//   const goNextIndex = () => setActiveStep((i) => Math.min(i + 1, visibleSteps.length - 1));
//   const goPrevIndex = () => setActiveStep((i) => Math.max(i - 1, 0));

//   /* ---------------- API calls ---------------- */

//   // STEP 1 → POST /api/business-apps
//   // { businessId, appName, appDescription, appType }  (appType is lowercase
//   // on the backend: "web" / "mobile" — the form itself keeps 'WEB'/'MOBILE'
//   // uppercase for the UI, so it's lowercased only in the outgoing payload.)
//   //
//   // The response shape from this endpoint hasn't been confirmed yet — the
//   // extraction below tries the common shapes. If appId ends up null, open
//   // devtools, check the network response for this call, and adjust the
//   // `newAppId = ...` line to match the actual key.
//   const createApplication = async () => {
//     try {
//       await detailsSchema.validate(values, { abortEarly: false });
//     } catch (err) {
//       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
//       setSubmitError('Please fill in all required fields.');
//       return;
//     }
//     setLoading(true);
//     setSubmitError('');
//     try {
//       const payload = {
//         businessId: values.businessId,
//         appName: values.businessName,
//         appDescription: values.description,
//         appType: values.applicationType.toLowerCase(), // 'web' | 'mobile'
//       };
//       const response = await adminService.createBusinessApp(payload);

//       // TODO: confirm the real key once you've seen a live response.
//       const newAppId =
//         response?.appId ||
//         response?.id ||
//         response?._id ||
//         response?.data?.appId ||
//         response?.data?.id ||
//         response?.data?._id;

//       if (!newAppId) {
//         console.warn('createBusinessApp response did not contain a recognizable app id:', response);
//         throw new Error('App ID not returned');
//       }

//       setAppId(newAppId);

//       // appLogoUrl / isActive aren't in the create payload above (not in
//       // the documented create endpoint). If the backend supports setting
//       // them on create, add them to `payload`; otherwise they can be sent
//       // via updateBusinessApp (PUT /api/business-apps/:id) here instead:
//       if (values.appLogoUrl || values.isActive === false) {
//         try {
//           await adminService.updateBusinessApp(newAppId, {
//             appName: values.businessName,
//             appDescription: values.description,
//           });
//         } catch {
//           // non-fatal — app was still created
//         }
//       }

//       goNextIndex();
//     } catch (err) {
//       setSubmitError(err.message || 'Failed to create application');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // STEP 3 → first save: POST /api/business-apps/settings/:appId
//   //          later saves: PUT  /api/business-apps/settings/:appId
//   // Body uses blockDuration as a STRING ("30 minutes") and
//   // failedAttemptsBeforeBlock (not failedAttempts).
//   const saveSettings = async () => {
//     try {
//       await settingsSchema.validate(values, { abortEarly: false });
//     } catch (err) {
//       err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
//       setSubmitError(err.errors?.[0] || 'Please fill in all required settings.');
//       return;
//     }
//     if (!appId) {
//       setSubmitError('Application not created yet.');
//       return;
//     }
//     setSavingSettings(true);
//     setSubmitError('');
//     try {
//       let metadataObj = {};
//       if (values.metadataJson && values.metadataJson.trim()) {
//         metadataObj = JSON.parse(values.metadataJson);
//       }
//       const settingsPayload = {
//         blockDuration: `${values.blockDuration} minutes`,
//         failedAttemptsBeforeBlock: values.failedAttempts,
//         webhookUrl: values.webhookUrl || undefined,
//         metadata: metadataObj,
//         enabled: values.isActive,
//       };

//       if (settingsSaved) {
//         await adminService.updateAppSettings(appId, settingsPayload);
//       } else {
//         await adminService.addAppSettings(appId, settingsPayload);
//         setSettingsSaved(true);
//       }

//       goNextIndex();
//     } catch (err) {
//       setSubmitError(err.message || 'Failed to save settings');
//     } finally {
//       setSavingSettings(false);
//     }
//   };

//   /* ---------------- Domain handlers ---------------- */
//   const addDomainRow = () => {
//     const next = [...values.domains, emptyDomain()];
//     setFieldValue('domains', next);
//     setExpandedDomains((prev) => ({ ...prev, [next.length - 1]: true }));
//   };

//   const updateDomainField = (index, field, value) => {
//     const updated = values.domains.map((d, i) =>
//       i === index ? { ...d, [field]: value, saved: field === 'status' ? d.saved : false } : d
//     );
//     setFieldValue('domains', updated);
//   };

//   // POST /api/business-apps/domains/:appId            (first save)
//   // PUT  /api/business-apps/domains/:domainName/:appId (re-save — keyed by
//   //       the name it was PREVIOUSLY saved under, since there's no domain id)
//   const saveDomain = async (index) => {
//     const domain = values.domains[index];
//     if (!domain.domain.trim() || !getPath(domain.redirectUrl).trim()) {
//       setSubmitError('Domain and Redirect URL are required.');
//       return;
//     }
//     if (!appId) {
//       setSubmitError('Application not created yet.');
//       return;
//     }
//     setSavingDomain(true);
//     setSubmitError('');
//     try {
//       const payload = {
//         domainName: domain.domain,
//         displayName: domain.displayName,
//         redirectUrl: domain.redirectUrl,
//         logoUrl: domain.logoUrl || undefined,
//         enabled: domain.status,
//       };

//       if (domain.saved && domain.savedDomainName) {
//         await adminService.updateAppDomain(domain.savedDomainName, appId, payload);
//       } else {
//         await adminService.addAppDomain(appId, payload);
//       }

//       const updated = values.domains.map((d, i) =>
//         i === index ? { ...d, id: true, savedDomainName: domain.domain, saved: true } : d
//       );
//       setFieldValue('domains', updated);
//       setExpandedDomains((prev) => ({ ...prev, [index]: false }));
//     } catch (err) {
//       setSubmitError(err.message || 'Failed to save domain');
//     } finally {
//       setSavingDomain(false);
//     }
//   };

//   // DELETE /api/business-apps/domains/:domainName/:appId
//   const removeDomain = async (index) => {
//     const domain = values.domains[index];
//     if (domain.saved && domain.savedDomainName && appId) {
//       setSavingDomain(true);
//       try {
//         await adminService.deleteAppDomain(domain.savedDomainName, appId);
//       } catch (err) {
//         setSubmitError(err.message || 'Failed to delete domain');
//         setSavingDomain(false);
//         return;
//       }
//     }
//     const updated = values.domains.filter((_, i) => i !== index);
//     setFieldValue('domains', updated.length ? updated : [emptyDomain()]);
//     setSavingDomain(false);
//   };

//   // Reuses the same PUT .../domains/:domainName/:appId endpoint, sending
//   // only the enabled flag. Confirm the backend accepts a partial body here —
//   // if it requires the full domain object, swap this for a full payload.
//   const toggleDomainStatus = async (index) => {
//     const domain = values.domains[index];
//     updateDomainField(index, 'status', !domain.status);

//     if (domain.saved && domain.savedDomainName && appId) {
//       setSavingDomain(true);
//       try {
//         await adminService.updateAppDomain(domain.savedDomainName, appId, {
//           enabled: !domain.status,
//         });
//       } catch (err) {
//         setSubmitError(err.message || 'Failed to toggle domain status');
//         updateDomainField(index, 'status', domain.status);
//       } finally {
//         setSavingDomain(false);
//       }
//     }
//   };

//   const handleNext = async () => {
//     if (currentStepKey === 'details') {
//       await createApplication();
//     } else if (currentStepKey === 'domains') {
//       const unsaved = values.domains.filter((d) => !d.saved && d.domain.trim());
//       if (unsaved.length > 0) {
//         setSubmitError('Please save all domains before proceeding.');
//         return;
//       }
//       goNextIndex();
//     } else if (currentStepKey === 'settings') {
//       await saveSettings();
//     } else {
//       goNextIndex();
//     }
//   };

//   const handleBack = () => goPrevIndex();

//   // Review & Create step performs no API call of its own — the app,
//   // domains, and settings were already created step-by-step. This just
//   // navigates away.
//   const handleDone = () => {
//     navigate(isAdmin ? '/admin/businesses' : '/business/applications');
//   };

//   const isBusy = loading || savingSettings || savingDomain;

//   /* ---------------- Render ---------------- */
//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Box sx={{ mb: 3 }}>
//         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
//           <MuiLink underline="hover" color="text.secondary" href="#" onClick={(e) => e.preventDefault()}>
//             Applications
//           </MuiLink>
//           <Typography color="text.primary" fontSize={13} fontWeight={600}>
//             Create Application
//           </Typography>
//         </Breadcrumbs>

//         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
//           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
//             Create Application
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Create and configure a new application for your business
//           </Typography>
//         </Box>
//       </Box>

//       {submitError && (
//         <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSubmitError('')}>
//           {submitError}
//         </Alert>
//       )}

//       {/* ---------- Wider & taller Stepper ---------- */}
//       <Paper
//         elevation={0}
//         sx={{
//           borderRadius: 3,
//           border: `1px solid ${C.border}`,
//           p: 3,
//           mb: 3,
//         }}
//       >
//         <Grid container spacing={2}>
//           {visibleSteps.map((step, index) => (
//             <Grid
//               item
//               xs
//               key={step.key}
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 1.5,
//                 borderRight: index < visibleSteps.length - 1 ? `1px solid ${C.border}` : 'none',
//                 pr: 2,
//                 mr: 2,
//                 py: 0.5,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 34,
//                   height: 34,
//                   borderRadius: '50%',
//                   flexShrink: 0,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: 700,
//                   fontSize: 16,
//                   bgcolor: index === activeStep ? C.blue : index < activeStep ? C.green : '#fff',
//                   color: index <= activeStep ? '#fff' : C.textSecondary,
//                   border: index > activeStep ? `2px solid ${C.border}` : 'none',
//                 }}
//               >
//                 {index < activeStep ? <CheckCircle sx={{ fontSize: 18 }} /> : index + 1}
//               </Box>
//               <Box sx={{ minWidth: 0 }}>
//                 <Typography
//                   variant="body1"
//                   fontWeight={700}
//                   noWrap
//                   sx={{ color: index === activeStep ? C.blue : C.textPrimary }}
//                 >
//                   {step.label}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
//                   {step.subtitle}
//                 </Typography>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Paper>

//       {/* ---------- Step content ---------- */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           alignItems: 'flex-start',
//           gap: 3,
//         }}
//       >
//         {/* LEFT — form (full width on the review step, since there is no sidebar there) */}
//         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
//           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
//             {currentStepKey === 'details' && (
//               <Step1Details
//                 values={values}
//                 handleChange={handleChange}
//                 setFieldValue={setFieldValue}
//                 errors={errors}
//                 touched={touched}
//                 businesses={businesses}
//                 isAdmin={isAdmin}
//                 fetching={fetchingBusinesses}
//               />
//             )}
//             {currentStepKey === 'domains' && (
//               <Step2Domains
//                 values={values}
//                 savingDomain={savingDomain}
//                 onSaveDomain={saveDomain}
//                 onRemoveDomain={removeDomain}
//                 onToggleDomain={toggleDomainStatus}
//                 updateDomainField={updateDomainField}
//                 addDomainRow={addDomainRow}
//                 expandedDomains={expandedDomains}
//                 setExpandedDomains={setExpandedDomains}
//                 appLogoUrl={values.appLogoUrl}
//               />
//             )}
//             {currentStepKey === 'settings' && (
//               <Step3Security
//                 values={values}
//                 handleChange={handleChange}
//                 setFieldValue={setFieldValue}
//                 errors={errors}
//                 touched={touched}
//               />
//             )}
//             {currentStepKey === 'review' && (
//               <Step4Review
//                 values={values}
//                 setActiveStep={setActiveStep}
//                 visibleSteps={visibleSteps}
//                 createdByEmail={createdByEmail}
//               />
//             )}

//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
//               <Button
//                 variant="outlined"
//                 startIcon={<ArrowBackIcon />}
//                 onClick={handleBack}
//                 disabled={activeStep === 0}
//                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
//               >
//                 Back
//               </Button>
//               {currentStepKey === 'review' ? (
//                 <Button
//                   variant="contained"
//                   onClick={handleDone}
//                   startIcon={<CheckCircle />}
//                   sx={{
//                     background: `#2563EB`,
//                     color: '#fff',
//                     px: 5,
//                     py: 1.5,
//                   }}
//                 >
//                   Create Application
//                 </Button>
//               ) : (
//                 <Button
//                   variant="contained"
//                   onClick={handleNext}
//                   disabled={isBusy}
//                   endIcon={isBusy ? <CircularProgress size={20} color="inherit" /> : <ArrowForward />}
//                   sx={{
//                     background: `#2563EB`,
//                     color: '#fff',
//                     px: 5,
//                     py: 1.5,
//                   }}
//                 >
//                   {isBusy ? 'Processing…' : 'Save & Continue'}
//                 </Button>
//               )}
//             </Box>
//           </Paper>
//         </Box>

//         {/* RIGHT — preview sidebar (hidden on review, where the form takes the full width instead) */}
//         {currentStepKey !== 'review' && (
//           <Box
//             sx={{
//               flex: '0 0 auto',
//               width: { xs: '100%', md: 600 },
//               position: { md: 'sticky' },
//               top: { md: 16 },
//             }}
//           >
//             <PreviewSidebar
//               values={values}
//               showDomains={showDomains}
//               currentStepKey={currentStepKey}
//             />
//           </Box>
//         )}
//       </Box>
//     </Container>
//   );
// };

// /* ----------------------------------------------------------------------
//    Status badge
// ---------------------------------------------------------------------- */
// const StatusBadge = ({ active }) => (
//   <Chip
//     label={active ? 'ACTIVE' : 'INACTIVE'}
//     size="small"
//     sx={{
//       fontWeight: 700,
//       fontSize: 11,
//       height: 22,
//       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
//       color: active ? C.badgeActiveText : C.badgeInactiveText,
//     }}
//   />
// );

// /* ----------------------------------------------------------------------
//    Saved / unsaved badge (used in the domains list)
// ---------------------------------------------------------------------- */
// const SaveStateBadge = ({ saved }) => (
//   <Chip
//     label={saved ? 'Saved' : 'Unsaved'}
//     size="small"
//     sx={{
//       fontWeight: 700,
//       fontSize: 11,
//       height: 22,
//       bgcolor: saved ? C.badgeActiveBg : C.amberBg,
//       color: saved ? C.badgeActiveText : C.amberText,
//     }}
//   />
// );

// /* ----------------------------------------------------------------------
//    Inline toggle row
// ---------------------------------------------------------------------- */
// const InlineToggleRow = ({ label, description, checked, onChange }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       gap: 2,
//       flexWrap: 'wrap',
//     }}
//   >
//     <Typography variant="body2" noWrap sx={{ overflow: 'visible' }}>
//       <Box component="span" fontWeight={600}>
//         {label}
//       </Box>
//       {description && (
//         <Box component="span" sx={{ color: C.textSecondary, ml: 1 }}>
//           — {description}
//         </Box>
//       )}
//     </Typography>
//     <Switch checked={checked} onChange={onChange} color="primary" />
//   </Box>
// );

// /* ----------------------------------------------------------------------
//    Step 1 — Application Details
// ---------------------------------------------------------------------- */
// const Step1Details = ({
//   values,
//   handleChange,
//   setFieldValue,
//   errors,
//   touched,
//   businesses,
//   isAdmin,
//   fetching,
// }) => {
//   const selectedBusiness = businesses.find((b) => b._id === values.businessId) || null;
//   const typeIcon =
//     values.applicationType === 'MOBILE' ? <MobileIcon fontSize="small" /> : <LanguageIcon fontSize="small" />;

//   return (
//     <Box>
//       <Typography variant="h6" fontWeight={700} gutterBottom>
//         Application Details
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         Provide basic information about your application
//       </Typography>

//       <SectionCard
//         icon={typeIcon}
//         title={values.businessName || 'New Application'}
//         badge={<StatusBadge active={values.isActive} />}
//         sx={{ mb: 0 }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//           {isAdmin && (
//             <Box>
//               <FieldLabel>Select Business *</FieldLabel>
//               <Autocomplete
//                 options={businesses}
//                 loading={fetching}
//                 value={selectedBusiness}
//                 getOptionLabel={(biz) => biz.businessName || ''}
//                 isOptionEqualToValue={(a, b) => a._id === b._id}
//                 onChange={(_, val) => setFieldValue('businessId', val ? val._id : '')}
//                 renderOption={(props, biz) => (
//                   <Box component="li" {...props} key={biz._id} sx={{ justifyContent: 'space-between !important' }}>
//                     <Box>
//                       <Typography variant="body2" fontWeight={600}>
//                         {biz.businessName}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {biz._id}
//                       </Typography>
//                     </Box>
//                     <StatusBadge active={biz.status !== false && biz.isActive !== false} />
//                   </Box>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Search and select a business"
//                     size="medium"
//                     error={touched.businessId && Boolean(errors.businessId)}
//                     helperText={touched.businessId && errors.businessId}
//                   />
//                 )}
//               />
//             </Box>
//           )}

//           <Box>
//             <FieldLabel>Business Name *</FieldLabel>
//             <TextField
//               fullWidth
//               size="medium"
//               name="businessName"
//               placeholder="Enter business name to display"
//               value={values.businessName}
//               onChange={handleChange}
//               error={touched.businessName && Boolean(errors.businessName)}
//               helperText={touched.businessName && errors.businessName}
//             />
//           </Box>

//           <Box>
//             <FieldLabel>Application Type *</FieldLabel>
//             <FormControl fullWidth size="medium" error={touched.applicationType && Boolean(errors.applicationType)}>
//               <Select
//                 name="applicationType"
//                 displayEmpty
//                 value={values.applicationType}
//                 onChange={(e) => {
//                   const type = e.target.value;
//                   setFieldValue('applicationType', type);
//                   if (type === 'MOBILE') {
//                     setFieldValue('domains', []);
//                   } else if (values.domains.length === 0) {
//                     setFieldValue('domains', [emptyDomain()]);
//                   }
//                 }}
//               >
//                 <MenuItem value="" disabled>Select application type</MenuItem>
//                 <MenuItem value="WEB">Web Application</MenuItem>
//                 <MenuItem value="MOBILE">Mobile Application</MenuItem>
//               </Select>
//               {touched.applicationType && errors.applicationType && (
//                 <FormHelperText error>{errors.applicationType}</FormHelperText>
//               )}
//             </FormControl>
//           </Box>

//           <Box>
//             <FieldLabel>Logo URL (optional)</FieldLabel>
//             <TextField
//               fullWidth
//               size="medium"
//               name="appLogoUrl"
//               placeholder="https://example.com/logo.png"
//               value={values.appLogoUrl}
//               onChange={handleChange}
//               error={touched.appLogoUrl && Boolean(errors.appLogoUrl)}
//               helperText={touched.appLogoUrl && errors.appLogoUrl}
//             />
//           </Box>

//           <Box>
//             <FieldLabel>Preview</FieldLabel>
//             <Box
//               sx={{
//                 border: `1px solid ${C.border}`,
//                 borderRadius: 2,
//                 width: 96,
//                 height: 96,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 bgcolor: C.bgLight,
//                 overflow: 'hidden',
//                 p: 1,
//               }}
//             >
//               {values.appLogoUrl ? (
//                 <Box
//                   component="img"
//                   src={values.appLogoUrl}
//                   alt="logo preview"
//                   sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
//                 />
//               ) : (
//                 <Typography variant="caption" color="text.secondary">
//                   No logo
//                 </Typography>
//               )}
//             </Box>
//           </Box>

//           <Box>
//             <FieldLabel>Description</FieldLabel>
//             <TextField
//               fullWidth
//               size="medium"
//               multiline
//               minRows={2}
//               name="description"
//               placeholder="Enter application description"
//               value={values.description}
//               onChange={handleChange}
//               error={touched.description && Boolean(errors.description)}
//               helperText={touched.description && errors.description}
//             />
//           </Box>
//         </Box>

//         <Divider sx={{ my: 2.5 }} />

//         <FormControlLabel
//           control={
//             <Switch
//               checked={values.isActive}
//               onChange={(e) => setFieldValue('isActive', e.target.checked)}
//               color="primary"
//             />
//           }
//           label={
//             <Box>
//               <Typography variant="body2" fontWeight={600}>
//                 Enable Application
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 Application will be active after creation
//               </Typography>
//             </Box>
//           }
//         />
//       </SectionCard>
//     </Box>
//   );
// };

// /* ----------------------------------------------------------------------
//    Preview sidebar (wider, tighter internal spacing)
// ---------------------------------------------------------------------- */
// const NEXT_STEP_COPY = {
//   details: 'Configure domains, URLs, and redirect settings for your application.',
//   domains: 'Set up block duration, failed-attempt limits, and other security settings.',
//   settings: 'Review everything and create your application.',
//   review: 'You’re all set — hit “Create Application” to finish up.',
// };

// const PreviewSidebar = ({ values, showDomains, currentStepKey }) => {
//   const initials = (values.businessName || 'AP').slice(0, 2).toUpperCase();
//   const logoUrl = values.appLogoUrl || null;
//   const nextStepText =
//     currentStepKey === 'details' && !showDomains
//       ? 'Configure security and access-control settings for your application.'
//       : NEXT_STEP_COPY[currentStepKey] || NEXT_STEP_COPY.details;

//   return (
//     <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
//       <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
//         Application Preview
//       </Typography>
//       <Box
//         sx={{
//           border: `1px solid ${C.border}`,
//           borderRadius: 2,
//           p: 3,
//           textAlign: 'center',
//           mb: 2.5,
//         }}
//       >
//         <Box
//           sx={{
//             width: 104,
//             height: 104,
//             borderRadius: '50%',
//             bgcolor: C.indigo,
//             color: '#fff',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             fontSize: 34,
//             fontWeight: 700,
//             mx: 'auto',
//             mb: 1.5,
//             overflow: 'hidden',
//           }}
//         >
//           {logoUrl ? (
//             <Box component="img" src={logoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//           ) : (
//             initials
//           )}
//         </Box>
//         <Typography variant="h5" fontWeight={700}>
//           {values.businessName || 'Application Name'}
//         </Typography>
//         {values.applicationType && (
//           <Chip
//             label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
//             size="medium"
//             sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
//           />
//         )}
//         <Typography variant="body2" color="text.secondary">
//           {values.businessId || 'Business Name'}
//         </Typography>
//       </Box>

//       <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
//         Overview
//       </Typography>
//       <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
//         {[
//           ['Business', values.businessId || 'Not selected'],
//           ['Type', values.applicationType === 'WEB' ? 'Web Application' : values.applicationType === 'MOBILE' ? 'Mobile Application' : '-'],
//           ['Status', values.isActive ? 'Active after creation' : 'Inactive'],
//           ['Domains', showDomains ? (values.domains?.length ? `${values.domains.length} configured` : 'Not configured') : 'N/A'],
//           ['Created', '-'],
//         ].map(([label, value]) => (
//           <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
//             <Typography variant="body2" color="text.secondary">
//               {label}
//             </Typography>
//             <Typography variant="body2" fontWeight={600}>
//               {value}
//             </Typography>
//           </Box>
//         ))}
//       </Box>

//       <Box
//         sx={{
//           mt: 2.5,
//           bgcolor: C.infoBg,
//           border: `1px solid ${C.infoBorder}`,
//           borderRadius: 2,
//           p: 2,
//           display: 'flex',
//           gap: 1.5,
//         }}
//       >
//         <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
//         <Box>
//           <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
//             {currentStepKey === 'review' ? 'Ready to Create' : 'Next Step'}
//           </Typography>
//           <Typography variant="caption" sx={{ color: C.infoText }}>
//             {nextStepText}
//           </Typography>
//         </Box>
//       </Box>
//     </Paper>
//   );
// };

// /* ----------------------------------------------------------------------
//    Step 2 — Domains & URLs
// ---------------------------------------------------------------------- */
// const Step2Domains = ({
//   values,
//   savingDomain,
//   onSaveDomain,
//   onRemoveDomain,
//   onToggleDomain,
//   updateDomainField,
//   addDomainRow,
//   expandedDomains,
//   setExpandedDomains,
//   appLogoUrl,
// }) => {
//   const domains = values.domains;

//   const toggleExpand = (index) =>
//     setExpandedDomains((prev) => ({ ...prev, [index]: !prev[index] }));

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 2 }}>
//         <Box>
//           <Typography variant="h6" fontWeight={700} gutterBottom>
//             Domains & URLs
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Add every domain that's allowed to access this application, along with where it should
//             redirect after authentication.
//           </Typography>
//         </Box>
//         <Chip
//           label={`${domains.length} ${domains.length === 1 ? 'domain' : 'domains'}`}
//           sx={{ bgcolor: C.bgLight, color: C.textPrimary, fontWeight: 700, border: `1px solid ${C.border}` }}
//         />
//       </Box>

//       {domains.map((domain, index) => {
//         const expanded = expandedDomains[index] ?? true;
//         const domainLogoSource = domain.logoUrl || appLogoUrl || null;

//         return (
//           <Box
//             key={domain._tempId || index}
//             sx={{
//               border: `1px solid ${domain.saved ? C.border : C.amber}44`,
//               borderRadius: 2,
//               mb: 2,
//               overflow: 'hidden',
//               transition: 'border-color 0.15s ease',
//             }}
//           >
//             {/* Card header */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 px: 2.5,
//                 py: 1.5,
//                 bgcolor: '#fafbfc',
//                 cursor: 'pointer',
//               }}
//               onClick={() => toggleExpand(index)}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
//                 <Avatar
//                   variant="rounded"
//                   sx={{
//                     width: 36,
//                     height: 36,
//                     bgcolor: domain.domain ? C.indigo : C.bgLight,
//                     color: domain.domain ? '#fff' : C.textSecondary,
//                     border: domain.domain ? 'none' : `1px dashed ${C.border}`,
//                   }}
//                 >
//                   <LanguageIcon fontSize="small" />
//                 </Avatar>
//                 <Box sx={{ minWidth: 0 }}>
//                   <Typography variant="body1" fontWeight={700} noWrap>
//                     {domain.domain || 'New Domain'}
//                   </Typography>
//                   {!expanded && (
//                     <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
//                       {domain.redirectUrl && getPath(domain.redirectUrl)
//                         ? domain.redirectUrl
//                         : 'No redirect URL set'}
//                     </Typography>
//                   )}
//                 </Box>
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={(e) => e.stopPropagation()}>
//                 <StatusBadge active={domain.status} />
//                 <SaveStateBadge saved={domain.saved} />
//                 <Button
//                   size="small"
//                   onClick={() => onRemoveDomain(index)}
//                   disabled={savingDomain}
//                   sx={{ color: '#e53e3e', minWidth: 'auto' }}
//                 >
//                   Remove
//                 </Button>
//                 <IconButton size="small" onClick={() => toggleExpand(index)}>
//                   {expanded ? <ExpandLess /> : <ExpandMore />}
//                 </IconButton>
//               </Box>
//             </Box>

//             {expanded && (
//               <Box sx={{ p: 2.5 }}>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//                       Domain *
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       placeholder="example.com"
//                       value={domain.domain}
//                       onChange={(e) => updateDomainField(index, 'domain', e.target.value)}
//                       size="medium"
//                     />
//                   </Box>

//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//                       Display Name *
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       placeholder="Marketing Site"
//                       value={domain.displayName}
//                       onChange={(e) => updateDomainField(index, 'displayName', e.target.value)}
//                       size="medium"
//                     />
//                   </Box>

//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//                       Redirect URL *
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       value={getPath(domain.redirectUrl)}
//                       onChange={(e) =>
//                         updateDomainField(
//                           index,
//                           'redirectUrl',
//                           `${getProtocol(domain.redirectUrl)}://${e.target.value}`
//                         )
//                       }
//                       size="medium"
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <Select
//                               variant="standard"
//                               disableUnderline
//                               value={getProtocol(domain.redirectUrl)}
//                               onChange={(e) =>
//                                 updateDomainField(
//                                   index,
//                                   'redirectUrl',
//                                   `${e.target.value}://${getPath(domain.redirectUrl)}`
//                                 )
//                               }
//                               sx={{ mr: 1 }}
//                             >
//                               <MenuItem value="https">https</MenuItem>
//                               <MenuItem value="http">http</MenuItem>
//                             </Select>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </Box>

//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//                       Logo URL (optional)
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       placeholder="https://example.com/domain-logo.png"
//                       value={domain.logoUrl}
//                       onChange={(e) => updateDomainField(index, 'logoUrl', e.target.value)}
//                       size="medium"
//                       helperText="Overrides the application logo for this domain, if provided."
//                     />
//                   </Box>

//                   <Box>
//                     <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//                       Preview
//                     </Typography>
//                     <Box
//                       sx={{
//                         border: `1px solid ${C.border}`,
//                         borderRadius: 2,
//                         width: 96,
//                         height: 96,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         bgcolor: C.bgLight,
//                         overflow: 'hidden',
//                         p: 1,
//                       }}
//                     >
//                       {domainLogoSource ? (
//                         <Box
//                           component="img"
//                           src={domainLogoSource}
//                           alt="logo preview"
//                           sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
//                         />
//                       ) : (
//                         <Typography variant="caption" color="text.secondary">
//                           No logo
//                         </Typography>
//                       )}
//                     </Box>
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 2.5 }} />

//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
//                   <FormControlLabel
//                     control={<Switch checked={domain.status} onChange={() => onToggleDomain(index)} />}
//                     label={domain.status ? 'Active' : 'Inactive'}
//                   />
//                   {!domain.saved ? (
//                     <Button
//                       size="medium"
//                       variant="contained"
//                       onClick={() => onSaveDomain(index)}
//                       disabled={savingDomain}
//                       sx={{ background: C.blue, px: 4 }}
//                     >
//                       {savingDomain ? <CircularProgress size={20} color="inherit" /> : 'Save Domain'}
//                     </Button>
//                   ) : (
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: C.badgeActiveText }}>
//                       <CheckCircle fontSize="small" />
//                       <Typography variant="body2" fontWeight={600}>
//                         Saved — edit any field to make changes
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>
//               </Box>
//             )}
//           </Box>
//         );
//       })}

//       {/* Single, clear entry point for adding another domain */}
//       <Box
//         onClick={addDomainRow}
//         sx={{
//           border: `1.5px dashed ${C.border}`,
//           borderRadius: 2,
//           py: 2,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           gap: 1,
//           cursor: 'pointer',
//           color: C.blue,
//           transition: 'background-color 0.15s ease, border-color 0.15s ease',
//           '&:hover': { bgcolor: C.infoBg, borderColor: C.blue },
//         }}
//       >
//         <AddIcon fontSize="small" />
//         <Typography variant="body2" fontWeight={700}>
//           Add another domain
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// /* ----------------------------------------------------------------------
//    Step 3 — Security & Settings
// ---------------------------------------------------------------------- */
// const Step3Security = ({ values, handleChange, setFieldValue, errors, touched }) => (
//   <Box>
//     <Typography variant="h6" fontWeight={700} gutterBottom>
//       Security & Settings
//     </Typography>
//     <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//       Configure security options and additional settings for this application.
//     </Typography>

//     <SectionCard icon={<LockIcon fontSize="small" />} title="Security Settings">
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//         <Box>
//           <FieldLabel>Block Duration *</FieldLabel>
//           <FormControl fullWidth size="medium" error={touched.blockDuration && Boolean(errors.blockDuration)}>
//             <Select name="blockDuration" value={values.blockDuration} onChange={handleChange}>
//               {BLOCK_DURATION_OPTIONS.map((v) => (
//                 <MenuItem key={v} value={v}>
//                   {v} minutes
//                 </MenuItem>
//               ))}
//             </Select>
//             {touched.blockDuration && errors.blockDuration ? (
//               <FormHelperText error>{errors.blockDuration}</FormHelperText>
//             ) : (
//               <FormHelperText>Duration for blocking after suspicious activity.</FormHelperText>
//             )}
//           </FormControl>
//         </Box>

//         <Box>
//           <FieldLabel>Failed Attempts *</FieldLabel>
//           <FormControl fullWidth size="medium" error={touched.failedAttempts && Boolean(errors.failedAttempts)}>
//             <Select name="failedAttempts" value={values.failedAttempts} onChange={handleChange}>
//               {FAILED_ATTEMPTS_OPTIONS.map((v) => (
//                 <MenuItem key={v} value={v}>
//                   {v} attempts
//                 </MenuItem>
//               ))}
//             </Select>
//             {touched.failedAttempts && errors.failedAttempts ? (
//               <FormHelperText error>{errors.failedAttempts}</FormHelperText>
//             ) : (
//               <FormHelperText>Failed attempts before blocking.</FormHelperText>
//             )}
//           </FormControl>
//         </Box>
//       </Box>

//       <Divider sx={{ my: 2.5 }} />

//       <FormControlLabel
//         control={
//           <Switch
//             checked={values.ipGeolocationEnabled}
//             onChange={(e) => setFieldValue('ipGeolocationEnabled', e.target.checked)}
//             color="primary"
//           />
//         }
//         label={
//           <Box>
//             <Typography variant="body2" fontWeight={600}>
//               IP Allowlisting
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Restrict access to specific IP addresses
//             </Typography>
//           </Box>
//         }
//       />
//     </SectionCard>

//     <SectionCard icon={<SettingsIcon fontSize="small" />} title="Advanced Settings">
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//         <Box>
//           <FieldLabel>Webhook URL</FieldLabel>
//           <TextField
//             fullWidth
//             size="medium"
//             name="webhookUrl"
//             placeholder="https://example.com/webhook/auth-events"
//             value={values.webhookUrl}
//             onChange={handleChange}
//             error={touched.webhookUrl && Boolean(errors.webhookUrl)}
//             helperText={
//               (touched.webhookUrl && errors.webhookUrl) || 'Receive real-time notifications and events.'
//             }
//           />
//         </Box>

//         <Box>
//           <FieldLabel>Metadata (JSON)</FieldLabel>
//           <TextField
//             fullWidth
//             size="medium"
//             multiline
//             minRows={3}
//             name="metadataJson"
//             value={values.metadataJson}
//             onChange={handleChange}
//             error={Boolean(errors.metadataJson)}
//             helperText={errors.metadataJson}
//             InputProps={{
//               sx: {
//                 fontFamily: 'Menlo, Consolas, monospace',
//                 fontSize: 13,
//                 bgcolor: '#f7fafc',
//               },
//             }}
//           />
//         </Box>
//       </Box>
//     </SectionCard>

//     <SectionCard
//       icon={<PersonOutlineIcon fontSize="small" />}
//       title="Application Status"
//       badge={<StatusBadge active={values.isActive} />}
//       sx={{ mb: 0 }}
//     >
//       <FormControlLabel
//         control={
//           <Switch
//             checked={values.isActive}
//             onChange={(e) => setFieldValue('isActive', e.target.checked)}
//             color="primary"
//           />
//         }
//         label={
//           <Box>
//             <Typography variant="body2" fontWeight={600}>
//               Enable Application
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Application will be active after creation
//             </Typography>
//           </Box>
//         }
//       />
//     </SectionCard>
//   </Box>
// );

// /* ----------------------------------------------------------------------
//    Step 4 — Review & Create
//    No API call — the app, its domains, and its settings were already
//    created step-by-step. This is purely a read-only confirmation screen.
// ---------------------------------------------------------------------- */
// const SummarySection = ({ title, onEdit, children, sx }) => (
//   <Paper variant="outlined" sx={{ p: 2.5, borderColor: C.border, borderRadius: 2, height: '100%', ...sx }}>
//     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
//       <Typography variant="subtitle1" fontWeight={700}>
//         {title}
//       </Typography>
//       {onEdit && (
//         <Button size="small" startIcon={<EditOutlined fontSize="small" />} onClick={onEdit} sx={{ color: C.blue }}>
//           Edit
//         </Button>
//       )}
//     </Box>
//     {children}
//   </Paper>
// );

// const StatTile = ({ icon, label, value }) => (
//   <Paper
//     variant="outlined"
//     sx={{
//       p: 2,
//       borderColor: C.border,
//       borderRadius: 2,
//       display: 'flex',
//       alignItems: 'center',
//       gap: 1.5,
//       height: '100%',
//     }}
//   >
//     <Box
//       sx={{
//         width: 40,
//         height: 40,
//         borderRadius: 2,
//         bgcolor: C.infoBg,
//         color: C.infoText,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         flexShrink: 0,
//       }}
//     >
//       {icon}
//     </Box>
//     <Box sx={{ minWidth: 0 }}>
//       <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
//         {label}
//       </Typography>
//       <Typography variant="body1" fontWeight={700} noWrap>
//         {value}
//       </Typography>
//     </Box>
//   </Paper>
// );

// const Step4Review = ({ values, setActiveStep, visibleSteps, createdByEmail }) => {
//   const showDomains = values.applicationType === 'WEB';
//   const stepIndex = (key) => visibleSteps.findIndex((s) => s.key === key);
//   const metadataCount = (() => {
//     try {
//       return Object.keys(JSON.parse(values.metadataJson || '{}')).length;
//     } catch {
//       return 0;
//     }
//   })();

//   const detailRow = (label, value) => (
//     <Grid item xs={12} sm={6} key={label}>
//       <Typography variant="body2" color="text.secondary">
//         {label}
//       </Typography>
//       <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
//         {value}
//       </Typography>
//     </Grid>
//   );

//   return (
//     <Box>
//       <Typography variant="h6" fontWeight={700} gutterBottom>
//         Review & Create
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         Confirm all details before creating the application.
//       </Typography>

//       {/* Hero summary */}
//       <Paper
//         variant="outlined"
//         sx={{
//           p: 3,
//           mb: 3,
//           borderColor: C.border,
//           borderRadius: 3,
//           bgcolor: C.bgLight,
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
//           <Box
//             sx={{
//               width: 64,
//               height: 64,
//               borderRadius: '50%',
//               bgcolor: C.indigo,
//               color: '#fff',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: 24,
//               fontWeight: 700,
//               flexShrink: 0,
//               overflow: 'hidden',
//             }}
//           >
//             {values.appLogoUrl ? (
//               <Box component="img" src={values.appLogoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//             ) : (
//               (values.businessName || 'AP').slice(0, 2).toUpperCase()
//             )}
//           </Box>
//           <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
//             <Typography variant="h5" fontWeight={800} noWrap>
//               {values.businessName || 'Application'}
//             </Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
//               <Chip
//                 label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
//                 size="small"
//                 sx={{ bgcolor: '#fff', color: C.textPrimary, fontWeight: 600, border: `1px solid ${C.border}` }}
//               />
//               <StatusBadge active={values.isActive} />
//             </Box>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: C.textSecondary }}>
//             <PersonOutlineIcon fontSize="small" />
//             <Box>
//               <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
//                 Created by
//               </Typography>
//               <Typography variant="body2" fontWeight={700}>
//                 {createdByEmail}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>
//       </Paper>

//       {/* At-a-glance stat tiles */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={6} md={3}>
//           <StatTile
//             icon={<PublicIcon fontSize="small" />}
//             label="Domains"
//             value={showDomains ? values.domains.length : 'N/A'}
//           />
//         </Grid>
//         <Grid item xs={6} md={3}>
//           <StatTile
//             icon={<AccessTimeIcon fontSize="small" />}
//             label="Block Duration"
//             value={`${values.blockDuration} min`}
//           />
//         </Grid>
//         <Grid item xs={6} md={3}>
//           <StatTile
//             icon={<LockIcon fontSize="small" />}
//             label="Failed Attempts"
//             value={`${values.failedAttempts}`}
//           />
//         </Grid>
//         <Grid item xs={6} md={3}>
//           <StatTile
//             icon={<VerifiedUserIcon fontSize="small" />}
//             label="IP Allowlisting"
//             value={values.ipGeolocationEnabled ? 'Enabled' : 'Disabled'}
//           />
//         </Grid>
//       </Grid>

//       {/* Two-up detail sections */}
//       <Grid container spacing={3} sx={{ mb: showDomains ? 3 : 0 }}>
//         <Grid item xs={12} md={6}>
//           <SummarySection title="Application Details" onEdit={() => setActiveStep(stepIndex('details'))}>
//             <Grid container spacing={2}>
//               {detailRow('Application Name', values.businessName)}
//               {detailRow('Application Type', values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application')}
//               {detailRow('Business', values.businessId || 'N/A')}
//               {detailRow('Description', values.description || 'Not provided')}
//             </Grid>
//           </SummarySection>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <SummarySection title="Security & Settings" onEdit={() => setActiveStep(stepIndex('settings'))}>
//             <Grid container spacing={2}>
//               {detailRow('Block Duration', `${values.blockDuration} minutes`)}
//               {detailRow('Failed Attempts Before Block', `${values.failedAttempts} attempts`)}
//               {detailRow('IP Allowlisting', values.ipGeolocationEnabled ? 'Enabled' : 'Disabled')}
//               {detailRow('Webhook URL', values.webhookUrl || 'Not configured')}
//               {detailRow('Metadata', metadataCount > 0 ? `${metadataCount} keys configured` : 'None')}
//             </Grid>
//           </SummarySection>
//         </Grid>
//       </Grid>

//       {showDomains && (
//         <SummarySection title="Domains & URLs" onEdit={() => setActiveStep(stepIndex('domains'))}>
//           <TableContainer>
//             <Table size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Domain</TableCell>
//                   <TableCell>Display Name</TableCell>
//                   <TableCell>Redirect URL</TableCell>
//                   <TableCell>Logo</TableCell>
//                   <TableCell>Status</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {values.domains.map((d, idx) => (
//                   <TableRow key={idx}>
//                     <TableCell>{d.domain}</TableCell>
//                     <TableCell>{d.displayName || '-'}</TableCell>
//                     <TableCell>{d.redirectUrl}</TableCell>
//                     <TableCell>{d.logoUrl ? '✓' : '-'}</TableCell>
//                     <TableCell>
//                       <StatusBadge active={d.status} />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </SummarySection>
//       )}
//     </Box>
//   );
// };

// export default CreateApplicationPage;



import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Switch,
  Radio,
  RadioGroup,
  IconButton,
  Alert,
  CircularProgress,
  Paper,
  Grid,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Breadcrumbs,
  Link as MuiLink,
  Chip,
  InputAdornment,
  FormHelperText,
  Avatar,
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  ArrowForward,
  ArrowBack as ArrowBackIcon,
  CheckCircle,
  Language as LanguageIcon,
  ExpandMore,
  ExpandLess,
  CloudUpload,
  InfoOutlined,
  EditOutlined,
  AccessTime as AccessTimeIcon,
  Lock as LockIcon,
  Public as PublicIcon,
  VerifiedUser as VerifiedUserIcon,
  PersonOutline as PersonOutlineIcon,
  PhoneIphone as MobileIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

import { adminService } from '../services/admin';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../utils/constants';

/* ----------------------------------------------------------------------
   Real APIs are wired in. If you ever need to go back to mocks for local
   UI work, reintroduce a USE_MOCK flag + mock service — removed here
   since we're now calling the real backend everywhere.
---------------------------------------------------------------------- */

/* ----------------------------------------------------------------------
   Design tokens
---------------------------------------------------------------------- */
const C = {
  border: '#e2e8f0',
  blue: '#3182ce',
  blueDark: '#2b6cb0',
  green: '#38a169',
  greenDark: '#276749',
  indigo: '#4c51bf',
  amber: '#dd6b20',
  amberBg: '#feebc8',
  amberText: '#9c4221',
  textPrimary: '#1a202c',
  textSecondary: '#718096',
  bgLight: '#f7fafc',
  badgeActiveBg: '#c6f6d5',
  badgeActiveText: '#276749',
  badgeInactiveBg: '#e2e8f0',
  badgeInactiveText: '#4a5568',
  infoBg: '#ebf8ff',
  infoBorder: '#bee3f8',
  infoText: '#2c5282',
};

/* ----------------------------------------------------------------------
   Validation schemas
---------------------------------------------------------------------- */
const detailsSchema = Yup.object({
  businessId: Yup.string().required('Business is required'),
  applicationType: Yup.string()
    .oneOf(['WEB', 'MOBILE'])
    .required('Application type is required'),
  businessName: Yup.string().required('Display name is required').max(100),
  description: Yup.string().max(500),
  isActive: Yup.boolean(),
  appLogoUrl: Yup.string().url('Invalid URL').nullable(),
});

const settingsSchema = Yup.object({
  blockDuration: Yup.number()
    .min(1, 'Min 1 minute')
    .max(1440, 'Max 1440 minutes')
    .required('Required'),
  failedAttempts: Yup.number()
    .min(1, 'Min 1')
    .max(99, 'Max 99')
    .required('Required'),
  ipGeolocationEnabled: Yup.boolean(),
  webhookUrl: Yup.string().url('Invalid URL').nullable(),
  metadataJson: Yup.string()
    .required('Metadata is empty. This field is required.')
    .test('not-blank', 'Metadata is empty. This field is required.', (val) => !!val && val.trim().length > 0)
    .test('is-json', 'Metadata must be valid JSON', (val) => {
      if (!val || !val.trim()) return true;
      try {
        JSON.parse(val);
        return true;
      } catch {
        return false;
      }
    })
    .test('non-empty-object', 'Metadata is empty. Provide at least one key.', (val) => {
      if (!val || !val.trim()) return true;
      try {
        const o = JSON.parse(val);
        return !(o && typeof o === 'object' && !Array.isArray(o) && Object.keys(o).length === 0);
      } catch {
        return true;
      }
    }),
});

/* Step definitions. The "domains" step is filtered out entirely for
   MOBILE applications. */
const ALL_STEPS = [
  { key: 'details', label: 'Application Details', subtitle: 'Basic information' },
  { key: 'domains', label: 'Domains & URLs', subtitle: 'Configure domains and URLs' },
  { key: 'settings', label: 'Security & Settings', subtitle: 'Security and access control' },
  { key: 'review', label: 'Review & Create', subtitle: 'Review and create application' },
];

const BLOCK_DURATION_OPTIONS = [5, 15, 30, 60, 120, 240, 1440];
const FAILED_ATTEMPTS_OPTIONS = [3, 5, 10, 15, 20, 25];

const emptyDomain = () => ({
  id: null,
  // The real API has no domain-id — a domain is addressed by its
  // domainName in the URL (PUT/DELETE .../domains/:domainName/:appId).
  // We track the name it was LAST SAVED under separately from the
  // (possibly edited, not-yet-saved) `domain` field below.
  savedDomainName: null,
  domain: '',
  displayName: '',
  redirectUrl: 'https://',
  status: true,
  saved: false,
  logoUrl: '', // only URL, no radio selection
  _tempId: Date.now() + Math.random(),
});

const getProtocol = (url = '') => (url.startsWith('http://') ? 'http' : 'https');
const getPath = (url = '') => url.replace(/^https?:\/\//, '');

/* ----------------------------------------------------------------------
   Section Card – the shared "domain card" visual language: a bordered,
   rounded container with a light-grey header (icon avatar + title +
   optional badge/action) and top-labelled fields in the body. Reused
   across every step so the whole wizard reads as one consistent system.
---------------------------------------------------------------------- */
const SectionCard = ({ icon, title, badge, action, children, sx }) => (
  <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2.5,
        py: 1.5,
        bgcolor: '#fafbfc',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        {icon && (
          <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
            {icon}
          </Avatar>
        )}
        <Typography variant="body1" fontWeight={700} noWrap>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {badge}
        {action}
      </Box>
    </Box>
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Box>
);

/* Field label used above every input inside a SectionCard, matching the
   domain fields' top-label style. */
const FieldLabel = ({ children }) => (
  <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
    {children}
  </Typography>
);

/* ----------------------------------------------------------------------
   Main Component
---------------------------------------------------------------------- */
const CreateApplicationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, businessId: userBusinessId, user, email: authEmail } = useAuth();

  // Resolve the signed-in admin's email defensively, since the exact shape
  // of the auth context can vary (user.email, top-level email, username, etc).
  const createdByEmail =
    user?.email || authEmail || user?.username || user?.name || 'Unknown user';

  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [fetchingBusinesses, setFetchingBusinesses] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [appId, setAppId] = useState(null);
  const [savingDomain, setSavingDomain] = useState(false);
  const [savingSettings, setSavingSettings] = useState(false);
  // Tracks whether settings have already been POSTed for this app, so a
  // second save on Step 3 (e.g. user goes Back and edits again) calls the
  // update (PUT) endpoint instead of trying to create them again.
  const [settingsSaved, setSettingsSaved] = useState(false);
  const [expandedDomains, setExpandedDomains] = useState({ 0: true });

  const preselectedBusinessId = new URLSearchParams(location.search).get('businessId');

  const formik = useFormik({
    initialValues: {
      businessId: preselectedBusinessId || (isAdmin ? '' : userBusinessId || ''),
      applicationType: 'WEB', // default to WEB
      description: '',
      businessName: '',
      isActive: true,
      domains: [emptyDomain()],
      blockDuration: 30,
      failedAttempts: 5,
      ipGeolocationEnabled: false,
      webhookUrl: '',
      metadataJson: '{\n  "placeholder": true\n}',
      appLogoUrl: '',
    },
    validateOnChange: true,
  });

  const { values, handleChange, setFieldValue, errors, touched } = formik;

  // Fetch businesses if admin
  useEffect(() => {
    if (isAdmin) {
      setFetchingBusinesses(true);
      adminService
        .getAllBusinesses(0, 100)
        .then((data) => {
          let list = [];
          if (Array.isArray(data)) list = data;
          else if (data.businesses && Array.isArray(data.businesses)) list = data.businesses;
          else if (data.data && Array.isArray(data.data)) list = data.data;
          setBusinesses(list);
        })
        .catch(() => {})
        .finally(() => setFetchingBusinesses(false));
    }
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin && userBusinessId) {
      setFieldValue('businessId', userBusinessId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, userBusinessId]);

  const showDomains = values.applicationType === 'WEB';

  const visibleSteps = ALL_STEPS.filter((s) => s.key !== 'domains' || showDomains);
  const currentStepKey = visibleSteps[activeStep]?.key;

  const goNextIndex = () => setActiveStep((i) => Math.min(i + 1, visibleSteps.length - 1));
  const goPrevIndex = () => setActiveStep((i) => Math.max(i - 1, 0));

  /* ---------------- API calls ---------------- */

  // STEP 1, first time only → POST /api/business-apps
  // { businessId, appName, appDescription, appType }  (appType is lowercase
  // on the backend: "web" / "mobile" — the form itself keeps 'WEB'/'MOBILE'
  // uppercase for the UI, so it's lowercased only in the outgoing payload.)
  //
  // STEP 1, on every later visit (user hit Back then Next again) → PUT
  // /api/business-apps/:appId instead, so we don't POST a duplicate app.
  //
  // The response shape from the create endpoint hasn't been confirmed yet —
  // the extraction below tries the common shapes. If appId ends up null,
  // open devtools, check the network response for this call, and adjust
  // the `newAppId = ...` line to match the actual key.
  const createApplication = async () => {
    try {
      await detailsSchema.validate(values, { abortEarly: false });
    } catch (err) {
      err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
      setSubmitError('Please fill in all required fields.');
      return;
    }
    setLoading(true);
    setSubmitError('');
    try {
      if (appId) {
        // Already created earlier in this session — just sync any edits.
        await adminService.updateBusinessApp(appId, {
          appName: values.businessName,
          appDescription: values.description,
        });
        goNextIndex();
        return;
      }

      const payload = {
        businessId: values.businessId,
        appName: values.businessName,
        appDescription: values.description,
        appType: values.applicationType.toLowerCase(), // 'web' | 'mobile'
      };
      const response = await adminService.createBusinessApp(payload);

      // TODO: confirm the real key once you've seen a live response.
      const newAppId =
        response?.appId ||
        response?.id ||
        response?._id ||
        response?.data?.appId ||
        response?.data?.id ||
        response?.data?._id;

      if (!newAppId) {
        console.warn('createBusinessApp response did not contain a recognizable app id:', response);
        throw new Error('App ID not returned');
      }

      setAppId(newAppId);

      // appLogoUrl / isActive aren't in the create payload above (not in
      // the documented create endpoint). If the backend supports setting
      // them on create, add them to `payload`; otherwise they can be sent
      // via updateBusinessApp (PUT /api/business-apps/:id) here instead:
      if (values.appLogoUrl || values.isActive === false) {
        try {
          await adminService.updateBusinessApp(newAppId, {
            appName: values.businessName,
            appDescription: values.description,
          });
        } catch {
          // non-fatal — app was still created
        }
      }

      goNextIndex();
    } catch (err) {
      setSubmitError(err.message || 'Failed to create application');
    } finally {
      setLoading(false);
    }
  };

  // STEP 3 → first save: POST /api/business-apps/settings/:appId
  //          later saves: PUT  /api/business-apps/settings/:appId
  // Body uses blockDuration as a STRING ("30 minutes") and
  // failedAttemptsBeforeBlock (not failedAttempts).
  const saveSettings = async () => {
    try {
      await settingsSchema.validate(values, { abortEarly: false });
    } catch (err) {
      err.inner.forEach((e) => formik.setFieldTouched(e.path, true));
      setSubmitError(err.errors?.[0] || 'Please fill in all required settings.');
      return;
    }
    if (!appId) {
      setSubmitError('Application not created yet.');
      return;
    }
    setSavingSettings(true);
    setSubmitError('');
    try {
      let metadataObj = {};
      if (values.metadataJson && values.metadataJson.trim()) {
        metadataObj = JSON.parse(values.metadataJson);
      }
      const settingsPayload = {
        blockDuration: `${values.blockDuration} minutes`,
        failedAttemptsBeforeBlock: values.failedAttempts,
        webhookUrl: values.webhookUrl || undefined,
        metadata: metadataObj,
        enabled: values.isActive,
      };

      if (settingsSaved) {
        await adminService.updateAppSettings(appId, settingsPayload);
      } else {
        await adminService.addAppSettings(appId, settingsPayload);
        setSettingsSaved(true);
      }

      goNextIndex();
    } catch (err) {
      setSubmitError(err.message || 'Failed to save settings');
    } finally {
      setSavingSettings(false);
    }
  };

  /* ---------------- Domain handlers ---------------- */
  const addDomainRow = () => {
    const next = [...values.domains, emptyDomain()];
    setFieldValue('domains', next);
    setExpandedDomains((prev) => ({ ...prev, [next.length - 1]: true }));
  };

  const updateDomainField = (index, field, value) => {
    const updated = values.domains.map((d, i) =>
      i === index ? { ...d, [field]: value, saved: field === 'status' ? d.saved : false } : d
    );
    setFieldValue('domains', updated);
  };

  // POST /api/business-apps/domains/:appId            (first save)
  // PUT  /api/business-apps/domains/:domainName/:appId (re-save — keyed by
  //       the name it was PREVIOUSLY saved under, since there's no domain id)
  const saveDomain = async (index) => {
    const domain = values.domains[index];
    if (!domain.domain.trim() || !getPath(domain.redirectUrl).trim()) {
      setSubmitError('Domain and Redirect URL are required.');
      return;
    }
    if (!appId) {
      setSubmitError('Application not created yet.');
      return;
    }
    setSavingDomain(true);
    setSubmitError('');
    try {
      const payload = {
        domainName: domain.domain,
        displayName: domain.displayName,
        redirectUrl: domain.redirectUrl,
        logoUrl: domain.logoUrl || undefined,
        enabled: domain.status,
      };

      if (domain.saved && domain.savedDomainName) {
        await adminService.updateAppDomain(domain.savedDomainName, appId, payload);
      } else {
        await adminService.addAppDomain(appId, payload);
      }

      const updated = values.domains.map((d, i) =>
        i === index ? { ...d, id: true, savedDomainName: domain.domain, saved: true } : d
      );
      setFieldValue('domains', updated);
      setExpandedDomains((prev) => ({ ...prev, [index]: false }));
    } catch (err) {
      setSubmitError(err.message || 'Failed to save domain');
    } finally {
      setSavingDomain(false);
    }
  };

  // DELETE /api/business-apps/domains/:domainName/:appId
  const removeDomain = async (index) => {
    const domain = values.domains[index];
    if (domain.saved && domain.savedDomainName && appId) {
      setSavingDomain(true);
      try {
        await adminService.deleteAppDomain(domain.savedDomainName, appId);
      } catch (err) {
        setSubmitError(err.message || 'Failed to delete domain');
        setSavingDomain(false);
        return;
      }
    }
    const updated = values.domains.filter((_, i) => i !== index);
    setFieldValue('domains', updated.length ? updated : [emptyDomain()]);
    setSavingDomain(false);
  };

  // Reuses the same PUT .../domains/:domainName/:appId endpoint, sending
  // only the enabled flag. Confirm the backend accepts a partial body here —
  // if it requires the full domain object, swap this for a full payload.
  const toggleDomainStatus = async (index) => {
    const domain = values.domains[index];
    updateDomainField(index, 'status', !domain.status);

    if (domain.saved && domain.savedDomainName && appId) {
      setSavingDomain(true);
      try {
        await adminService.updateAppDomain(domain.savedDomainName, appId, {
          enabled: !domain.status,
        });
      } catch (err) {
        setSubmitError(err.message || 'Failed to toggle domain status');
        updateDomainField(index, 'status', domain.status);
      } finally {
        setSavingDomain(false);
      }
    }
  };

  const handleNext = async () => {
    if (currentStepKey === 'details') {
      await createApplication();
    } else if (currentStepKey === 'domains') {
      const unsaved = values.domains.filter((d) => !d.saved && d.domain.trim());
      if (unsaved.length > 0) {
        setSubmitError('Please save all domains before proceeding.');
        return;
      }
      goNextIndex();
    } else if (currentStepKey === 'settings') {
      await saveSettings();
    } else {
      goNextIndex();
    }
  };

  const handleBack = () => goPrevIndex();

  // Review & Create step performs no API call of its own — the app,
  // domains, and settings were already created step-by-step. This just
  // navigates away.
  const handleDone = () => {
    navigate(isAdmin ? '/admin/businesses' : '/business/applications');
  };

  const isBusy = loading || savingSettings || savingDomain;

  /* ---------------- Render ---------------- */
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
          <MuiLink underline="hover" color="text.secondary" href="#" onClick={(e) => e.preventDefault()}>
            Applications
          </MuiLink>
          <Typography color="text.primary" fontSize={13} fontWeight={600}>
            Create Application
          </Typography>
        </Breadcrumbs>

        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
          <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
            Create Application
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Create and configure a new application for your business
          </Typography>
        </Box>
      </Box>

      {submitError && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSubmitError('')}>
          {submitError}
        </Alert>
      )}

      {/* ---------- Wider & taller Stepper ---------- */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: `1px solid ${C.border}`,
          p: 3,
          mb: 3,
        }}
      >
        <Grid container spacing={2}>
          {visibleSteps.map((step, index) => (
            <Grid
              item
              xs
              key={step.key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderRight: index < visibleSteps.length - 1 ? `1px solid ${C.border}` : 'none',
                pr: 2,
                mr: 2,
                py: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: '50%',
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  fontSize: 16,
                  bgcolor: index === activeStep ? C.blue : index < activeStep ? C.green : '#fff',
                  color: index <= activeStep ? '#fff' : C.textSecondary,
                  border: index > activeStep ? `2px solid ${C.border}` : 'none',
                }}
              >
                {index < activeStep ? <CheckCircle sx={{ fontSize: 18 }} /> : index + 1}
              </Box>
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="body1"
                  fontWeight={700}
                  noWrap
                  sx={{ color: index === activeStep ? C.blue : C.textPrimary }}
                >
                  {step.label}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                  {step.subtitle}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* ---------- Step content ---------- */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'flex-start',
          gap: 3,
        }}
      >
        {/* LEFT — form (full width on the review step, since there is no sidebar there) */}
        <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
          <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
            {currentStepKey === 'details' && (
              <Step1Details
                values={values}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
                businesses={businesses}
                isAdmin={isAdmin}
                fetching={fetchingBusinesses}
              />
            )}
            {currentStepKey === 'domains' && (
              <Step2Domains
                values={values}
                savingDomain={savingDomain}
                onSaveDomain={saveDomain}
                onRemoveDomain={removeDomain}
                onToggleDomain={toggleDomainStatus}
                updateDomainField={updateDomainField}
                addDomainRow={addDomainRow}
                expandedDomains={expandedDomains}
                setExpandedDomains={setExpandedDomains}
                appLogoUrl={values.appLogoUrl}
              />
            )}
            {currentStepKey === 'settings' && (
              <Step3Security
                values={values}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                errors={errors}
                touched={touched}
              />
            )}
            {currentStepKey === 'review' && (
              <Step4Review
                values={values}
                setActiveStep={setActiveStep}
                visibleSteps={visibleSteps}
                createdByEmail={createdByEmail}
              />
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleBack}
                disabled={activeStep === 0}
                sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
              >
                Back
              </Button>
              {currentStepKey === 'review' ? (
                <Button
                  variant="contained"
                  onClick={handleDone}
                  startIcon={<CheckCircle />}
                  sx={{
                    background: `#2563EB`,
                    color: '#fff',
                    px: 5,
                    py: 1.5,
                  }}
                >
                  Create Application
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  disabled={isBusy}
                  endIcon={isBusy ? <CircularProgress size={20} color="inherit" /> : <ArrowForward />}
                  sx={{
                    background: `#2563EB`,
                    color: '#fff',
                    px: 5,
                    py: 1.5,
                  }}
                >
                  {isBusy ? 'Processing…' : 'Save & Continue'}
                </Button>
              )}
            </Box>
          </Paper>
        </Box>

        {/* RIGHT — preview sidebar (hidden on review, where the form takes the full width instead) */}
        {currentStepKey !== 'review' && (
          <Box
            sx={{
              flex: '0 0 auto',
              width: { xs: '100%', md: 600 },
              position: { md: 'sticky' },
              top: { md: 16 },
            }}
          >
            <PreviewSidebar
              values={values}
              showDomains={showDomains}
              currentStepKey={currentStepKey}
            />
          </Box>
        )}
      </Box>
    </Container>
  );
};

/* ----------------------------------------------------------------------
   Status badge
---------------------------------------------------------------------- */
const StatusBadge = ({ active }) => (
  <Chip
    label={active ? 'ACTIVE' : 'INACTIVE'}
    size="small"
    sx={{
      fontWeight: 700,
      fontSize: 11,
      height: 22,
      bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
      color: active ? C.badgeActiveText : C.badgeInactiveText,
    }}
  />
);

/* ----------------------------------------------------------------------
   Saved / unsaved badge (used in the domains list)
---------------------------------------------------------------------- */
const SaveStateBadge = ({ saved }) => (
  <Chip
    label={saved ? 'Saved' : 'Unsaved'}
    size="small"
    sx={{
      fontWeight: 700,
      fontSize: 11,
      height: 22,
      bgcolor: saved ? C.badgeActiveBg : C.amberBg,
      color: saved ? C.badgeActiveText : C.amberText,
    }}
  />
);

/* ----------------------------------------------------------------------
   Inline toggle row
---------------------------------------------------------------------- */
const InlineToggleRow = ({ label, description, checked, onChange }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      flexWrap: 'wrap',
    }}
  >
    <Typography variant="body2" noWrap sx={{ overflow: 'visible' }}>
      <Box component="span" fontWeight={600}>
        {label}
      </Box>
      {description && (
        <Box component="span" sx={{ color: C.textSecondary, ml: 1 }}>
          — {description}
        </Box>
      )}
    </Typography>
    <Switch checked={checked} onChange={onChange} color="primary" />
  </Box>
);

/* ----------------------------------------------------------------------
   Step 1 — Application Details
---------------------------------------------------------------------- */
const Step1Details = ({
  values,
  handleChange,
  setFieldValue,
  errors,
  touched,
  businesses,
  isAdmin,
  fetching,
}) => {
  const selectedBusiness = businesses.find((b) => b._id === values.businessId) || null;
  const typeIcon =
    values.applicationType === 'MOBILE' ? <MobileIcon fontSize="small" /> : <LanguageIcon fontSize="small" />;

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Application Details
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Provide basic information about your application
      </Typography>

      <SectionCard
        icon={typeIcon}
        title={values.businessName || 'New Application'}
        badge={<StatusBadge active={values.isActive} />}
        sx={{ mb: 0 }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          {isAdmin && (
            <Box>
              <FieldLabel>Select Business *</FieldLabel>
              <Autocomplete
                options={businesses}
                loading={fetching}
                value={selectedBusiness}
                getOptionLabel={(biz) => biz.businessName || ''}
                isOptionEqualToValue={(a, b) => a._id === b._id}
                onChange={(_, val) => setFieldValue('businessId', val ? val._id : '')}
                renderOption={(props, biz) => (
                  <Box component="li" {...props} key={biz._id} sx={{ justifyContent: 'space-between !important' }}>
                    <Box>
                      <Typography variant="body2" fontWeight={600}>
                        {biz.businessName}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {biz._id}
                      </Typography>
                    </Box>
                    <StatusBadge active={biz.status !== false && biz.isActive !== false} />
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select a business"
                    size="medium"
                    error={touched.businessId && Boolean(errors.businessId)}
                    helperText={touched.businessId && errors.businessId}
                  />
                )}
              />
            </Box>
          )}

            <Box>
                <FieldLabel>Business Name *</FieldLabel>
                <TextField
                fullWidth
                size="medium"
                name="businessName"
                placeholder="Enter business name to display"
                value={values.businessName}
                onChange={handleChange}
                error={touched.businessName && Boolean(errors.businessName)}
                helperText={touched.businessName && errors.businessName}
                />
            </Box>

          <Box>
            <FieldLabel>Application Type *</FieldLabel>
            <FormControl fullWidth size="medium" error={touched.applicationType && Boolean(errors.applicationType)}>
              <Select
                name="applicationType"
                displayEmpty
                value={values.applicationType}
                onChange={(e) => {
                  const type = e.target.value;
                  setFieldValue('applicationType', type);
                  if (type === 'MOBILE') {
                    setFieldValue('domains', []);
                  } else if (values.domains.length === 0) {
                    setFieldValue('domains', [emptyDomain()]);
                  }
                }}
              >
                <MenuItem value="" disabled>Select application type</MenuItem>
                <MenuItem value="WEB">Web Application</MenuItem>
                <MenuItem value="MOBILE">Mobile Application</MenuItem>
              </Select>
              {touched.applicationType && errors.applicationType && (
                <FormHelperText error>{errors.applicationType}</FormHelperText>
              )}
            </FormControl>
          </Box>

          <Box>
            <FieldLabel>Logo URL (optional)</FieldLabel>
            <TextField
              fullWidth
              size="medium"
              name="appLogoUrl"
              placeholder="https://example.com/logo.png"
              value={values.appLogoUrl}
              onChange={handleChange}
              error={touched.appLogoUrl && Boolean(errors.appLogoUrl)}
              helperText={touched.appLogoUrl && errors.appLogoUrl}
            />
          </Box>

          <Box>
            <FieldLabel>Preview</FieldLabel>
            <Box
              sx={{
                border: `1px solid ${C.border}`,
                borderRadius: 2,
                width: 96,
                height: 96,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: C.bgLight,
                overflow: 'hidden',
                p: 1,
              }}
            >
              {values.appLogoUrl ? (
                <Box
                  component="img"
                  src={values.appLogoUrl}
                  alt="logo preview"
                  sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                />
              ) : (
                <Typography variant="caption" color="text.secondary">
                  No logo
                </Typography>
              )}
            </Box>
          </Box>

          <Box>
            <FieldLabel>Description</FieldLabel>
            <TextField
              fullWidth
              size="medium"
              multiline
              minRows={2}
              name="description"
              placeholder="Enter application description"
              value={values.description}
              onChange={handleChange}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
            />
          </Box>
        </Box>

        <Divider sx={{ my: 2.5 }} />

        <FormControlLabel
          control={
            <Switch
              checked={values.isActive}
              onChange={(e) => setFieldValue('isActive', e.target.checked)}
              color="primary"
            />
          }
          label={
            <Box>
              <Typography variant="body2" fontWeight={600}>
                Enable Application
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Application will be active after creation
              </Typography>
            </Box>
          }
        />
      </SectionCard>
    </Box>
  );
};

/* ----------------------------------------------------------------------
   Preview sidebar (wider, tighter internal spacing)
---------------------------------------------------------------------- */
const NEXT_STEP_COPY = {
  details: 'Configure domains, URLs, and redirect settings for your application.',
  domains: 'Set up block duration, failed-attempt limits, and other security settings.',
  settings: 'Review everything and create your application.',
  review: 'You’re all set — hit “Create Application” to finish up.',
};

const PreviewSidebar = ({ values, showDomains, currentStepKey }) => {
  const initials = (values.businessName || 'AP').slice(0, 2).toUpperCase();
  const logoUrl = values.appLogoUrl || null;
  const nextStepText =
    currentStepKey === 'details' && !showDomains
      ? 'Configure security and access-control settings for your application.'
      : NEXT_STEP_COPY[currentStepKey] || NEXT_STEP_COPY.details;

  return (
    <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
        Application Preview
      </Typography>
      <Box
        sx={{
          border: `1px solid ${C.border}`,
          borderRadius: 2,
          p: 3,
          textAlign: 'center',
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            width: 104,
            height: 104,
            borderRadius: '50%',
            bgcolor: C.indigo,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 34,
            fontWeight: 700,
            mx: 'auto',
            mb: 1.5,
            overflow: 'hidden',
          }}
        >
          {logoUrl ? (
            <Box component="img" src={logoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            initials
          )}
        </Box>
        <Typography variant="h5" fontWeight={700}>
          {values.businessName || 'Application Name'}
        </Typography>
        {values.applicationType && (
          <Chip
            label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
            size="medium"
            sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
          />
        )}
        <Typography variant="body2" color="text.secondary">
          {values.businessId || 'Business Name'}
        </Typography>
      </Box>

      <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
        Overview
      </Typography>
      <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
        {[
          ['Business', values.businessId || 'Not selected'],
          ['Type', values.applicationType === 'WEB' ? 'Web Application' : values.applicationType === 'MOBILE' ? 'Mobile Application' : '-'],
          ['Status', values.isActive ? 'Active after creation' : 'Inactive'],
          ['Domains', showDomains ? (values.domains?.length ? `${values.domains.length} configured` : 'Not configured') : 'N/A'],
          ['Created', '-'],
        ].map(([label, value]) => (
          <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {value}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          mt: 2.5,
          bgcolor: C.infoBg,
          border: `1px solid ${C.infoBorder}`,
          borderRadius: 2,
          p: 2,
          display: 'flex',
          gap: 1.5,
        }}
      >
        <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
        <Box>
          <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
            {currentStepKey === 'review' ? 'Ready to Create' : 'Next Step'}
          </Typography>
          <Typography variant="caption" sx={{ color: C.infoText }}>
            {nextStepText}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

/* ----------------------------------------------------------------------
   Step 2 — Domains & URLs
---------------------------------------------------------------------- */
const Step2Domains = ({
  values,
  savingDomain,
  onSaveDomain,
  onRemoveDomain,
  onToggleDomain,
  updateDomainField,
  addDomainRow,
  expandedDomains,
  setExpandedDomains,
  appLogoUrl,
}) => {
  const domains = values.domains;

  const toggleExpand = (index) =>
    setExpandedDomains((prev) => ({ ...prev, [index]: !prev[index] }));

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Domains & URLs
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Add every domain that's allowed to access this application, along with where it should
            redirect after authentication.
          </Typography>
        </Box>
        <Chip
          label={`${domains.length} ${domains.length === 1 ? 'domain' : 'domains'}`}
          sx={{ bgcolor: C.bgLight, color: C.textPrimary, fontWeight: 700, border: `1px solid ${C.border}` }}
        />
      </Box>

      {domains.map((domain, index) => {
        const expanded = expandedDomains[index] ?? true;
        const domainLogoSource = domain.logoUrl || appLogoUrl || null;

        return (
          <Box
            key={domain._tempId || index}
            sx={{
              border: `1px solid ${domain.saved ? C.border : C.amber}44`,
              borderRadius: 2,
              mb: 2,
              overflow: 'hidden',
              transition: 'border-color 0.15s ease',
            }}
          >
            {/* Card header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2.5,
                py: 1.5,
                bgcolor: '#fafbfc',
                cursor: 'pointer',
              }}
              onClick={() => toggleExpand(index)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                <Avatar
                  variant="rounded"
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: domain.domain ? C.indigo : C.bgLight,
                    color: domain.domain ? '#fff' : C.textSecondary,
                    border: domain.domain ? 'none' : `1px dashed ${C.border}`,
                  }}
                >
                  <LanguageIcon fontSize="small" />
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant="body1" fontWeight={700} noWrap>
                    {domain.domain || 'New Domain'}
                  </Typography>
                  {!expanded && (
                    <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                      {domain.redirectUrl && getPath(domain.redirectUrl)
                        ? domain.redirectUrl
                        : 'No redirect URL set'}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={(e) => e.stopPropagation()}>
                <StatusBadge active={domain.status} />
                <SaveStateBadge saved={domain.saved} />
                <Button
                  size="small"
                  onClick={() => onRemoveDomain(index)}
                  disabled={savingDomain}
                  sx={{ color: '#e53e3e', minWidth: 'auto' }}
                >
                  Remove
                </Button>
                <IconButton size="small" onClick={() => toggleExpand(index)}>
                  {expanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
            </Box>

            {expanded && (
              <Box sx={{ p: 2.5 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  <Box>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                      Domain *
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="example.com"
                      value={domain.domain}
                      onChange={(e) => updateDomainField(index, 'domain', e.target.value)}
                      size="medium"
                    />
                  </Box>

                  <Box>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                      Display Name *
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Marketing Site"
                      value={domain.displayName}
                      onChange={(e) => updateDomainField(index, 'displayName', e.target.value)}
                      size="medium"
                    />
                  </Box>

                  <Box>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                      Redirect URL *
                    </Typography>
                    <TextField
                      fullWidth
                      value={getPath(domain.redirectUrl)}
                      onChange={(e) =>
                        updateDomainField(
                          index,
                          'redirectUrl',
                          `${getProtocol(domain.redirectUrl)}://${e.target.value}`
                        )
                      }
                      size="medium"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Select
                              variant="standard"
                              disableUnderline
                              value={getProtocol(domain.redirectUrl)}
                              onChange={(e) =>
                                updateDomainField(
                                  index,
                                  'redirectUrl',
                                  `${e.target.value}://${getPath(domain.redirectUrl)}`
                                )
                              }
                              sx={{ mr: 1 }}
                            >
                              <MenuItem value="https">https</MenuItem>
                              <MenuItem value="http">http</MenuItem>
                            </Select>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                      Logo URL (optional)
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="https://example.com/domain-logo.png"
                      value={domain.logoUrl}
                      onChange={(e) => updateDomainField(index, 'logoUrl', e.target.value)}
                      size="medium"
                      helperText="Overrides the application logo for this domain, if provided."
                    />
                  </Box>

                  <Box>
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                      Preview
                    </Typography>
                    <Box
                      sx={{
                        border: `1px solid ${C.border}`,
                        borderRadius: 2,
                        width: 96,
                        height: 96,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: C.bgLight,
                        overflow: 'hidden',
                        p: 1,
                      }}
                    >
                      {domainLogoSource ? (
                        <Box
                          component="img"
                          src={domainLogoSource}
                          alt="logo preview"
                          sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                      ) : (
                        <Typography variant="caption" color="text.secondary">
                          No logo
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Divider sx={{ my: 2.5 }} />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
                  <FormControlLabel
                    control={<Switch checked={domain.status} onChange={() => onToggleDomain(index)} />}
                    label={domain.status ? 'Active' : 'Inactive'}
                  />
                  {!domain.saved ? (
                    <Button
                      size="medium"
                      variant="contained"
                      onClick={() => onSaveDomain(index)}
                      disabled={savingDomain}
                      sx={{ background: C.blue, px: 4 }}
                    >
                      {savingDomain ? <CircularProgress size={20} color="inherit" /> : 'Save Domain'}
                    </Button>
                  ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: C.badgeActiveText }}>
                      <CheckCircle fontSize="small" />
                      <Typography variant="body2" fontWeight={600}>
                        Saved — edit any field to make changes
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        );
      })}

      {/* Single, clear entry point for adding another domain */}
      <Box
        onClick={addDomainRow}
        sx={{
          border: `1.5px dashed ${C.border}`,
          borderRadius: 2,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          cursor: 'pointer',
          color: C.blue,
          transition: 'background-color 0.15s ease, border-color 0.15s ease',
          '&:hover': { bgcolor: C.infoBg, borderColor: C.blue },
        }}
      >
        <AddIcon fontSize="small" />
        <Typography variant="body2" fontWeight={700}>
          Add another domain
        </Typography>
      </Box>
    </Box>
  );
};

/* ----------------------------------------------------------------------
   Step 3 — Security & Settings
---------------------------------------------------------------------- */
const Step3Security = ({ values, handleChange, setFieldValue, errors, touched }) => (
  <Box>
    <Typography variant="h6" fontWeight={700} gutterBottom>
      Security & Settings
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Configure security options and additional settings for this application.
    </Typography>

    <SectionCard icon={<LockIcon fontSize="small" />} title="Security Settings">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Box>
          <FieldLabel>Block Duration *</FieldLabel>
          <FormControl fullWidth size="medium" error={touched.blockDuration && Boolean(errors.blockDuration)}>
            <Select name="blockDuration" value={values.blockDuration} onChange={handleChange}>
              {BLOCK_DURATION_OPTIONS.map((v) => (
                <MenuItem key={v} value={v}>
                  {v} minutes
                </MenuItem>
              ))}
            </Select>
            {touched.blockDuration && errors.blockDuration ? (
              <FormHelperText error>{errors.blockDuration}</FormHelperText>
            ) : (
              <FormHelperText>Duration for blocking after suspicious activity.</FormHelperText>
            )}
          </FormControl>
        </Box>

        <Box>
          <FieldLabel>Failed Attempts *</FieldLabel>
          <FormControl fullWidth size="medium" error={touched.failedAttempts && Boolean(errors.failedAttempts)}>
            <Select name="failedAttempts" value={values.failedAttempts} onChange={handleChange}>
              {FAILED_ATTEMPTS_OPTIONS.map((v) => (
                <MenuItem key={v} value={v}>
                  {v} attempts
                </MenuItem>
              ))}
            </Select>
            {touched.failedAttempts && errors.failedAttempts ? (
              <FormHelperText error>{errors.failedAttempts}</FormHelperText>
            ) : (
              <FormHelperText>Failed attempts before blocking.</FormHelperText>
            )}
          </FormControl>
        </Box>
      </Box>

      <Divider sx={{ my: 2.5 }} />

      <FormControlLabel
        control={
          <Switch
            checked={values.ipGeolocationEnabled}
            onChange={(e) => setFieldValue('ipGeolocationEnabled', e.target.checked)}
            color="primary"
          />
        }
        label={
          <Box>
            <Typography variant="body2" fontWeight={600}>
              IP Allowlisting
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Restrict access to specific IP addresses
            </Typography>
          </Box>
        }
      />
    </SectionCard>

    <SectionCard icon={<SettingsIcon fontSize="small" />} title="Advanced Settings">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Box>
          <FieldLabel>Webhook URL</FieldLabel>
          <TextField
            fullWidth
            size="medium"
            name="webhookUrl"
            placeholder="https://example.com/webhook/auth-events"
            value={values.webhookUrl}
            onChange={handleChange}
            error={touched.webhookUrl && Boolean(errors.webhookUrl)}
            helperText={
              (touched.webhookUrl && errors.webhookUrl) || 'Receive real-time notifications and events.'
            }
          />
        </Box>

        <Box>
          <FieldLabel>Metadata (JSON)</FieldLabel>
          <TextField
            fullWidth
            size="medium"
            multiline
            minRows={3}
            name="metadataJson"
            value={values.metadataJson}
            onChange={handleChange}
            placeholder={'{\n  "publicKey": "./keys/merchant_public.pem"\n}'}
            error={Boolean(errors.metadataJson)}
            helperText={errors.metadataJson}
            InputProps={{
              sx: {
                fontFamily: 'Menlo, Consolas, monospace',
                fontSize: 13,
                bgcolor: '#f7fafc',
              },
            }}
          />
        </Box>
      </Box>
    </SectionCard>

    <SectionCard
      icon={<PersonOutlineIcon fontSize="small" />}
      title="Application Status"
      badge={<StatusBadge active={values.isActive} />}
      sx={{ mb: 0 }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={values.isActive}
            onChange={(e) => setFieldValue('isActive', e.target.checked)}
            color="primary"
          />
        }
        label={
          <Box>
            <Typography variant="body2" fontWeight={600}>
              Enable Application
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Application will be active after creation
            </Typography>
          </Box>
        }
      />
    </SectionCard>
  </Box>
);

/* ----------------------------------------------------------------------
   Step 4 — Review & Create
   No API call — the app, its domains, and its settings were already
   created step-by-step. This is purely a read-only confirmation screen.
---------------------------------------------------------------------- */
const SummarySection = ({ title, onEdit, children, sx }) => (
  <Paper variant="outlined" sx={{ p: 2.5, borderColor: C.border, borderRadius: 2, height: '100%', ...sx }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
      <Typography variant="subtitle1" fontWeight={700}>
        {title}
      </Typography>
      {onEdit && (
        <Button size="small" startIcon={<EditOutlined fontSize="small" />} onClick={onEdit} sx={{ color: C.blue }}>
          Edit
        </Button>
      )}
    </Box>
    {children}
  </Paper>
);

const StatTile = ({ icon, label, value }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 2,
      borderColor: C.border,
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      height: '100%',
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: 2,
        bgcolor: C.infoBg,
        color: C.infoText,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
        {label}
      </Typography>
      <Typography variant="body1" fontWeight={700} noWrap>
        {value}
      </Typography>
    </Box>
  </Paper>
);

const Step4Review = ({ values, setActiveStep, visibleSteps, createdByEmail }) => {
  const showDomains = values.applicationType === 'WEB';
  const stepIndex = (key) => visibleSteps.findIndex((s) => s.key === key);
  const metadataCount = (() => {
    try {
      return Object.keys(JSON.parse(values.metadataJson || '{}')).length;
    } catch {
      return 0;
    }
  })();

  const detailRow = (label, value) => (
    <Grid item xs={12} sm={6} key={label}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
        {value}
      </Typography>
    </Grid>
  );

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Review & Create
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Confirm all details before creating the application.
      </Typography>

      {/* Hero summary */}
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          mb: 3,
          borderColor: C.border,
          borderRadius: 3,
          bgcolor: C.bgLight,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: C.indigo,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              fontWeight: 700,
              flexShrink: 0,
              overflow: 'hidden',
            }}
          >
            {values.appLogoUrl ? (
              <Box component="img" src={values.appLogoUrl} alt="logo" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              (values.businessName || 'AP').slice(0, 2).toUpperCase()
            )}
          </Box>
          <Box sx={{ flex: '1 1 240px', minWidth: 0 }}>
            <Typography variant="h5" fontWeight={800} noWrap>
              {values.businessName || 'Application'}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
              <Chip
                label={values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application'}
                size="small"
                sx={{ bgcolor: '#fff', color: C.textPrimary, fontWeight: 600, border: `1px solid ${C.border}` }}
              />
              <StatusBadge active={values.isActive} />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: C.textSecondary }}>
            <PersonOutlineIcon fontSize="small" />
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                Created by
              </Typography>
              <Typography variant="body2" fontWeight={700}>
                {createdByEmail}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* At-a-glance stat tiles */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} md={3}>
          <StatTile
            icon={<PublicIcon fontSize="small" />}
            label="Domains"
            value={showDomains ? values.domains.length : 'N/A'}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatTile
            icon={<AccessTimeIcon fontSize="small" />}
            label="Block Duration"
            value={`${values.blockDuration} min`}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatTile
            icon={<LockIcon fontSize="small" />}
            label="Failed Attempts"
            value={`${values.failedAttempts}`}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <StatTile
            icon={<VerifiedUserIcon fontSize="small" />}
            label="IP Allowlisting"
            value={values.ipGeolocationEnabled ? 'Enabled' : 'Disabled'}
          />
        </Grid>
      </Grid>

      {/* Two-up detail sections */}
      <Grid container spacing={3} sx={{ mb: showDomains ? 3 : 0 }}>
        <Grid item xs={12} md={6}>
          <SummarySection title="Application Details" onEdit={() => setActiveStep(stepIndex('details'))}>
            <Grid container spacing={2}>
              {detailRow('Application Name', values.businessName)}
              {detailRow('Application Type', values.applicationType === 'WEB' ? 'Web Application' : 'Mobile Application')}
              {detailRow('Business', values.businessId || 'N/A')}
              {detailRow('Description', values.description || 'Not provided')}
            </Grid>
          </SummarySection>
        </Grid>

        <Grid item xs={12} md={6}>
          <SummarySection title="Security & Settings" onEdit={() => setActiveStep(stepIndex('settings'))}>
            <Grid container spacing={2}>
              {detailRow('Block Duration', `${values.blockDuration} minutes`)}
              {detailRow('Failed Attempts Before Block', `${values.failedAttempts} attempts`)}
              {detailRow('IP Allowlisting', values.ipGeolocationEnabled ? 'Enabled' : 'Disabled')}
              {detailRow('Webhook URL', values.webhookUrl || 'Not configured')}
              {detailRow('Metadata', metadataCount > 0 ? `${metadataCount} keys configured` : 'None')}
            </Grid>
          </SummarySection>
        </Grid>
      </Grid>

      {showDomains && (
        <SummarySection title="Domains & URLs" onEdit={() => setActiveStep(stepIndex('domains'))}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Domain</TableCell>
                  <TableCell>Display Name</TableCell>
                  <TableCell>Redirect URL</TableCell>
                  <TableCell>Logo</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.domains.map((d, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{d.domain}</TableCell>
                    <TableCell>{d.displayName || '-'}</TableCell>
                    <TableCell>{d.redirectUrl}</TableCell>
                    <TableCell>{d.logoUrl ? '✓' : '-'}</TableCell>
                    <TableCell>
                      <StatusBadge active={d.status} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SummarySection>
      )}
    </Box>
  );
};

export default CreateApplicationPage;